import { useState, useEffect, useRef } from "react";
import { createClient } from '@supabase/supabase-js';

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_KEY
);


const _ShopNotify = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  if (sent) return <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: "#B8A48C", textAlign: "center", margin: "0 0 24px", fontStyle: "italic" }}>✦ You're on the list. We'll find you when it's time.</p>;
  return (
    <div style={{ display: "flex", gap: 8, marginBottom: 24 }}>
      <input value={email} onChange={e => setEmail(e.target.value)} placeholder="Your email address" style={{ flex: 1, background: "#FAF7F2", border: "1px solid #D6C9B6", borderRadius: 2, padding: "11px 14px", fontFamily: "'Jost', sans-serif", fontSize: 12, fontWeight: 300, color: "#1C1610", outline: "none" }} />
      <button onClick={() => { if (email.includes("@")) { setSent(true); subscribeToKlaviyo(email); } }} style={{ background: "#1C1610", color: "#FAF7F2", border: "none", borderRadius: 2, padding: "11px 16px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.12em", textTransform: "uppercase", cursor: "pointer", whiteSpace: "nowrap" }}>Notify Me</button>
          <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 11, color: T.inkGhost, textAlign: "center", lineHeight: 1.8, margin: "16px 0 0" }}>
            By signing up you agree to our{' '}
            <span onClick={() => {}} style={{ textDecoration: "underline", cursor: "pointer", color: T.inkSoft }}>Terms of Service</span>
            {' '}and{' '}
            <span onClick={() => {}} style={{ textDecoration: "underline", cursor: "pointer", color: T.inkSoft }}>Privacy Policy</span>.
          </p>
          <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 11, color: T.inkGhost, textAlign: "center", lineHeight: 1.8, margin: "16px 0 0" }}>
            By signing up you agree to our{' '}
            <span onClick={() => {}} style={{ textDecoration: "underline", cursor: "pointer", color: T.inkSoft }}>Terms of Service</span>
            {' '}and{' '}
            <span onClick={() => {}} style={{ textDecoration: "underline", cursor: "pointer", color: T.inkSoft }}>Privacy Policy</span>.
          </p>
    </div>
  );
};



const subscribeToKlaviyo = async (email, firstName = '') => {
  try {
    await fetch('/api/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, firstName })
    });
  } catch(e) {
    console.log('Klaviyo error:', e);
  }
};

const T = {
  ivory: "#FAF7F2", sand: "#EDE5D8", sandMid: "#D6C9B6", sandDark: "#B8A48C",
  blush: "#C9A98A", ink: "#1C1610", inkMid: "#3D3228", inkSoft: "#5F5242", inkGhost: "#6B5D4D",
};

const FontLoader = () => {
  useEffect(() => {
    const link = document.createElement("link");
    link.href = "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400;1,600&family=Jost:wght@300;400;500&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }, []);
  return null;
};

const Serif = ({ children, style, italic, size = 22, weight = 300, color = T.ink }) => (
  <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: size, fontWeight: weight, fontStyle: italic ? "italic" : "normal", color, lineHeight: 1.35, ...style }}>{children}</span>
);
const Label = ({ children, style }) => (
  <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.18em", textTransform: "uppercase", color: T.inkGhost, fontWeight: 400, margin: 0, ...style }}>{children}</p>
);
const Divider = ({ style }) => <div style={{ height: 1, background: T.sand, margin: "20px 0", ...style }} />;
const FadeIn = ({ children, delay = 0, style }) => {
  const [visible, setVisible] = useState(false);
  useEffect(() => { const t = setTimeout(() => setVisible(true), delay); return () => clearTimeout(t); }, [delay]);
  return <div style={{ opacity: visible ? 1 : 0, transform: visible ? "translateY(0)" : "translateY(12px)", transition: "opacity 0.7s ease, transform 0.7s ease", ...style }}>{children}</div>;
};
// eslint-disable-next-line no-unused-vars
const Input = ({ placeholder, value, onChange, style }) => (
  <input value={value} onChange={onChange} placeholder={placeholder}
    style={{ width: "100%", background: T.sand, border: `1px solid ${T.sandMid}`, borderRadius: 2, padding: "12px 16px", fontFamily: "'Jost', sans-serif", fontSize: 13, fontWeight: 300, color: T.ink, outline: "none", boxSizing: "border-box", ...style }}
    onFocus={e => e.target.style.borderColor = T.blush} onBlur={e => e.target.style.borderColor = T.sandMid} />
);
const Btn = ({ children, onClick, ghost, style }) => (
  <button onClick={onClick} style={{ width: "100%", background: ghost ? "none" : T.ink, color: ghost ? T.inkSoft : T.ivory, border: ghost ? `1px solid ${T.sandMid}` : "none", borderRadius: 2, padding: "14px", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.16em", textTransform: "uppercase", cursor: "pointer", ...style }}>{children}</button>
);

const Nav = ({ screen, setScreen }) => {
  const [showMore, setShowMore] = useState(false);

  const t = TRANSLATIONS.en;
  const mainTabs = [
    { id: "home", label: t.sanctuary },
    { id: "journal", label: t.reframe },
    { id: "ritual", label: t.stillness },
    { id: "library", label: t.strength },
    { id: "more", label: t.more },
  ];

  const moreTabs = [
    { id: "shop", label: t.collection },
    { id: "community", label: t.community },
    { id: "detente", label: t.detente },
    { id: "lumiere", label: t.lumiere },
    { id: "settings", label: t.settings },
    { id: "scripture", label: t.word },
    { id: "wall3am", label: "3am Wall" },
    { id: "letter", label: "Unsent Letter" },
    { id: "grief", label: "Grief Mode" },
    { id: "sanctuary2", label: "Sanctuary for Two" },
  ];

  const isMore = moreTabs.some(t => t.id === screen);

  return (
    <>
      {showMore && (
        <div onClick={() => setShowMore(false)} style={{ position: "fixed", inset: 0, background: "rgba(28,22,16,0.5)", zIndex: 90 }}>
          <div onClick={e => e.stopPropagation()} style={{ position: "absolute", bottom: 60, left: 0, right: 0, maxWidth: 430, margin: "0 auto", background: T.ivory, borderTop: "1px solid " + T.sand, padding: "16px 20px 8px" }}>
            <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.16em", textTransform: "uppercase", color: T.inkGhost, margin: "0 0 12px" }}>More</p>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8 }}>
              {moreTabs.map(t => (
                <button key={t.id} onClick={() => { setScreen(t.id); setShowMore(false); }}
                  style={{ background: screen === t.id ? T.ink : T.sand, border: "none", borderRadius: 2, padding: "14px 8px", cursor: "pointer", textAlign: "center" }}>
                  <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: screen === t.id ? T.ivory : T.inkMid }}>{t.label}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
      <div style={{ position: "fixed", bottom: 0, left: 0, right: 0, background: T.ivory, borderTop: "1px solid " + T.sand, display: "flex", zIndex: 100, maxWidth: 430, margin: "0 auto" }}>
        {mainTabs.map(t => {
          const active = t.id === "more" ? isMore || showMore : screen === t.id;
          return (
            <button key={t.id} onClick={() => t.id === "more" ? setShowMore(!showMore) : (setScreen(t.id), setShowMore(false))}
              style={{ flex: 1, padding: "10px 1px 12px", background: "none", border: "none", cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", gap: 3 }}>
              <div style={{ width: 20, height: 2, background: active ? T.ink : "transparent", borderRadius: 1, transition: "background 0.3s" }} />
              <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.08em", textTransform: "uppercase", color: active ? T.ink : T.inkGhost, fontWeight: active ? 500 : 300 }}>{t.label}</span>
            </button>
          );
        })}
      </div>
    </>
  );
};
const WeightCheck = ({ onComplete, userMood }) => {
  const [sliderValue, setSliderValue] = useState(50);
  const [phase, setPhase] = useState("slider"); // slider | ritual | done
  const [breathPhase, setBreathPhase] = useState("ready");
  const [candleTime, setCandleTime] = useState(60);
// eslint-disable-next-line no-unused-vars
  const [candleActive, setCandleActive] = useState(false);

  const weight = sliderValue < 33 ? "light" : sliderValue < 66 ? "medium" : "heavy";

  const getRitual = () => {
    if (weight === "light") return { label: "A moment of gratitude", type: "scripture" };
    if (weight === "medium") return { label: "Breathe it through", type: "breathe" };
    return { label: "Hold it in the light", type: "candle" };
  };

  const getScripture = () => 'Cast all your anxiety on him because he cares for you. — 1 Peter 5:7';

  const handleRelease = () => {
    const today = new Date().toDateString();
    localStorage.setItem('pr_weight_check', JSON.stringify({ date: today, weight, slider: sliderValue }));
    setPhase("ritual");
    if (getRitual().type === "breathe") startBreath();
    if (getRitual().type === "candle") startCandle();
  };

  const startBreath = () => {
    setBreathPhase("in");
    const cycle = (p) => {
      if (p === "in") setTimeout(() => { setBreathPhase("hold"); cycle("hold"); }, 4000);
      else if (p === "hold") setTimeout(() => { setBreathPhase("out"); cycle("out"); }, 4000);
      else setTimeout(() => { setBreathPhase("done"); }, 8000);
    };
    cycle("in");
  };

  const startCandle = () => {
    setCandleActive(true);
    let t = 60;
    const timer = setInterval(() => { t--; setCandleTime(t); if (t <= 0) clearInterval(timer); }, 1000);
  };

  const trackColor = weight === "light" ? T.sandDark : weight === "medium" ? "#8B6914" : T.ink;

  if (phase === "done") return (
    <div style={{ background: T.sand, borderRadius: 2, padding: "24px 20px", marginBottom: 20, textAlign: "center", border: "1px solid " + T.sandMid }}>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 18, fontStyle: "italic", color: T.inkMid, lineHeight: 1.7, margin: 0 }}>
        Named. Released. ✦
      </p>
    </div>
  );

  if (phase === "ritual") {
    const ritual = getRitual();
    return (
      <div style={{ background: T.sand, borderRadius: 2, padding: "24px 20px", marginBottom: 20, border: "1px solid " + T.sandMid }}>
        <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkGhost, letterSpacing: "0.14em", marginBottom: 16, textAlign: "center" }}>
          {weight === "light" ? "YOU'RE CARRYING SOMETHING LIGHT TODAY" : weight === "medium" ? "LET'S BREATHE THROUGH THIS" : "YOU'RE CARRYING SOMETHING HEAVY"}
        </p>

        {ritual.type === "scripture" && (
          <div style={{ textAlign: "center" }}>
            <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 18, fontStyle: "italic", color: T.inkMid, lineHeight: 1.8, marginBottom: 24 }}>{getScripture()}</p>
            <button onClick={() => { setPhase("done"); setTimeout(onComplete, 2000); }}
              style={{ background: T.ink, color: T.ivory, border: "none", borderRadius: 2, padding: "12px 28px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.14em", cursor: "pointer" }}>
              Received ✦
            </button>
          </div>
        )}

        {ritual.type === "breathe" && (
          <div style={{ textAlign: "center" }}>
            <style>{`
              @keyframes wcBreatheIn { from { transform: scale(0.7); opacity: 0.4; } to { transform: scale(1.5); opacity: 1; } }
              @keyframes wcBreatheHold { from { transform: scale(1.5); } to { transform: scale(1.5); } }
              @keyframes wcBreatheOut { from { transform: scale(1.5); opacity: 1; } to { transform: scale(0.7); opacity: 0.3; } }
              @keyframes wcBreatheReady { from { transform: scale(1); opacity: 0.6; } to { transform: scale(1.1); opacity: 0.9; } }
            `}</style>
            <div style={{ position: "relative", width: 120, height: 120, margin: "0 auto 20px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <div style={{ position: "absolute", width: "100%", height: "100%", borderRadius: "50%", background: "radial-gradient(circle, #8B691425 0%, transparent 70%)",
                animation: breathPhase === "in" ? "wcBreatheIn 4s ease-in-out forwards" : breathPhase === "hold" ? "wcBreatheHold 4s linear forwards" : breathPhase === "out" ? "wcBreatheOut 8s ease-in-out forwards" : "wcBreatheReady 2s ease-in-out infinite alternate" }} />
              <img src="/pure-reve-icon.svg" style={{ width: 52, height: 52, position: "relative", zIndex: 1,
                animation: breathPhase === "in" ? "wcBreatheIn 4s ease-in-out forwards" : breathPhase === "hold" ? "wcBreatheHold 4s linear forwards" : breathPhase === "out" ? "wcBreatheOut 8s ease-in-out forwards" : "wcBreatheReady 2s ease-in-out infinite alternate" }} alt="Pure Reve" />
            </div>
            <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontStyle: "italic", color: T.inkMid, marginBottom: 8 }}>
              {breathPhase === "in" ? "Breathe in..." : breathPhase === "hold" ? "Hold..." : breathPhase === "out" ? "Breathe out..." : breathPhase === "done" ? "You released it. ✦" : "Breathe with this..."}
            </p>
            {breathPhase === "done" && (
              <button onClick={() => { setPhase("done"); setTimeout(onComplete, 2000); }}
                style={{ background: T.ink, color: T.ivory, border: "none", borderRadius: 2, padding: "12px 28px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.14em", cursor: "pointer", marginTop: 16 }}>
                Released ✦
              </button>
            )}
          </div>
        )}

        {ritual.type === "candle" && (
          <div style={{ textAlign: "center" }}>
            <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 48, marginBottom: 8 }}>🕯</p>
            <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 18, fontStyle: "italic", color: T.inkMid, lineHeight: 1.7, marginBottom: 8 }}>
              Hold this. Just hold it.<br/>You don't have to fix it right now.
            </p>
            <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkGhost, marginBottom: 16 }}>
              {candleTime > 0 ? candleTime + "s" : "✦"}
            </p>
            {candleTime <= 0 && (
              <button onClick={() => { setPhase("done"); setTimeout(onComplete, 2000); }}
                style={{ background: T.ink, color: T.ivory, border: "none", borderRadius: 2, padding: "12px 28px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.14em", cursor: "pointer" }}>
                I held it ✦
              </button>
            )}
          </div>
        )}
      </div>
    );
  }

  return (
    <div style={{ background: T.sand, borderRadius: 2, padding: "24px 20px", marginBottom: 20, border: "1px solid " + T.sandMid, marginTop: 24 }}>
      <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkGhost, letterSpacing: "0.14em", marginBottom: 12 }}>TODAY'S WEIGHT CHECK</p>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontStyle: "italic", color: T.inkMid, lineHeight: 1.6, marginBottom: 24 }}>
        What are you carrying today that isn't yours?
      </p>

      {/* Slider */}
      <div style={{ marginBottom: 8 }}>
        <input type="range" min="0" max="100" value={sliderValue}
          onChange={e => setSliderValue(parseInt(e.target.value))}
          style={{ width: "100%", accentColor: trackColor, cursor: "pointer", height: 6 }}
        />
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 6 }}>
          <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkGhost }}>Light</span>
          <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 16, fontStyle: "italic", color: trackColor }}>
            {weight === "light" ? "Something light" : weight === "medium" ? "Carrying a bit" : "Quite heavy"}
          </span>
          <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkGhost }}>Heavy</span>
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 20 }}>
        <button onClick={onComplete}
          style={{ background: "none", border: "none", fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkGhost, cursor: "pointer", padding: 0 }}>
          Skip for now
        </button>
        <button onClick={handleRelease}
          style={{ background: T.ink, color: T.ivory, border: "none", borderRadius: 2, padding: "10px 24px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.14em", cursor: "pointer" }}>
          {getRitual().label} →
        </button>
      </div>
    </div>
  );
};
const HomeScreen = ({ setScreen, user }) => {
  const [showWeightCheck, setShowWeightCheck] = useState(true);
  const hour = new Date().getHours();
  const greeting = hour < 12 ? "Good morning" : hour < 17 ? "Good afternoon" : "Good evening";
  const cards = [
    { id: "journal", num: "01", title: TRANSLATIONS.en.reframeStruggle, sub: TRANSLATIONS.en.turnDifficulty, time: "5–10 min" },
    { id: "ritual", num: "02", title: TRANSLATIONS.en.nightlyStillness, sub: TRANSLATIONS.en.releaseDay, time: "2 min" },
    { id: "library", num: "03", title: TRANSLATIONS.en.strengthLibrary, sub: TRANSLATIONS.en.sevenMeditations, time: "As needed" },
    { id: "shop", num: "04", title: "Pure Essentials", sub: "Pure Rêve wellness products", time: "New" },
    { id: "community", num: "05", title: "Community & Support", sub: TRANSLATIONS.en.youAreNotAlone, time: "Always open" },
  ];
  return (
    <div style={{ padding: "48px 28px 100px" }}>
      <FadeIn>
        <div style={{ marginBottom: 24 }}>
          <Serif size={11} style={{ display: "block", letterSpacing: "0.22em", textTransform: "uppercase", color: T.inkGhost, fontStyle: "normal", marginBottom: 4 }}>Pure Rêve<sup style={{ fontSize: "0.55em", letterSpacing: 0, marginLeft: 2, verticalAlign: "super" }}>™</sup></Serif>
          <Serif size={13} italic color={T.inkSoft} style={{ display: "block" }}>{TRANSLATIONS.en.digitalSanctuary}</Serif>
        </div>
        <Label style={{ marginBottom: 10 }}>{greeting}</Label>
        <Serif size={34} italic style={{ display: "block", lineHeight: 1.2, marginBottom: 6 }}>Your sanctuary</Serif>
        <Serif size={34} style={{ display: "block", lineHeight: 1.2 }}>awaits.</Serif>
      </FadeIn>
      <KintsugiVessel user={user} />
      <div style={{ marginTop: 24 }}>{showWeightCheck && <WeightCheck onComplete={() => setShowWeightCheck(false)} />}</div><FadeIn delay={150}><Divider style={{ margin: "28px 0" }} /><Label style={{ marginBottom: 18 }}>"Where would you like to begin?"</Label></FadeIn>
      {cards.map((c, i) => (
        <FadeIn key={c.id} delay={220 + i * 80}>
          <button onClick={() => setScreen(c.id)} style={{ width: "100%", background: T.sand, border: "none", borderRadius: 2, padding: "18px 20px", marginBottom: 8, cursor: "pointer", textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between", transition: "background 0.2s" }}
            onMouseEnter={e => e.currentTarget.style.background = T.sandMid} onMouseLeave={e => e.currentTarget.style.background = T.sand}>
            <div><Label style={{ marginBottom: 6 }}>{c.num}</Label><Serif size={18} weight={600} style={{ display: "block", marginBottom: 3 }}>{c.title}</Serif><span style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkSoft, fontWeight: 300 }}>{c.sub}</span></div>
            <div style={{ textAlign: "right" }}><span style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkGhost }}>{c.time}</span><div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, color: T.sandDark, lineHeight: 1, marginTop: 4 }}>→</div></div>
          </button>
        </FadeIn>
      ))}
      <FadeIn delay={700}>
        <div style={{ marginTop: 24, padding: "18px 22px", borderLeft: `2px solid ${T.sandMid}` }}>
          <Label style={{ marginBottom: 8 }}>Today's reflection</Label>
          <Serif size={15} italic color={T.inkMid} style={{ display: "block", lineHeight: 1.6 }}>"The wound is the place where the light enters you."</Serif>
          <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, fontWeight: 300 }}>— Rumi</span>
        </div>
      </FadeIn>
    </div>
  );
};

const QUESTIONS = [
  "What does this struggle feel like in your body right now — and where exactly do you feel it?",
  "If this difficulty were a teacher arriving with a lesson just for you, what might it be trying to show you?",
  "What quality in you — resilience, patience, courage — has this experience quietly been building?",
];

const JournalScreen = () => {
  const [phase, setPhase] = useState("input");
  const [struggle, setStruggle] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [inputVal, setInputVal] = useState("");
  const [qIndex, setQIndex] = useState(0);
  const bottomRef = useRef(null);
  useEffect(() => { bottomRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages, loading]);

  const startJourney = async () => {
    if (!struggle.trim()) return;
    setPhase("conversation"); setLoading(true);
    await new Promise(r => setTimeout(r, 800));
    setMessages([{ role: "assistant", text: QUESTIONS[0] }]);
    setQIndex(1); setLoading(false);
  };

  const sendAnswer = async () => {
    if (!inputVal.trim() || loading) return;
    const userMsg = inputVal.trim(); setInputVal("");
    const next = [...messages, { role: "user", text: userMsg }];
    setMessages(next); setLoading(true);
    if (qIndex < QUESTIONS.length) {
      await new Promise(r => setTimeout(r, 900));
      setMessages([...next, { role: "assistant", text: QUESTIONS[qIndex] }]);
      setQIndex(qIndex + 1); setLoading(false);
    } else {
      try {
        const fullText = "";
        const reframePart = fullText.match(/REFRAME:(.*?)(?=GUIDANCE:|$)/s)?.[1]?.trim() || "Within your willingness to look at this struggle lives an extraordinary strength.";
        const guidancePart = fullText.match(/GUIDANCE:(.*)/s)?.[1]?.trim() || "Be gentle with yourself today. You may carry this with you.";
        setMessages([...next, { role: "assistant", text: reframePart, isReframe: true }, { role: "assistant", text: guidancePart, isGuidance: true }]);
        setPhase("complete");
      } catch {
        setMessages([...next, { role: "assistant", text: "Within your willingness to look at this struggle lives an extraordinary strength.", isReframe: true }, { role: "assistant", text: "Be gentle with yourself today. You may carry this with you.", isGuidance: true }]);
        setPhase("complete");
      }
      setLoading(false);
    }
  };

  if (phase === "input") return (
    <div style={{ padding: "56px 28px 100px" }}>
      <FadeIn>
        <Label style={{ marginBottom: 12 }}>Reframing Journal</Label>
        <Serif size={30} italic style={{ display: "block", lineHeight: 1.25, marginBottom: 6 }}>What is the struggle</Serif>
        <Serif size={30} style={{ display: "block", lineHeight: 1.25, marginBottom: 28 }}>you are ready to transform?</Serif>
        <textarea value={struggle} onChange={e => setStruggle(e.target.value)} placeholder="Write it plainly. There is no wrong way to begin..." rows={7}
          style={{ width: "100%", background: T.sand, border: `1px solid ${T.sandMid}`, borderRadius: 2, padding: "18px 20px", fontFamily: "'Jost', sans-serif", fontSize: 14, fontWeight: 300, color: T.ink, lineHeight: 1.9, resize: "none", outline: "none", boxSizing: "border-box" }}
          onFocus={e => e.target.style.borderColor = T.blush} onBlur={e => e.target.style.borderColor = T.sandMid} />
          <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkGhost, lineHeight: 1.7, margin: "8px 0 0", textAlign: "center" }}>
            If you are in crisis, call or text <strong>988</strong> or call <strong>911</strong>. Pure Rêve is not a crisis service.
          </p>
        <div style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, textAlign: "right", marginTop: 8, marginBottom: 24 }}>{struggle.length} / 600</div>
        <Btn onClick={startJourney} style={{ opacity: struggle.trim() ? 1 : 0.4 }}>Begin the Journey</Btn>
      </FadeIn>
    </div>
  );

  return (
    <div style={{ padding: "56px 0 140px", display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <div style={{ padding: "0 28px 20px" }}>
        <Label style={{ marginBottom: 6 }}>Reframing Journal</Label>
        <div style={{ display: "flex", gap: 6 }}>{[0,1,2,3].map(i => <div key={i} style={{ flex: 1, height: 2, borderRadius: 1, background: i < qIndex ? T.ink : T.sand, transition: "background 0.4s" }} />)}</div>
      </div>
      <div style={{ flex: 1, padding: "0 28px", display: "flex", flexDirection: "column", gap: 16 }}>
        {messages.map((m, i) => (
          <FadeIn key={i}>
            {m.role === "assistant" ? (
              <div style={{ background: m.isReframe ? T.ink : m.isGuidance ? T.sandMid : T.sand, borderRadius: 2, padding: "20px 22px", borderLeft: (m.isReframe || m.isGuidance) ? "none" : `2px solid ${T.sandDark}` }}>
                {m.isReframe && <Label style={{ color: T.sandDark, marginBottom: 10 }}>Your Reframe</Label>}
                {m.isGuidance && <Label style={{ color: T.inkSoft, marginBottom: 10 }}>Guidance for You</Label>}
                <Serif size={m.isReframe ? 17 : 15} italic={!m.isReframe && !m.isGuidance} color={m.isReframe ? T.sand : T.inkMid} style={{ display: "block", lineHeight: 1.8 }}>{m.text}</Serif>
              </div>
            ) : (
              <div style={{ textAlign: "right" }}>
                <span style={{ display: "inline-block", background: T.ivory, border: `1px solid ${T.sand}`, borderRadius: 2, padding: "12px 16px", fontFamily: "'Jost', sans-serif", fontSize: 14, fontWeight: 300, color: T.ink, lineHeight: 1.65, maxWidth: "85%", textAlign: "left" }}>{m.text}</span>
              </div>
            )}
          </FadeIn>
        ))}
        {loading && <FadeIn><div style={{ display: "flex", gap: 6, padding: "8px 0" }}>{[0,1,2].map(i => <div key={i} style={{ width: 6, height: 6, borderRadius: "50%", background: T.sandDark, animation: `pulse 1.4s ease-in-out ${i*0.2}s infinite` }} />)}</div></FadeIn>}
        <div ref={bottomRef} />
      </div>
      {phase === "conversation" && (
        <div style={{ position: "fixed", bottom: 60, left: 0, right: 0, padding: "12px 20px", background: T.ivory, borderTop: `1px solid ${T.sand}`, display: "flex", gap: 10, maxWidth: 430, margin: "0 auto", boxSizing: "border-box" }}>
          <input value={inputVal} onChange={e => setInputVal(e.target.value)} onKeyDown={e => e.key === "Enter" && sendAnswer()} placeholder="Write your response..."
            style={{ flex: 1, background: T.sand, border: `1px solid ${T.sandMid}`, borderRadius: 2, padding: "12px 14px", fontFamily: "'Jost', sans-serif", fontSize: 13, fontWeight: 300, color: T.ink, outline: "none" }} />
          <button onClick={sendAnswer} style={{ background: T.ink, color: T.ivory, border: "none", borderRadius: 2, padding: "12px 18px", cursor: "pointer" }}>→</button>
        </div>
      )}
      <style>{`@keyframes pulse{0%,100%{opacity:0.3;transform:scale(0.8)}50%{opacity:1;transform:scale(1)}}`}</style>
    </div>
  );
};

const RitualScreen = ({ user, appLang }) => {
  const [phase, setPhase] = useState("intro");
  const [text, setText] = useState("");
  const [seconds, setSeconds] = useState(120);
  const [opacity, setOpacity] = useState(1);
  const timerRef = useRef(null);
  const soundRef = useRef(null);
  const [soundOn, setSoundOn] = useState(true);
  const [selectedSound, setSelectedSound] = useState("brown");
  const startRitual = () => {
    setPhase("writing");
    timerRef.current = setInterval(() => setSeconds(s => { if (s <= 1) { clearInterval(timerRef.current); beginFade(); stopSound(); return 0; } return s - 1; }), 1000);
    startSound();
  };

  const startSound = () => {
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const masterGain = ctx.createGain();
      masterGain.gain.setValueAtTime(0, ctx.currentTime);
      masterGain.gain.linearRampToValueAtTime(1.0, ctx.currentTime + 2);
      masterGain.connect(ctx.destination);

      if (selectedSound === "hymn") {
        // Evening Hymn - peaceful organ-like chords
        const chords = [
          [261.63, 329.63, 392.00], // C major
          [293.66, 369.99, 440.00], // D minor
          [246.94, 311.13, 369.99], // B minor
          [261.63, 329.63, 392.00], // C major
        ];
        let chordIndex = 0;
        let activeOscillators = [];

        const playChord = () => {
          activeOscillators.forEach(o => {
            try { o.gain.gain.linearRampToValueAtTime(0, ctx.currentTime + 1.5); } catch(e) {}
          });
          activeOscillators = [];
          const chord = chords[chordIndex % chords.length];
          chord.forEach(freq => {
            const osc = ctx.createOscillator();
            const gain = ctx.createGain();
            osc.type = 'sine';
            osc.frequency.value = freq;
            gain.gain.setValueAtTime(0, ctx.currentTime);
            gain.gain.linearRampToValueAtTime(0.25, ctx.currentTime + 1);
            gain.gain.linearRampToValueAtTime(0.18, ctx.currentTime + 3);
            osc.connect(gain);
            gain.connect(masterGain);
            osc.start();
            activeOscillators.push({ osc, gain });
          });
          chordIndex++;
        };

        playChord();
        const chordTimer = setInterval(playChord, 4000);
        soundRef.current = { masterGain, ctx, chordTimer, activeOscillators };

      } else if (selectedSound === "forest") {
        const bufferSize = ctx.sampleRate * 10;
        const buffer = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
        const data = buffer.getChannelData(0);
        for (let i = 0; i < bufferSize; i++) {
          const t = i / ctx.sampleRate;
          const cricket = Math.sin(2 * Math.PI * 4200 * t) * 0.3 * (Math.random() > 0.97 ? 1 : 0);
          const wind = (Math.random() * 2 - 1) * 0.25 * (0.5 + 0.5 * Math.sin(2 * Math.PI * 0.1 * t));
          data[i] = cricket + wind;
        }
        const source = ctx.createBufferSource();
        source.buffer = buffer;
        source.loop = true;
        source.connect(masterGain);
        source.start();
        soundRef.current = { source, masterGain, ctx };

      } else if (selectedSound === "rain") {
        const bufferSize = ctx.sampleRate * 10;
        const buffer = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
        const data = buffer.getChannelData(0);
        for (let i = 0; i < bufferSize; i++) {
          data[i] = (Math.random() * 2 - 1) * 0.6;
        }
        const source = ctx.createBufferSource();
        source.buffer = buffer;
        source.loop = true;
        const filter = ctx.createBiquadFilter();
        filter.type = 'bandpass';
        filter.frequency.value = 1200;
        filter.Q.value = 0.5;
        source.connect(filter);
        filter.connect(masterGain);
        source.start();
        soundRef.current = { source, masterGain, ctx };
      }
    } catch(e) { console.log('Audio error:', e); }
  };

  const stopSound = () => {
    if (soundRef.current) {
      try {
        if (soundRef.current.chordTimer) clearInterval(soundRef.current.chordTimer);
        if (soundRef.current.activeOscillators) {
          soundRef.current.activeOscillators.forEach(o => {
            try { o.gain.gain.linearRampToValueAtTime(0, soundRef.current.ctx.currentTime + 2); } catch(e) {}
          });
        }
        if (soundRef.current.masterGain) {
          soundRef.current.masterGain.gain.linearRampToValueAtTime(0, soundRef.current.ctx.currentTime + 2);
        }
        if (soundRef.current.source) {
          setTimeout(() => { try { soundRef.current.source.stop(); } catch(e) {} }, 2000);
        }
      } catch(e) {}
      soundRef.current = null;
    }
  };

  const toggleSound = () => {
    if (soundOn) {
      stopSound();
      setSoundOn(false);
    } else {
      startSound();
      setSoundOn(true);
    }
  };
  const beginFade = () => {
    setPhase("fading"); let op = 1;
    const fade = setInterval(() => { op -= 0.025; setOpacity(op); if (op <= 0) { clearInterval(fade); setPhase("complete"); } }, 80);
  };
  const reset = () => { clearInterval(timerRef.current); stopSound(); setPhase("intro"); setText(""); setSeconds(120); setOpacity(1); };
  const mins = Math.floor(seconds / 60), secs = seconds % 60;
  const progress = (120 - seconds) / 120;
  const r = 22, circ = 2 * Math.PI * r;

  if (phase === "intro") return (
    <div style={{ padding: "56px 28px 100px" }}>
      <FadeIn>
        <Label style={{ marginBottom: 12 }}>{TRANSLATIONS.en.nightlyStillness}</Label>
        <Serif size={30} italic style={{ display: "block", lineHeight: 1.25, marginBottom: 6 }}>{TRANSLATIONS.en.releaseDay}</Serif>
        <Serif size={30} style={{ display: "block", lineHeight: 1.25, marginBottom: 28 }}>Welcome the night.</Serif>
        <div style={{ borderLeft: `2px solid ${T.sandMid}`, paddingLeft: 20, marginBottom: 32 }}>
          <Serif size={14} italic color={T.inkSoft} style={{ display: "block", lineHeight: 1.9 }}>You have two minutes. Write everything your mind is holding. When the timer ends, your words will gently dissolve. Let them go.</Serif>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 16, padding: "18px 22px", background: T.sand, borderRadius: 2, marginBottom: 28 }}>
          <div style={{ width: 44, height: 44, borderRadius: "50%", border: `1.5px solid ${T.sandDark}`, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Serif size={18} italic color={T.inkMid}>2'</Serif>
          </div>
          <div>
            <Serif size={14} weight={600} style={{ display: "block", marginBottom: 2 }}>Two-minute brain dump</Serif>
            <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkSoft, fontWeight: 300 }}>Best taken with your Pure Rêve Stillness Gummy</span>
          </div>
        </div>
        <div style={{ marginBottom: 20 }}>
          <Label style={{ marginBottom: 12 }}>Choose your sound</Label>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {[
              { id: "hymn", label: "Evening Hymn", sub: "Peaceful organ chords" },
              { id: "forest", label: "Forest Night", sub: "Crickets and gentle wind" },
              { id: "rain", label: "Still Waters", sub: "Gentle rain on leaves" },
            ].map(s => (
              <button key={s.id} onClick={() => setSelectedSound(s.id)}
                style={{ background: selectedSound === s.id ? T.ink : T.sand, border: "none", borderRadius: 2, padding: "12px 16px", cursor: "pointer", textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div>
                  <Serif size={15} color={selectedSound === s.id ? T.ivory : T.inkMid} style={{ display: "block", marginBottom: 2 }}>{s.label}</Serif>
                  <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: selectedSound === s.id ? T.sandDark : T.inkGhost, fontWeight: 300 }}>{s.sub}</span>
                </div>
                <div style={{ width: 20, height: 20, borderRadius: "50%", border: "1px solid " + (selectedSound === s.id ? T.sandDark : T.sandMid), background: selectedSound === s.id ? T.sandDark : "transparent" }} />
              </button>
            ))}
          </div>
        </div>
        <Btn onClick={startRitual}>Begin the Stillness</Btn>
      </FadeIn>
      <StillnessTracker user={user} />
    </div>
  );

  if (phase === "complete") return (
    <div style={{ padding: "56px 28px 100px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "80vh", textAlign: "center" }}>
      <FadeIn>
        <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 52, color: T.sandDark, marginBottom: 24, fontWeight: 300 }}>✦</div>
        <Serif size={34} italic style={{ display: "block", marginBottom: 10 }}>Sleep well.</Serif>
        <Serif size={18} color={T.inkSoft} style={{ display: "block", lineHeight: 1.6, maxWidth: 280, margin: "0 auto 32px" }}>Your thoughts have been released. Rest now. Tomorrow is a new beginning.</Serif>
        <Btn ghost onClick={reset}>Return to Sanctuary</Btn>
      </FadeIn>
    </div>
  );

  return (
    <div style={{ padding: "56px 28px 100px" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 28 }}>
        <Label>{TRANSLATIONS.en.nightlyStillness}</Label>
        {phase === "writing" && (
          <button onClick={toggleSound} style={{ background: "none", border: "none", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.12em", textTransform: "uppercase", color: T.inkGhost, cursor: "pointer", padding: 0 }}>
            {soundOn ? "✦ Sound on" : "✦ Sound off"}
          </button>
        )}
        <div style={{ position: "relative", width: 60, height: 60 }}>
          <svg width="60" height="60" style={{ transform: "rotate(-90deg)" }}>
            <circle cx="30" cy="30" r={r} fill="none" stroke={T.sand} strokeWidth="1.5" />
            <circle cx="30" cy="30" r={r} fill="none" stroke={T.ink} strokeWidth="1.5" strokeDasharray={circ} strokeDashoffset={circ * (1 - progress)} strokeLinecap="round" style={{ transition: "stroke-dashoffset 1s linear" }} />
          </svg>
          <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 14, color: T.ink }}>{mins}:{secs.toString().padStart(2, "0")}</span>
          </div>
        </div>
      </div>
      <Serif size={15} italic color={T.inkSoft} style={{ display: "block", lineHeight: 1.6, marginBottom: 20 }}>Write freely. Let everything out. This space holds it all — then lets it go.</Serif>
      <div style={{ position: "relative" }}>
        <textarea value={text} onChange={e => setText(e.target.value)} placeholder="Everything on your mind right now..." rows={14} readOnly={phase === "fading"}
          style={{ width: "100%", background: T.sand, border: `1px solid ${T.sandMid}`, borderRadius: 2, padding: "18px 20px", fontFamily: "'Jost', sans-serif", fontSize: 14, fontWeight: 300, color: `rgba(28,22,16,${opacity})`, lineHeight: 1.9, resize: "none", outline: "none", boxSizing: "border-box" }} />
        {phase === "fading" && <div style={{ position: "absolute", inset: 0, background: `rgba(237,229,216,${1 - opacity * 0.3})`, borderRadius: 2, pointerEvents: "none" }} />}
      </div>
    </div>
  );
};

const generateCardImage = async (card, format = "story") => {
  const W = format === "story" ? 1080 : 1000;
  const H = format === "story" ? 1920 : 1500;
  const canvas = document.createElement("canvas");
  canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = card.color; ctx.fillRect(0, 0, W, H);
  ctx.font = "300 " + Math.round(W * 0.024) + "px Georgia";
  ctx.fillStyle = card.textColor; ctx.globalAlpha = 0.3; ctx.textAlign = "center";
  ctx.fillText("PURE REVE", W / 2, H * 0.07); ctx.globalAlpha = 1;
  ctx.beginPath(); ctx.moveTo(W * 0.38, H * 0.09); ctx.lineTo(W * 0.62, H * 0.09);
  ctx.strokeStyle = card.textColor; ctx.globalAlpha = 0.15; ctx.lineWidth = 1; ctx.stroke(); ctx.globalAlpha = 1;
  const circY = H * 0.2;
  ctx.beginPath(); ctx.arc(W / 2, circY, W * 0.12, 0, Math.PI * 2);
  ctx.strokeStyle = card.textColor; ctx.globalAlpha = 0.1; ctx.lineWidth = 1; ctx.stroke(); ctx.globalAlpha = 1;
  ctx.beginPath(); ctx.moveTo(W / 2, circY - W * 0.11);
  ctx.bezierCurveTo(W / 2 + W * 0.055, circY - W * 0.06, W / 2 + W * 0.07, circY, W / 2, circY);
  ctx.bezierCurveTo(W / 2 - W * 0.07, circY + W * 0.04, W / 2 - W * 0.035, circY + W * 0.09, W / 2, circY + W * 0.11);
  ctx.strokeStyle = card.textColor; ctx.globalAlpha = 0.5; ctx.lineWidth = 2; ctx.lineCap = "round"; ctx.stroke(); ctx.globalAlpha = 1;
  ctx.font = "300 " + Math.round(W * 0.028) + "px Georgia";
  ctx.fillStyle = card.textColor; ctx.globalAlpha = 0.25; ctx.textAlign = "center";
  ctx.fillText(card.num, W / 2, H * 0.36); ctx.globalAlpha = 1;
  const titleSize = Math.round(W * 0.068);
  ctx.font = "italic 300 " + titleSize + "px Georgia";
  ctx.fillStyle = card.textColor; ctx.textAlign = "center";
  const tWords = card.title.split(" "); let tLine = ""; let tY = H * 0.41; const tLines = [];
  for (let w of tWords) { const test = tLine + w + " "; if (ctx.measureText(test).width > W * 0.8 && tLine !== "") { tLines.push(tLine.trim()); tLine = w + " "; } else { tLine = test; } }
  tLines.push(tLine.trim());
  tLines.forEach((l, i) => ctx.fillText(l, W / 2, tY + i * Math.round(titleSize * 1.25)));
  const divY = tY + tLines.length * Math.round(titleSize * 1.25) + H * 0.022;
  ctx.beginPath(); ctx.moveTo(W * 0.38, divY); ctx.lineTo(W * 0.62, divY);
  ctx.strokeStyle = card.textColor; ctx.globalAlpha = 0.18; ctx.lineWidth = 1; ctx.stroke(); ctx.globalAlpha = 1;
  const bSize = Math.round(W * 0.036);
  ctx.font = "300 " + bSize + "px Georgia"; ctx.fillStyle = card.textColor; ctx.globalAlpha = 0.80; ctx.textAlign = "center";
  const bWords = card.body.split(" "); let bLine = ""; let bY = divY + H * 0.04; const bLH = Math.round(bSize * 1.7);
  for (let w of bWords) { const test = bLine + w + " "; if (ctx.measureText(test).width > W * 0.80 && bLine !== "") { ctx.fillText(bLine.trim(), W / 2, bY); bLine = w + " "; bY += bLH; } else { bLine = test; } }
  ctx.fillText(bLine.trim(), W / 2, bY); ctx.globalAlpha = 1;
  bY += bLH + H * 0.025;
  const vSize = Math.round(W * 0.028);
  ctx.font = "italic " + vSize + "px Georgia"; ctx.fillStyle = card.textColor; ctx.globalAlpha = 0.4;
  const vWords = card.verse.split(" "); let vLine = ""; const vLines = [];
  for (let w of vWords) { const test = vLine + w + " "; if (ctx.measureText(test).width > W * 0.72 && vLine !== "") { vLines.push(vLine.trim()); vLine = w + " "; } else { vLine = test; } }
  vLines.push(vLine.trim());
  vLines.forEach((l, i) => ctx.fillText(l, W / 2, bY + i * Math.round(vSize * 1.6))); ctx.globalAlpha = 1;
  ctx.beginPath(); ctx.moveTo(W * 0.38, H * 0.935); ctx.lineTo(W * 0.62, H * 0.935);
  ctx.strokeStyle = card.textColor; ctx.globalAlpha = 0.15; ctx.lineWidth = 1; ctx.stroke(); ctx.globalAlpha = 1;
  ctx.font = "300 " + Math.round(W * 0.026) + "px Georgia";
  ctx.fillStyle = card.textColor; ctx.globalAlpha = 0.22; ctx.textAlign = "right";
  ctx.fillText("\u2726 purereve.app", W - W * 0.055, H * 0.963); ctx.globalAlpha = 1;
  return canvas.toDataURL("image/png");
};

const CARDS = [
  { num: "I", title: "The Strength in Silence", sub: "On stillness as power", color: "#1C1610", textColor: "#FAF7F2", body: "Silence is not the absence of something — it is the presence of everything unspoken, gathering itself into form. The moments you chose not to react, not to fill the air with noise, were not weakness. They were the quiet accumulation of a strength few people ever find. In your silence, you were already speaking a language deeper than words.", verse: "\"Be still, and know that I am God.\" — Psalm 46:10" },
  { num: "II", title: "The Wisdom of a Setback", sub: "On what failure teaches", color: "#EDE5D8", textColor: "#1C1610", body: "Every setback is an instruction manual written specifically for you. The path that closed was not the only path — it was simply the one that led you here, to this moment of knowing exactly what you are made of. What felt like loss was, in truth, precision: life removing what was no longer needed so that what matters could finally arrive.", verse: "\"And we know that in all things God works for the good of those who love him.\" — Romans 8:28" },
  { num: "III", title: "The Gift of Feeling", sub: "On emotional depth", color: "#D6C9B6", textColor: "#1C1610", body: "To feel deeply is not a burden — it is the rarest form of intelligence. The grief you have carried, the love that left you open, the fear that made your hands tremble: all of it is evidence of a life fully inhabited. The people who feel nothing protect themselves from nothing. You, who feel everything, are building a world that others can finally rest in.", verse: "\"The Lord is close to the brokenhearted and saves those who are crushed in spirit.\" — Psalm 34:18" },
  { num: "IV", title: "The Courage to Begin Again", sub: "On renewal and resilience", color: "#C9A98A", textColor: "#1C1610", body: "There is an extraordinary kind of bravery required simply to try again. Not the bravery of someone who has never failed, but the deeper kind — the bravery of someone who knows exactly how much it costs, and chooses to begin anyway. Every morning you opened your eyes and continued was an act of courage so ordinary it almost hid itself. It was not ordinary. It was everything.", verse: "\"I can do all things through Christ who strengthens me.\" — Philippians 4:13" },
  { num: "V", title: "The Grace of Letting Go", sub: "On release and freedom", color: "#FAF7F2", textColor: "#1C1610", body: "Releasing something is not the same as losing it. When you finally unclenched your hands and let what was never truly yours return to the open air, you did not become emptier. You became lighter. The space left behind is not a wound — it is a room being prepared for something that actually belongs to you. Let it be readied in peace.", verse: "\"Cast all your anxiety on him because he cares for you.\" — 1 Peter 5:7" },
  { num: "VI", title: "The Power of Patience", sub: "On waiting as wisdom", color: "#B8A48C", textColor: "#1C1610", body: "Patience is not passivity. It is the deliberate choice to trust that what is being built beneath the surface is worth the wait. Trees do not apologize for growing slowly. Neither should you. The depth of your roots is being laid right now, in this season of waiting, and when the right wind comes, it will find you already standing.", verse: "\"But those who hope in the Lord will renew their strength. They will soar on wings like eagles.\" — Isaiah 40:31" },
  { num: "VII", title: "The Wholeness of Being Broken", sub: "On integration and healing", color: "#3D3228", textColor: "#FAE5D8", body: "The Japanese practice of Kintsugi repairs broken pottery with gold — because the break, once healed, is where the beauty lives. You are not damaged. You are gilded. Every crack in you tells the story of something survived, something integrated, something transformed. The light that enters through your fractures is not an accident. It is the point of the whole beautiful thing.", verse: "\"He heals the brokenhearted and binds up their wounds.\" — Psalm 147:3" },
];


const MardiExpanded = () => {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ marginBottom: 14 }}>
      <button onClick={() => setOpen(!open)} style={{ background: 'none', border: 'none', padding: 0, fontFamily: "'Jost', sans-serif", fontSize: 12, color: '#B8965A', cursor: 'pointer', letterSpacing: '0.05em', display: 'flex', alignItems: 'center', gap: 4 }}>
        {open ? 'Read less ▲' : 'Read more ▼'}
      </button>
      {open && (
        <div style={{ marginTop: 12, fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic', fontSize: 13, color: '#3B2E22', lineHeight: 1.8 }}>
          <p>My name is Mardi Rosenfeld and I am both a licensed mental health counselor and educator. I earned both my B.A. and M.A in Community/Clinical Mental Health Counseling from Rollins College in Winter Park, Florida. I am so very lucky to have the opportunity to be a part of this well-being journey with you!</p>
          <p>You may say, "Mardi, there is nothing GOOD in my world." I would say: "Yes, there is bad in the world. And, at the same time while there is bad, there is also GOOD. When we look at what is GOOD, we are not ignoring what is bad. Instead, we accept the reality of both."</p>
          <p>I quote from Mr. Fred Rogers when asked about War: "Always look for the helpers. When we witness the people who help in times of trouble, those who help the injured and the dying, we are witnessing the good in our world." Both bad and GOOD can be present at the same time.</p>
          <p>So, I ask you — what are three things that are good in your world, right now? Maybe you had just enough gas to drive to the gas station, or a door was held open for you by a stranger. When we take a moment to notice and accept what is GOOD in our world, it helps us create a kinder and gentler view of ourselves and others.</p>
          <p>Write down "3 Blessings" — things that were GOOD in your world today. Write them down EACH AND EVERY DAY, and you will see that there is so much GOOD in this world.</p>
          <p style={{ marginTop: 16, fontStyle: 'normal', fontSize: 12, color: '#8B7355' }}>*This exercise comes from the Positive Psychology Movement. A great book: "Authentic Happiness" by Martin Seligman.</p>
          <p style={{ marginTop: 8, fontStyle: 'normal', fontSize: 12, color: '#B8965A' }}>May love, light and all that is GOOD be noticed in your path,<br/>Mardi Rosenfeld, MA, LMHC</p>
        </div>
      )}
    </div>
  );
};

const LibraryScreen = ({ setScreen, appLang }) => {
  const [open, setOpen] = useState(null);
  const [shareMenu, setShareMenu] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [shared, setShared] = useState(false);

  const handleDownload = async (card, format = "story") => {
    setDownloading(true);
    try {
      const dataUrl = await generateCardImage(card, format);
      const suffix = format === "story" ? "instagram-story" : "pinterest";
      const link = document.createElement("a");
      link.download = "pure-reve-" + card.title.toLowerCase().replace(/\s+/g, "-") + "-" + suffix + ".png";
      link.href = dataUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch(e) { console.error("Download error:", e); }
    setDownloading(false);
    setShareMenu(false);
  };

  const handleShare = async (card) => {
    try {
      const dataUrl = await generateCardImage(card, "story");
      const blob = await (await fetch(dataUrl)).blob();
      const file = new File([blob], "pure-reve-" + card.num + ".png", { type: "image/png" });
      if (navigator.share && navigator.canShare({ files: [file] })) {
        await navigator.share({ title: "Pure Rêve — " + card.title, text: card.body.substring(0, 100) + "...", url: "https://purereve.app", files: [file] });
      } else if (navigator.share) {
        await navigator.share({ title: "Pure Rêve — " + card.title, url: "https://purereve.app" });
      } else {
        await navigator.clipboard.writeText("https://purereve.app");
        setShared(true); setTimeout(() => setShared(false), 3000);
      }
    } catch(e) { console.error(e); }
    setShareMenu(false);
  };

  if (open !== null) {
    const card = CARDS[open];
    return (
      <div style={{ padding: "56px 28px 100px", minHeight: "100vh", background: card.color }}>
        <FadeIn>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 32 }}>
            <button onClick={() => { setOpen(null); setShareMenu(false); }} style={{ background: "none", border: "none", cursor: "pointer", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.14em", textTransform: "uppercase", color: card.textColor, opacity: 0.6, padding: 0 }}>← Library</button>
            <button onClick={() => setShareMenu(!shareMenu)} style={{ background: "none", border: `1px solid ${card.textColor}`, borderRadius: 2, padding: "8px 16px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.12em", textTransform: "uppercase", color: card.textColor, opacity: 0.7, cursor: "pointer" }}>✦ Share</button>
          </div>

          {shareMenu && (
            <div style={{ background: card.textColor, borderRadius: 2, padding: "18px 20px", marginBottom: 24 }}>
              <button onClick={() => handleDownload(card, "story")} disabled={downloading} style={{ display: "block", width: "100%", background: card.color, color: card.textColor, border: "none", borderRadius: 2, padding: "13px 16px", fontFamily: "Jost", fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", cursor: "pointer", marginBottom: 10, textAlign: "center" }}>{downloading ? "Generating..." : "↓ Download as Image"}</button>
              <button onClick={() => handleShare(card)} style={{ display: "block", width: "100%", background: "none", color: card.color, border: "1px solid " + card.color, borderRadius: 2, padding: "13px 16px", fontFamily: "Jost", fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", cursor: "pointer", textAlign: "center" }}>{shared ? "✦ Copied" : "↗ Share to Instagram / Pinterest"}</button>
              <p style={{ fontFamily: "Jost", fontSize: 12, color: card.color, opacity: 0.28, margin: "12px 0 0", textAlign: "center" }}>✦ All shared images include the Pure Rêve watermark.</p>
            </div>
          )}
          )}

          <Label style={{ color: card.textColor, opacity: 0.5, marginBottom: 16 }}>{card.num} of VII</Label>
          <Serif size={32} weight={300} italic color={card.textColor} style={{ display: "block", lineHeight: 1.25, marginBottom: 8 }}>{card.title}</Serif>
          <Serif size={14} color={card.textColor} style={{ display: "block", opacity: 0.5, marginBottom: 36 }}>{card.sub}</Serif>
          <div style={{ height: 1, background: card.textColor, opacity: 0.15, marginBottom: 36 }} />
          <Serif size={17} color={card.textColor} style={{ display: "block", lineHeight: 1.85, fontStyle: "normal", fontWeight: 300 }}>{card.body}</Serif>
          <div style={{ marginTop: 32, padding: "18px 20px", borderLeft: `2px solid ${card.textColor}`, opacity: 0.65 }}>
            <Label style={{ color: card.textColor, marginBottom: 8 }}>Scripture</Label>
            <Serif size={13} italic color={card.textColor} style={{ display: "block", lineHeight: 1.8 }}>{card.verse}</Serif>
          </div>
          <div style={{ marginTop: 48, display: "flex", justifyContent: "space-between" }}>
            <button onClick={() => { setOpen(Math.max(0, open - 1)); setShareMenu(false); }} disabled={open === 0} style={{ background: "none", border: `1px solid ${card.textColor}`, borderRadius: 2, padding: "12px 22px", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.12em", textTransform: "uppercase", color: card.textColor, opacity: open === 0 ? 0.2 : 0.7, cursor: open === 0 ? "default" : "pointer" }}>← Prev</button>
            <button onClick={() => { setOpen(Math.min(CARDS.length - 1, open + 1)); setShareMenu(false); }} disabled={open === CARDS.length - 1} style={{ background: "none", border: `1px solid ${card.textColor}`, borderRadius: 2, padding: "12px 22px", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.12em", textTransform: "uppercase", color: card.textColor, opacity: open === CARDS.length - 1 ? 0.2 : 0.7, cursor: open === CARDS.length - 1 ? "default" : "pointer" }}>{TRANSLATIONS.en.next}</button>
          </div>
          <div style={{ marginTop: 40, textAlign: "center" }}>
            <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: card.textColor, opacity: 0.25 }}>© 2026 Pure Rêve LLC</span>
          </div>
        </FadeIn>
      </div>
    );
  }

  return (
    <div style={{ padding: "56px 28px 100px" }}>
      <FadeIn>
        <Label style={{ marginBottom: 12 }}>Strength Library</Label>
        <Serif size={30} italic style={{ display: "block", lineHeight: 1.25, marginBottom: 6 }}>{TRANSLATIONS.en.sevenMeditations}</Serif>
        <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkSoft, fontWeight: 300, display: "block", marginBottom: 32 }}>Read one. Sit with it. Return when needed.</span>
      </FadeIn>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {CARDS.map((card, i) => (
          <FadeIn key={i} delay={i * 60}>
            <button onClick={() => setOpen(i)} style={{ width: "100%", background: card.color, border: "1px solid #EDE5D8", borderRadius: 2, padding: "20px 22px", cursor: "pointer", textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between", transition: "opacity 0.2s" }}
              onMouseEnter={e => e.currentTarget.style.opacity = "0.85"} onMouseLeave={e => e.currentTarget.style.opacity = "1"}>
              <div>
                <Label style={{ color: card.textColor, opacity: 0.45, marginBottom: 8 }}>{card.num}</Label>
                <Serif size={17} weight={600} color={card.textColor} style={{ display: "block", marginBottom: 3 }}>{card.title}</Serif>
                <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: card.textColor, opacity: 0.55, fontWeight: 300 }}>{card.sub}</span>
              </div>
              <Serif size={20} color={card.textColor} style={{ opacity: 0.4 }}>→</Serif>
            </button>
          </FadeIn>
        ))}
      </div>
      <div style={{ marginTop: 40 }}>
        <div style={{ borderTop: '1px solid #EDE5D8', paddingTop: 28, marginBottom: 16 }}>
          <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 11, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#B8965A', display: 'block', marginBottom: 16 }}>✦ KEEPER</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 16 }}>
            <img src="/mardi2.jpg" alt="Mardi Rosenfeld" style={{ width: 56, height: 56, borderRadius: '50%', border: '2px solid #B8965A', objectFit: 'cover', flexShrink: 0 }} />
            <div>
              <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 16, fontWeight: 500, color: '#3B2E22', marginBottom: 2 }}>Mardi Rosenfeld</div>
              <div style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: '#B8965A', letterSpacing: '0.05em', marginBottom: 2 }}>MA, LMHC</div>
              <div style={{ fontFamily: "'Jost', sans-serif", fontSize: 11, color: '#8B7355' }}>Licensed Mental Health Counselor</div>
            </div>
          </div>
          <div style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic', fontSize: 13, color: '#3B2E22', lineHeight: 1.7, marginBottom: 14 }}>When we look at what is good, we are not ignoring what is bad. We accept both and choose where to place our attention.</div>
          <MardiExpanded />
          <div style={{ background: '#F5EFE6', borderLeft: '2px solid #B8965A', borderRadius: '0 8px 8px 0', padding: '12px 14px', marginBottom: 14 }}>
            <div style={{ fontFamily: "'Jost', sans-serif", fontSize: 11, letterSpacing: '0.15em', color: '#B8965A', marginBottom: 6 }}>✦ TODAY'S PRACTICE</div>
            <div style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: '#3B2E22', lineHeight: 1.6 }}>Write down 3 things that were good in your world today — no matter how small. Do this every day and watch what begins to shift.</div>
          </div>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            {['Positive Psychology', 'Gratitude', 'Mental Wellness'].map(t => (<span key={t} style={{ fontFamily: "'Jost', sans-serif", fontSize: 11, color: '#8B7355', background: '#F5EFE6', border: '0.5px solid #EDE5D8', borderRadius: 20, padding: '3px 10px' }}>{t}</span>))}
          </div>
        </div>
      </div>
      <div style={{ marginTop: 32, textAlign: 'center' }}>
        <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkGhost }}>© 2026 Pure Rêve LLC</span>
      </div>
    </div>
  );
};

const ShopScreen = () => {
  const [expanded, setExpanded] = useState(null);

  const products = [
    {
      id: 1,
      tag: "Evening Ritual · Melatonin*",
      name: "Stillness Strips",
      sub: "Dissolving oral strips with melatonin and botanical extracts.*",
      price: "$36.50",
      details: "Melatonin 1 mg per strip · Valerian root, chamomile, lavender and hibiscus extracts",
      ritual: "Place one strip on your tongue. Let it dissolve in 30 seconds. Begin your stillness.",
      coa: "May cause drowsiness. Do not drive or operate machinery after taking, and do not combine with alcohol. Contains melatonin and valerian root, which may interact with some medications. Consult a healthcare provider before use if you take any medication. Pregnant or nursing individuals, anyone under 18, and anyone with a medical condition should consult a physician first. Maximum 1 strip per day.",
      url: "https://purereve.com/collections/all",
    },
    {
      id: 2,
      tag: "Evening Ritual · Melatonin*",
      name: "Stillness Capsules",
      sub: "Melatonin, magnesium and a botanical blend in one evening capsule.*",
      price: "$29.90",
      details: "Per 2 capsules: Melatonin 10 mg · Vitamin B6 1.8 mg · Magnesium 13 mg · Calcium 17 mg · Sleep Formula Proprietary Blend 905 mg (L-tryptophan, lycium, chamomile, lemon balm, passion flower, L-taurine, hops, St. John's Wort, GABA, Chinese skullcap, L-theanine, ashwagandha, inositol, 5-HTP)",
      ritual: "Take two capsules once daily, 20 to 30 minutes before bedtime, with an 8 oz glass of water.",
      coa: "10 mg melatonin per serving. May cause drowsiness. Do not drive or operate machinery after taking, and do not combine with alcohol. Contains melatonin, St. John's Wort and 5-HTP, which may interact with some medications, including antidepressants, sedatives, blood thinners and birth control. Consult a healthcare provider before use if you take any medication. Pregnant or nursing individuals, anyone under 18, and anyone with a medical condition should consult a physician first. Do not exceed the recommended dose.",
      url: "https://purereve.com/collections/all",
    },
  ];

  return (
    <div style={{ padding: "56px 0 100px", background: T.ivory, minHeight: "100vh" }}>
      <div style={{ padding: "0 24px 32px" }}>
        <FadeIn>
          <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 11, letterSpacing: "0.2em", textTransform: "uppercase", color: T.inkGhost, display: "block", marginBottom: 8 }}>Pure Rêve<sup style={{ fontSize: "0.55em", letterSpacing: 0, marginLeft: 2, verticalAlign: "super" }}>™</sup></span>
          <Serif size={32} italic style={{ display: "block", lineHeight: 1.2, marginBottom: 8 }}>The Evening Sanctuary Collection.</Serif>
          <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkSoft, fontWeight: 300, display: "block" }}>Crafted for rest. Designed for renewal.</span>
        </FadeIn>
      </div>

      {products.map((p, i) => (
        <FadeIn key={p.id} delay={i * 150}>
          <div style={{ margin: "0 0 2px", borderTop: "1px solid " + T.sandMid, borderBottom: "1px solid " + T.sandMid }}>
            {/* Product image area */}
            <div style={{ background: T.inkMid, padding: "48px 24px", display: "flex", alignItems: "center", justifyContent: "center", borderBottom: "1px solid " + T.sandMid }}>
              <div style={{ textAlign: "center" }}>
                <div style={{ width: 120, height: 120, borderRadius: "50%", background: "rgba(250,247,242,0.15)", margin: "0 auto 16px", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid rgba(250,247,242,0.3)" }}>
                  <img src="/pure-reve-icon.svg" style={{ width: 60, height: 60, opacity: 0.8 }} alt="Pure Reve" />
                </div>
                <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 11, letterSpacing: "0.18em", textTransform: "uppercase", color: "rgba(250,247,242,0.6)" }}>Pure Rêve<sup style={{ fontSize: "0.55em", letterSpacing: 0, marginLeft: 2, verticalAlign: "super" }}>™</sup></span>
              </div>
            </div>

            {/* Product info */}
            <div style={{ padding: "28px 24px", borderLeft: "3px solid #B8965A" }}>
              <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 11, letterSpacing: "0.16em", textTransform: "uppercase", color: "#8B6914", display: "block", marginBottom: 8 }}>{p.tag}</span>
              <Serif size={26} weight={600} style={{ display: "block", marginBottom: 8 }}>{p.name}</Serif>
              <Serif size={14} italic color={T.inkSoft} style={{ display: "block", lineHeight: 1.8, marginBottom: 16 }}>{p.sub}</Serif>
              <Serif size={20} style={{ display: "block", marginBottom: 20 }}>{p.price}</Serif>

              {/* Accordion */}
              <div style={{ borderTop: "1px solid " + T.sandMid }}>
                {[
                  { label: "Ingredients", content: p.details },
                  { label: "The Ritual", content: p.ritual },
                  { label: "Safety", content: p.coa },
                ].map(item => (
                  <div key={item.label} style={{ borderBottom: "1px solid " + T.sandMid }}>
                    <button onClick={() => setExpanded(expanded === p.id + item.label ? null : p.id + item.label)}
                      style={{ width: "100%", background: "none", border: "none", padding: "14px 0", display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer" }}>
                      <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.ink, fontWeight: 400 }}>{item.label}</span>
                      <span style={{ color: T.inkGhost, fontSize: 18 }}>{expanded === p.id + item.label ? "−" : "+"}</span>
                    </button>
                    {expanded === p.id + item.label && (
                      <div style={{ paddingBottom: 16 }}>
                        <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkSoft, fontWeight: 300, lineHeight: 1.8 }}>{item.content}</span>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              <a href={p.url} target="_blank" rel="noopener noreferrer"
                style={{ display: "block", width: "100%", background: T.ink, color: T.ivory, border: "none", borderRadius: 2, padding: "16px", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.16em", textTransform: "uppercase", cursor: "pointer", textAlign: "center", textDecoration: "none", marginTop: 24, boxSizing: "border-box" }}>
                Shop Now
              </a>

              <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 11, color: T.inkGhost, textAlign: "center", lineHeight: 1.7, margin: "16px 0 0" }}>
                *These statements have not been evaluated by the FDA. This product is not intended to diagnose, treat, cure, or prevent any disease.
              </p>
            </div>
          </div>
        </FadeIn>
      ))}

      <div style={{ padding: "32px 24px 0", textAlign: "center" }}>
        <Serif size={13} italic color={T.inkGhost}>Free shipping on orders over $50 · purereve.com</Serif>
      </div>
    </div>
  );
};
const SEED_VENTS = [
  { id: 1, text: "I feel like I am carrying everything alone today and no one sees how heavy it is.", faded: false, encouragements: ["You are seen here. This weight you carry is real — and so is your strength.", "You are not invisible. We see you."] },
  { id: 2, text: "I failed at something I worked so hard for and I don't know how to begin again.", faded: false, encouragements: ["Every master was once a beginner who refused to quit. Your effort was never wasted."] },
  { id: 3, text: "I am exhausted in a way that sleep doesn't fix.", faded: false, encouragements: ["Rest your soul, not just your body. You are allowed to simply be."] },
];
// eslint-disable-next-line no-unused-vars
const ExchangeInput = ({ value, onChange, dimColor, textColor, accentColor }) => (
  <textarea value={value} onChange={e => onChange(e.target.value)} rows={4}
    placeholder="Start anywhere..."
    style={{ width: "100%", background: "none", border: "none", borderBottom: "1px solid " + dimColor, padding: "10px 0", fontFamily: "'Cormorant Garamond', serif", fontSize: 16, fontStyle: "italic", color: textColor, outline: "none", caretColor: accentColor, resize: "none", lineHeight: 1.9, boxSizing: "border-box", marginBottom: 16 }}
  />
);

// eslint-disable-next-line no-unused-vars
const WitnessInput = ({ value, onChange, dimColor, textColor, accentColor }) => (
  <textarea value={value} onChange={e => onChange(e.target.value)} rows={4}
    placeholder="What do you need them to witness?"
    style={{ width: "100%", background: "none", border: "none", borderBottom: "1px solid " + dimColor, padding: "10px 0", fontFamily: "'Cormorant Garamond', serif", fontSize: 16, fontStyle: "italic", color: textColor, outline: "none", caretColor: accentColor, resize: "none", lineHeight: 1.9, boxSizing: "border-box", marginBottom: 16 }}
  />
);


const SanctuaryTwo = ({ user, setScreen }) => {
  const [phase, setPhase] = useState("home"); // home | create | join | waiting | together | breathe | exchange | witness
  const [code, setCode] = useState("");
  const [inputCode, setInputCode] = useState("");
  const [sessionId, setSessionId] = useState(null);
  const [role, setRole] = useState(null); // 'a' or 'b'
  const [breathPhase, setBreathPhase] = useState("ready");
  const [breathCount, setBreathCount] = useState(0);
  const [myText, setMyText] = useState("");
  const [theirText, setTheirText] = useState("");
  const [revealed, setRevealed] = useState(false);
  const [myReady, setMyReady] = useState(false);
  const [candleTime, setCandleTime] = useState(60);
  const [candleActive, setCandleActive] = useState(false);
  const [myShare, setMyShare] = useState("");
  const [error, setError] = useState("");

  const bgColor = "radial-gradient(ellipse at center, #0D3B5E 0%, #071E30 70%, #050F1A 100%)";
  const textColor = "#C4B5A0";
  const dimColor = "#5A4F48";
  const accentColor = "#8B6914";

  const generateCode = () => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ234567";
    let result = "";
    for (let i = 0; i < 6; i++) result += chars[Math.floor(Math.random() * chars.length)];
    return result;
  };

  const createSession = async () => {
    const newCode = generateCode();
    const { data, error } = await supabase.from('sanctuary_sessions').insert([{
      code: newCode,
      user_a: user.id,
      state: { phase: "waiting", ritual: null, breath_phase: "ready" }
    }]).select().single();
    if (error) { setError("Could not create session. Try again."); return; }
    setCode(newCode);
    setSessionId(data.id);
    setRole('a');
    setPhase("waiting");
    subscribeToSession(data.id, 'a');
  };

  const joinSession = async () => {
    if (inputCode.length < 6) return;
    const { data, error } = await supabase.from('sanctuary_sessions')
      .select('*').eq('code', inputCode.toUpperCase()).single();
    if (error || !data) { setError("Code not found. Check and try again."); return; }
    // Allow rejoin
    await supabase.from('sanctuary_sessions').update({ user_b: user.id }).eq('id', data.id);
    setSessionId(data.id);
    setCode(data.code);
    setRole('b');
    setPhase("together");
    // session joined
    subscribeToSession(data.id, 'b');
    await supabase.from('sanctuary_sessions').update({ state: { phase: "together", ritual: null } }).eq('id', data.id);
  };

  const pollRef = useRef(null);
  const lastStateRef = useRef(null);

  const subscribeToSession = (id, myRole) => {
    // Poll every 2 seconds instead of realtime (more reliable on mobile)
    pollRef.current = setInterval(async () => {
      const { data } = await supabase.from('sanctuary_sessions').select('state, user_b').eq('id', id).single();
      if (!data) return;
      
      const state = data.state;
      const stateStr = JSON.stringify(state);
      if (stateStr === lastStateRef.current) return; // No change
      lastStateRef.current = stateStr;

      if (data.user_b && state.phase === "waiting") {
        await supabase.from('sanctuary_sessions').update({ state: { phase: "together" } }).eq('id', id);
        return;
      }
      if (state.phase === "together") { setPhase("together"); }
      if (state.phase === "breathe") { 
        setPhase("breathe"); 
        if (state.breath_phase) setBreathPhase(state.breath_phase);
      }
      if (state.phase === "exchange") { setPhase("exchange"); }
      if (state.phase === "witness") { setPhase("witness"); }
      if (state.phase === "closing") { setPhase("closing"); }
      if (state.phase === "left") { setPhase("left"); }
      
      if (myRole === 'a' && state.their_text) setTheirText(state.their_text);
      if (myRole === 'b' && state.my_text) setTheirText(state.my_text);
      if (state.revealed) setRevealed(true);
      if (myRole === 'b' && state.witness_share) setMyShare(state.witness_share);
      if (state.candle_active) { 
        setCandleActive(prev => { if (!prev) startCandle(); return true; });
      }
    }, 2000);
  };;

  const updateState = async (newState) => {
    if (!sessionId) return;
    await supabase.from('sanctuary_sessions').update({ state: newState }).eq('id', sessionId);
  };

  const startBreath = async () => {
    await updateState({ phase: "breathe", breath_phase: "in" });
    setBreathPhase("in");
    let count = 0;
    const cycle = async (p) => {
      if (p === "in") {
        setTimeout(async () => { await updateState({ phase: "breathe", breath_phase: "hold" }); cycle("hold"); }, 4000);
      } else if (p === "hold") {
        setTimeout(async () => { await updateState({ phase: "breathe", breath_phase: "out" }); cycle("out"); }, 4000);
      } else {
        setTimeout(async () => {
          count++;
          setBreathCount(count);
          if (count < 4) { await updateState({ phase: "breathe", breath_phase: "in" }); cycle("in"); }
          else { await updateState({ phase: "breathe", breath_phase: "done" }); setBreathPhase("done"); }
        }, 8000);
      }
    };
    cycle("in");
  };

// eslint-disable-next-line no-unused-vars
  const submitExchange = async () => {
    if (!myText.trim()) return;
    const key = role === 'a' ? 'my_text' : 'their_text';
    const state = { phase: "exchange", [key]: myText };
    await updateState(state);
  };

// eslint-disable-next-line no-unused-vars
  const revealExchange = async () => {
    await updateState({ phase: "exchange", revealed: true });
    setRevealed(true);
  };

  const startCandle = () => {
    let t = 60;
    const timer = setInterval(() => {
      t--;
      setCandleTime(t);
      if (t <= 0) clearInterval(timer);
    }, 1000);
  };


  const leaveSession = async () => {
    if (sessionId) await updateState({ left: true, phase: "left" });
    if (pollRef.current) clearInterval(pollRef.current);
    setScreen("home");
  };


  const Wrapper = ({ children }) => (
    <div style={{ position: "fixed", inset: 0, background: bgColor, zIndex: 600, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "40px 28px", overflowY: "auto" }}>
      <button onClick={leaveSession} style={{ position: "absolute", top: 20, right: 20, background: "none", border: "none", color: dimColor, fontFamily: "'Jost', sans-serif", fontSize: 13, cursor: "pointer" }}>Leave</button>
      <div style={{ width: "100%", maxWidth: 360, textAlign: "center" }}>{children}</div>
    </div>
  );

  if (phase === "left") return (
    <Wrapper>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 22, fontStyle: "italic", color: textColor, lineHeight: 1.9, marginBottom: 32 }}>
        They've stepped away.<br/>The sanctuary remains open for you.
      </p>
      <button onClick={() => setScreen("home")} style={{ background: "none", border: "1px solid " + dimColor, borderRadius: 2, padding: "14px 28px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.14em", color: textColor, cursor: "pointer" }}>
        Return to sanctuary
      </button>
    </Wrapper>
  );

  if (phase === "home") return (
    <Wrapper>
      <img src="/pure-reve-icon-light.svg" style={{ width: 52, height: 52, display: "block", margin: "0 auto 24px", opacity: 0.7 }} alt="Pure Reve" />
      <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: dimColor, letterSpacing: "0.2em", marginBottom: 16 }}>SANCTUARY FOR TWO</p>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 26, fontStyle: "italic", color: textColor, lineHeight: 1.6, marginBottom: 12 }}>
        A shared space for two.
      </p>
      <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: dimColor, fontWeight: 300, lineHeight: 1.9, marginBottom: 40 }}>
        No chat. No video. Just presence.<br/>Three rituals. Nothing saved.
      </p>
      <button onClick={createSession} style={{ width: "100%", background: "none", border: "1px solid " + dimColor, borderRadius: 2, padding: "16px", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.14em", color: textColor, cursor: "pointer", marginBottom: 12 }}>
        Invite someone in
      </button>
      <button onClick={() => setPhase("join")} style={{ width: "100%", background: "none", border: "1px solid " + dimColor, borderRadius: 2, padding: "16px", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.14em", color: textColor, cursor: "pointer" }}>
        Enter a sanctuary code
      </button>
    </Wrapper>
  );

  if (phase === "join") return (
    <Wrapper>
      <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: dimColor, letterSpacing: "0.2em", marginBottom: 24 }}>ENTER CODE</p>
      
      {/* Display boxes */}
      <div style={{ display: "flex", gap: 8, justifyContent: "center", marginBottom: 24 }}>
        {[0,1,2,3,4,5].map(i => (
          <div key={i} style={{ width: 44, height: 52, borderRadius: 2, border: "1px solid " + (inputCode.length === i ? accentColor : dimColor), display: "flex", alignItems: "center", justifyContent: "center", background: inputCode[i] ? "rgba(139,105,20,0.1)" : "none" }}>
            <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 20, color: textColor }}>{inputCode[i] || ""}</span>
          </div>
        ))}
      </div>

      {/* Character keypad */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 6, marginBottom: 16 }}>
        {"ABCDEFGHJKLMNPQRSTUVWXYZ234567".split("").slice(0, 30).map(ch => (
          <button key={ch} onClick={() => { if (inputCode.length < 6) setInputCode(prev => prev + ch); setError(""); }}
            style={{ background: "none", border: "1px solid " + dimColor, borderRadius: 2, padding: "10px 0", fontFamily: "'Jost', sans-serif", fontSize: 12, color: textColor, cursor: "pointer" }}>
            {ch}
          </button>
        ))}
      </div>

      <button onClick={() => setInputCode(prev => prev.slice(0, -1))}
        style={{ width: "100%", background: "none", border: "1px solid " + dimColor, borderRadius: 2, padding: "10px", fontFamily: "'Jost', sans-serif", fontSize: 13, color: dimColor, cursor: "pointer", marginBottom: 10, letterSpacing: "0.12em" }}>
        ← Delete
      </button>

      {error && <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: "#C0392B", marginBottom: 8 }}>{error}</p>}
      
      <button onClick={joinSession} style={{ width: "100%", border: "1px solid " + (inputCode.length === 6 ? accentColor : dimColor), background: "none", borderRadius: 2, padding: "14px", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.14em", color: inputCode.length === 6 ? textColor : dimColor, cursor: inputCode.length === 6 ? "pointer" : "default" }}>
        Enter the sanctuary →
      </button>
    </Wrapper>
  );

  
  if (phase === "waiting") return (
    <Wrapper>
      <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: dimColor, letterSpacing: "0.2em", marginBottom: 24 }}>YOUR SANCTUARY CODE</p>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 48, color: accentColor, letterSpacing: "0.3em", marginBottom: 12 }}>{code}</p>
      <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: dimColor, lineHeight: 1.9, marginBottom: 40 }}>
        Share this code with your person.<br/>Valid for 24 hours.<br/>Waiting for them to arrive...
      </p>
      <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
        {[0,1,2].map(i => (
          <div key={i} style={{ width: 6, height: 6, borderRadius: "50%", background: dimColor, animation: "pulse 1.5s " + (i * 0.5) + "s ease-in-out infinite" }} />
        ))}
      </div>
    </Wrapper>
  );

  if (phase === "together") return (
    <Wrapper>
      <img src="/pure-reve-icon-light.svg" style={{ width: 52, height: 52, display: "block", margin: "0 auto 20px", opacity: 0.8 }} alt="Pure Reve" />
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 28, fontStyle: "italic", color: textColor, lineHeight: 1.6, marginBottom: 8 }}>
        You are both here.
      </p>
      <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: dimColor, marginBottom: 40 }}>Choose a shared ritual.</p>
      
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <button onClick={() => { setPhase("breathe"); if (role === 'a') startBreath(); }}
          style={{ background: "none", border: "1px solid " + dimColor, borderRadius: 2, padding: "18px 20px", fontFamily: "'Cormorant Garamond', serif", fontSize: 18, fontStyle: "italic", color: textColor, cursor: "pointer", textAlign: "left" }}>
          Breathe Together
          <span style={{ display: "block", fontFamily: "'Jost', sans-serif", fontSize: 12, color: dimColor, fontStyle: "normal", marginTop: 4 }}>Synchronized. In silence. Just presence.</span>
        </button>
        <button onClick={() => { setPhase("exchange"); updateState({ phase: "exchange" }); }}
          style={{ background: "none", border: "1px solid " + dimColor, borderRadius: 2, padding: "18px 20px", fontFamily: "'Cormorant Garamond', serif", fontSize: 18, fontStyle: "italic", color: textColor, cursor: "pointer", textAlign: "left" }}>
          The Exchange
          <span style={{ display: "block", fontFamily: "'Jost', sans-serif", fontSize: 12, color: dimColor, fontStyle: "normal", marginTop: 4 }}>Each writes. Both revealed at once.</span>
        </button>
        <button onClick={() => { setPhase("witness"); updateState({ phase: "witness" }); }}
          style={{ background: "none", border: "1px solid " + dimColor, borderRadius: 2, padding: "18px 20px", fontFamily: "'Cormorant Garamond', serif", fontSize: 18, fontStyle: "italic", color: textColor, cursor: "pointer", textAlign: "left" }}>
          Witness & Release
          <span style={{ display: "block", fontFamily: "'Jost', sans-serif", fontSize: 12, color: dimColor, fontStyle: "normal", marginTop: 4 }}>One shares. One holds a candle. No words.</span>
        </button>
      </div>
    </Wrapper>
  );

  if (phase === "breathe") return (
    <Wrapper>
      <style>{`
        @keyframes s2breatheIn { from { transform: scale(0.7); opacity: 0.4; } to { transform: scale(1.5); opacity: 1; } }
        @keyframes s2breatheHold { from { transform: scale(1.5); opacity: 1; } to { transform: scale(1.5); opacity: 1; } }
        @keyframes s2breatheOut { from { transform: scale(1.5); opacity: 1; } to { transform: scale(0.7); opacity: 0.3; } }
        @keyframes s2breatheReady { from { transform: scale(1); opacity: 0.6; } to { transform: scale(1.1); opacity: 0.8; } }
      `}</style>
      <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: dimColor, letterSpacing: "0.2em", marginBottom: 40 }}>BREATHING TOGETHER</p>
      
      <div style={{ position: "relative", width: 180, height: 180, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 40px" }}>
        <div style={{
          position: "absolute", width: "100%", height: "100%", borderRadius: "50%",
          background: "radial-gradient(circle, " + accentColor + "25 0%, transparent 70%)",
          animation: breathPhase === "in" ? "s2breatheIn 4s ease-in-out forwards" :
                     breathPhase === "hold" ? "s2breatheHold 4s linear forwards" :
                     breathPhase === "out" ? "s2breatheOut 8s ease-in-out forwards" :
                     breathPhase === "done" ? "none" : "s2breatheReady 2s ease-in-out infinite alternate",
        }} />
        <img src="/pure-reve-icon-light.svg" style={{
          width: 72, height: 72, position: "relative", zIndex: 1,
          animation: breathPhase === "in" ? "s2breatheIn 4s ease-in-out forwards" :
                     breathPhase === "hold" ? "s2breatheHold 4s linear forwards" :
                     breathPhase === "out" ? "s2breatheOut 8s ease-in-out forwards" :
                     breathPhase === "done" ? "none" : "s2breatheReady 2s ease-in-out infinite alternate",
        }} alt="Pure Reve" />
      </div>

      {breathPhase === "ready" && (
        <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 22, fontStyle: "italic", color: textColor, lineHeight: 1.8 }}>
          Ready when you both are.
        </p>
      )}

      {breathPhase !== "ready" && breathPhase !== "done" && (
        <>
          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 30, fontStyle: "italic", color: textColor, marginBottom: 8 }}>
            {breathPhase === "in" ? "Breathe in..." : breathPhase === "hold" ? "Hold..." : "Breathe out..."}
          </p>
          <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: dimColor, letterSpacing: "0.12em", marginBottom: 4 }}>
            {breathPhase === "in" ? "4 seconds" : breathPhase === "hold" ? "4 seconds" : "8 seconds"}
          </p>
          <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: dimColor, letterSpacing: "0.1em" }}>
            Cycle {Math.min(breathCount + 1, 4)} of 4
          </p>
        </>
      )}

      {breathPhase === "done" && (
        <div style={{ textAlign: "center" }}>
          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 24, fontStyle: "italic", color: textColor, lineHeight: 1.8, marginBottom: 32 }}>
            You breathed together. ✦
          </p>
          <button onClick={async () => { setPhase("together"); await supabase.from('sanctuary_sessions').update({ state: { phase: "together" } }).eq('id', sessionId); }}
            style={{ width: "100%", background: "none", border: "1px solid " + dimColor, borderRadius: 2, padding: "14px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.14em", color: textColor, cursor: "pointer", marginBottom: 10 }}>
            Continue together →
          </button>
          <button onClick={async () => { setPhase("closing"); await supabase.from('sanctuary_sessions').update({ state: { phase: "closing" } }).eq('id', sessionId); }}
            style={{ width: "100%", background: "none", border: "none", fontFamily: "'Jost', sans-serif", fontSize: 12, color: dimColor, cursor: "pointer", letterSpacing: "0.12em", padding: "10px" }}>
            We're done for tonight
          </button>
        </div>
      )}
    </Wrapper>
  );

  
  if (phase === "exchange") return (
    <div style={{ position: "fixed", inset: 0, background: bgColor, zIndex: 600, overflowY: "auto", WebkitOverflowScrolling: "touch" }}>
      <div style={{ minHeight: "100vh", padding: "60px 28px 40px", display: "flex", flexDirection: "column", maxWidth: 430, margin: "0 auto" }}>
        <button onClick={leaveSession} style={{ position: "absolute", top: 20, right: 20, background: "none", border: "none", color: dimColor, fontFamily: "'Jost', sans-serif", fontSize: 13, cursor: "pointer", letterSpacing: "0.12em" }}>Leave</button>
        <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: dimColor, letterSpacing: "0.2em", marginBottom: 24 }}>THE EXCHANGE</p>
      {!revealed ? (
        <>
          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 17, fontStyle: "italic", color: textColor, lineHeight: 1.8, marginBottom: 20 }}>
            Write what you're carrying.<br/>Write what you're grateful for about them.<br/>Both revealed at the same moment.
          </p>
          <textarea
            defaultValue={myText}
            onBlur={e => setMyText(e.target.value)}
            onInput={e => setMyText(e.target.value)}
            rows={6}
            placeholder="Start anywhere..."
            style={{ width: "100%", background: "none", border: "none", borderBottom: "1px solid " + dimColor, padding: "10px 0", fontFamily: "'Cormorant Garamond', serif", fontSize: 16, fontStyle: "italic", color: textColor, outline: "none", caretColor: accentColor, resize: "none", lineHeight: 1.9, boxSizing: "border-box", marginBottom: 20 }}
          />
          <button onClick={async () => { const text = document.querySelector('textarea').value; setMyText(text); const key = role === 'a' ? 'my_text' : 'their_text'; await supabase.from('sanctuary_sessions').update({ state: { phase: "exchange", [key]: text } }).eq('id', sessionId); setMyReady(true); }}
            style={{ width: "100%", background: "none", border: "1px solid " + accentColor, borderRadius: 2, padding: "13px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.14em", color: textColor, cursor: "pointer", marginBottom: 10 }}>
            I'm ready ✦
          </button>
          {myReady && !theirText && <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: dimColor, textAlign: "center", marginTop: 8 }}>Waiting for them...</p>}
          {myReady && theirText && (
            <button onClick={async () => { await supabase.from('sanctuary_sessions').update({ state: { phase: "exchange", revealed: true } }).eq('id', sessionId); setRevealed(true); }}
              style={{ width: "100%", background: accentColor + "22", border: "1px solid " + accentColor, borderRadius: 2, padding: "13px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.14em", color: textColor, cursor: "pointer" }}>
              Both ready — Reveal ✦
            </button>
          )}
        </>
      ) : (
        <div>
          <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: dimColor, letterSpacing: "0.16em", marginBottom: 8 }}>YOU</p>
          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 17, fontStyle: "italic", color: textColor, lineHeight: 1.9, marginBottom: 24, paddingLeft: 12, borderLeft: "1px solid " + dimColor }}>{myText}</p>
          <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: dimColor, letterSpacing: "0.16em", marginBottom: 8 }}>THEM</p>
          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 17, fontStyle: "italic", color: textColor, lineHeight: 1.9, marginBottom: 32, paddingLeft: 12, borderLeft: "1px solid " + accentColor }}>{theirText || "Still writing..."}</p>
          <button onClick={async () => { setPhase("together"); await supabase.from('sanctuary_sessions').update({ state: { phase: "together" } }).eq('id', sessionId); }}
            style={{ width: "100%", background: "none", border: "1px solid " + dimColor, borderRadius: 2, padding: "14px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.14em", color: textColor, cursor: "pointer", marginBottom: 10 }}>
            Continue together →
          </button>
          <button onClick={async () => { setPhase("closing"); await supabase.from('sanctuary_sessions').update({ state: { phase: "closing" } }).eq('id', sessionId); }}
            style={{ width: "100%", background: "none", border: "none", fontFamily: "'Jost', sans-serif", fontSize: 12, color: dimColor, cursor: "pointer", letterSpacing: "0.12em", padding: "10px" }}>
            We're done for tonight
          </button>
        </div>
      )}
      </div>
    </div>
  );

  
  if (phase === "witness") return (
    <div style={{ position: "fixed", inset: 0, background: bgColor, zIndex: 600, overflowY: "auto", WebkitOverflowScrolling: "touch" }}>
      <div style={{ minHeight: "100vh", padding: "60px 28px 40px", display: "flex", flexDirection: "column" }}>
        <button onClick={leaveSession} style={{ position: "absolute", top: 20, right: 20, background: "none", border: "none", color: dimColor, fontFamily: "'Jost', sans-serif", fontSize: 13, cursor: "pointer", letterSpacing: "0.12em" }}>Leave</button>
        <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: dimColor, letterSpacing: "0.2em", marginBottom: 24 }}>WITNESS & RELEASE</p>
      {role === 'a' ? (
        <>
          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 17, fontStyle: "italic", color: textColor, lineHeight: 1.8, marginBottom: 20 }}>
            Share something hard.<br/>They will hold space for 60 seconds.<br/>No words. Just witness.
          </p>
          <textarea
            defaultValue={myShare}
            onBlur={e => setMyShare(e.target.value)}
            onInput={e => setMyShare(e.target.value)}
            rows={6}
            placeholder="What do you need them to witness?"
            style={{ width: "100%", background: "none", border: "none", borderBottom: "1px solid " + dimColor, padding: "10px 0", fontFamily: "'Cormorant Garamond', serif", fontSize: 16, fontStyle: "italic", color: textColor, outline: "none", caretColor: accentColor, resize: "none", lineHeight: 1.9, boxSizing: "border-box", marginBottom: 20 }}
          />
          <button onClick={async () => { const text = document.querySelectorAll('textarea')[0].value; setMyShare(text); await supabase.from('sanctuary_sessions').update({ state: { phase: "witness", witness_share: text, candle_active: true } }).eq('id', sessionId); startCandle(); }}
            style={{ width: "100%", background: "none", border: "1px solid " + accentColor, borderRadius: 2, padding: "13px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.14em", color: textColor, cursor: "pointer" }}>
            Share & begin ✦
          </button>
          {candleActive && (
            <div style={{ marginTop: 32, textAlign: "center" }}>
              <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 48, color: accentColor, marginBottom: 8 }}>🕯</p>
              <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: dimColor, marginBottom: candleTime <= 0 ? 16 : 0 }}>They are holding space · {candleTime > 0 ? candleTime + "s" : "✦"}</p>
              {candleTime <= 0 && (
                <div style={{ marginTop: 16 }}>
                  <button onClick={async () => { setPhase("together"); await supabase.from('sanctuary_sessions').update({ state: { phase: "together" } }).eq('id', sessionId); }}
                    style={{ width: "100%", background: "none", border: "1px solid " + dimColor, borderRadius: 2, padding: "12px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.14em", color: textColor, cursor: "pointer", marginBottom: 8 }}>
                    Continue together →
                  </button>
                  <button onClick={async () => { setPhase("closing"); await supabase.from('sanctuary_sessions').update({ state: { phase: "closing" } }).eq('id', sessionId); }}
                    style={{ width: "100%", background: "none", border: "none", fontFamily: "'Jost', sans-serif", fontSize: 12, color: dimColor, cursor: "pointer", letterSpacing: "0.12em" }}>
                    We're done for tonight
                  </button>
                </div>
              )}
            </div>
          )}
        </>
      ) : (
        <>
          {myShare ? (
            <div style={{ textAlign: "center" }}>
              <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 17, fontStyle: "italic", color: textColor, lineHeight: 1.9, marginBottom: 28, paddingLeft: 12, borderLeft: "1px solid " + dimColor, textAlign: "left" }}>{myShare}</p>
              <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 52, color: accentColor, marginBottom: 12 }}>🕯</p>
              <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontStyle: "italic", color: textColor, lineHeight: 1.8, marginBottom: 8 }}>Hold this space.</p>
              <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: dimColor }}>No words needed · {candleTime > 0 ? candleTime + "s" : "✦"}</p>
              {candleTime <= 0 && (
                <div style={{ marginTop: 24 }}>
                  <button onClick={async () => { setPhase("together"); await supabase.from('sanctuary_sessions').update({ state: { phase: "together" } }).eq('id', sessionId); }}
                    style={{ width: "100%", background: "none", border: "1px solid " + dimColor, borderRadius: 2, padding: "12px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.14em", color: textColor, cursor: "pointer", marginBottom: 8 }}>
                    Continue together →
                  </button>
                  <button onClick={async () => { setPhase("closing"); await supabase.from('sanctuary_sessions').update({ state: { phase: "closing" } }).eq('id', sessionId); }}
                    style={{ width: "100%", background: "none", border: "none", fontFamily: "'Jost', sans-serif", fontSize: 12, color: dimColor, cursor: "pointer", letterSpacing: "0.12em" }}>
                    We're done for tonight
                  </button>
                </div>
              )}
            </div>
          ) : (
            <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontStyle: "italic", color: textColor, lineHeight: 1.8 }}>Waiting for them to share...</p>
          )}
        </>
      )}
      </div>
    </div>
  );

  
  if (phase === "closing") return (
    <Wrapper>
      <img src="/pure-reve-icon-light.svg" style={{ width: 52, height: 52, display: "block", margin: "0 auto 24px", opacity: 0.7 }} alt="Pure Reve" />
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 26, fontStyle: "italic", color: textColor, lineHeight: 1.8, marginBottom: 16 }}>You showed up for each other.</p>
      <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: dimColor, fontWeight: 300, lineHeight: 1.9, marginBottom: 32 }}>This session is now closed.<br/>Nothing was saved.<br/>What happened here stays here.</p>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 15, fontStyle: "italic", color: dimColor, marginBottom: 40 }}>"Two are better than one." — Ecclesiastes 4:9</p>
      <button onClick={() => setScreen("home")} style={{ background: "none", border: "1px solid " + dimColor, borderRadius: 2, padding: "14px 28px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.14em", color: textColor, cursor: "pointer" }}>
        Return to sanctuary
      </button>
    </Wrapper>
  );

  return null;
};


const GriefMode = ({ setScreen }) => {
  const [page, setPage] = useState(0);

  const bgColor = "radial-gradient(ellipse at center, #0D3B5E 0%, #071E30 70%, #050F1A 100%)";
  const textColor = "#EDE5D8";
  const dimColor = "#8B7A6A";
  const softColor = "#C4B5A0";

  const pages = [
    {
      top: null,
      title: "You don't have to be okay today.",
      body: "This is not a space for breathing exercises or silver linings. There is nothing to fix here. You are allowed to simply be in this.",
      action: null,
    },
    {
      top: "YOU ARE ALLOWED TO",
      title: null,
      items: [
        "Feel exactly what you feel",
        "Not have words for it",
        "Cry without a reason",
        "Miss someone who hurt you",
        "Grieve something others don't understand",
        "Not be ready to move on",
        "Take as long as you need",
      ],
      action: null,
    },
    {
      top: "A WITNESS",
      title: "Someone sees you carrying this.",
      body: "Not to fix it. Not to rush it. Just to acknowledge that what you are going through is real, and it is heavy, and you are allowed to feel the full weight of it.",
      action: null,
    },
    {
      top: "WHEN YOU ARE READY",
      title: null,
      body: "Not today. Maybe not tomorrow. But when you are ready — Pure Rêve will be here. The sanctuary does not close.",
      verse: '"He heals the brokenhearted and binds up their wounds." — Psalm 147:3',
      action: "Return to sanctuary",
    },
  ];

  const current = pages[page];

  return (
    <div style={{ position: "fixed", inset: 0, background: bgColor, zIndex: 600, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "48px 32px", overflowY: "auto" }}>
      <button onClick={() => setScreen("home")}
        style={{ position: "absolute", top: 20, right: 20, background: "none", border: "none", color: dimColor, fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.12em", cursor: "pointer" }}>
        Leave
      </button>

      <div style={{ maxWidth: 360, width: "100%", textAlign: "center" }}>
        {current.top && (
          <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: dimColor, letterSpacing: "0.22em", marginBottom: 32 }}>
            {current.top}
          </p>
        )}

        {current.title && (
          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 28, fontStyle: "italic", color: textColor, lineHeight: 1.6, marginBottom: 28 }}>
            {current.title}
          </p>
        )}

        {current.body && (
          <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 14, color: softColor, fontWeight: 300, lineHeight: 2, marginBottom: 28 }}>
            {current.body}
          </p>
        )}

        {current.items && (
          <div style={{ textAlign: "left", marginBottom: 32 }}>
            {current.items.map((item, i) => (
              <p key={i} style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontStyle: "italic", color: textColor, lineHeight: 1.9, margin: "0 0 4px", paddingLeft: 16, borderLeft: "1px solid " + dimColor }}>
                {item}
              </p>
            ))}
          </div>
        )}

        {current.verse && (
          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 15, fontStyle: "italic", color: dimColor, lineHeight: 1.9, margin: "0 0 40px" }}>
            {current.verse}
          </p>
        )}

        <div style={{ display: "flex", justifyContent: "center", gap: 16, marginTop: 16 }}>
          {page > 0 && (
            <button onClick={() => setPage(page - 1)}
              style={{ background: "none", border: "none", color: dimColor, fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.12em", cursor: "pointer" }}>
              ← Back
            </button>
          )}
          {current.action ? (
            <button onClick={() => setScreen("home")}
              style={{ background: "none", border: "1px solid " + dimColor, borderRadius: 2, padding: "14px 28px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.16em", color: textColor, cursor: "pointer" }}>
              {current.action}
            </button>
          ) : (
            <button onClick={() => setPage(page + 1)}
              style={{ background: "none", border: "1px solid " + dimColor, borderRadius: 2, padding: "14px 28px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.16em", color: textColor, cursor: "pointer" }}>
              Continue →
            </button>
          )}
        </div>

        <div style={{ display: "flex", justifyContent: "center", gap: 8, marginTop: 32 }}>
          {pages.map((_, i) => (
            <div key={i} style={{ width: 4, height: 4, borderRadius: "50%", background: i === page ? softColor : dimColor }} />
          ))}
        </div>
      </div>
    </div>
  );
};


const UnsentLetter = ({ setScreen }) => {
  const [to, setTo] = useState("");
  const [body, setBody] = useState("");
  const [phase, setPhase] = useState("write"); // write | burning | gone
  const [showPrompts, setShowPrompts] = useState(false);

  const bgColor = "#0D3B5E";
  const textColor = "#EDE5D8";
  const dimColor = "#8B7A6A";
  const accentColor = "#8B6914";

  const prompts = [
    "What I never got to say to you...",
    "What I wish you knew...",
    "What I forgive you for...",
    "What I forgive myself for...",
    "What I'm finally letting go of...",
    "What I would say if you could hear me...",
    "Dear younger me...",
    "Dear grief...",
    "Dear fear...",
  ];

  const handleBurn = () => {
    if (!body.trim()) return;
    setPhase("burning");
    setTimeout(() => setPhase("gone"), 3000);
  };

  const getMidnightMsg = () => {
    const now = new Date();
    const midnight = new Date();
    midnight.setHours(24, 0, 0, 0);
    const diff = Math.round((midnight - now) / 60000);
    if (diff < 60) return diff + " minutes until midnight";
    return Math.round(diff / 60) + " hours until midnight";
  };

  if (phase === "burning") return (
    <div style={{ position: "fixed", inset: 0, background: bgColor, zIndex: 600, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "40px 28px" }}>
      <style>{`
        @keyframes burnUp {
          0% { opacity: 1; transform: translateY(0) scaleY(1); filter: brightness(1); }
          30% { opacity: 0.8; transform: translateY(-4px) scaleY(0.97); filter: brightness(1.4) sepia(0.8); color: #C4701A; }
          60% { opacity: 0.4; transform: translateY(-12px) scaleY(0.9); filter: brightness(1.8) sepia(1); color: #8B4010; }
          100% { opacity: 0; transform: translateY(-30px) scaleY(0.7); filter: brightness(2) sepia(1); }
        }
        @keyframes emberGlow {
          0% { opacity: 0; }
          20% { opacity: 1; }
          80% { opacity: 0.6; }
          100% { opacity: 0; }
        }
        @keyframes ashFall {
          0% { opacity: 0; transform: translateY(0) rotate(0deg); }
          20% { opacity: 0.4; }
          100% { opacity: 0; transform: translateY(60px) rotate(45deg); }
        }
      `}</style>
      <div style={{ width: "100%", maxWidth: 360, position: "relative" }}>
        {/* Burning letter text */}
        <div style={{ 
          animation: "burnUp 3s ease-in forwards",
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: 16, fontStyle: "italic",
          color: textColor, lineHeight: 1.9,
          marginBottom: 16, opacity: 1,
          transformOrigin: "bottom center",
        }}>
          {body.split('\n').slice(0, 6).map((line, i) => (
            <p key={i} style={{ 
              margin: "0 0 4px",
              animation: `burnUp ${2.5 + i * 0.15}s ${i * 0.1}s ease-in forwards`,
              transformOrigin: "bottom center",
            }}>{line || " "}</p>
          ))}
        </div>

        {/* Ember glow effect */}
        <div style={{
          position: "absolute", bottom: 0, left: "50%", transform: "translateX(-50%)",
          width: 120, height: 40,
          background: "radial-gradient(ellipse, rgba(180,80,20,0.6) 0%, transparent 70%)",
          animation: "emberGlow 3s ease-in-out forwards",
          borderRadius: "50%",
        }} />

        {/* Floating ash particles */}
        {[...Array(6)].map((_, i) => (
          <div key={i} style={{
            position: "absolute",
            bottom: 20 + Math.random() * 20,
            left: `${30 + i * 8}%`,
            width: 3, height: 3,
            borderRadius: "50%",
            background: "#8B6914",
            animation: `ashFall ${2 + i * 0.3}s ${0.5 + i * 0.2}s ease-in forwards`,
            opacity: 0,
          }} />
        ))}
      </div>
    </div>
  );

  if (phase === "gone") return (
    <div style={{ position: "fixed", inset: 0, background: bgColor, zIndex: 600, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "40px 28px" }}>
      <img src="/pure-reve-icon-light.svg" style={{ width: 56, height: 56, display: "block", margin: "0 auto 28px", opacity: 0.7 }} alt="Pure Reve" />
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 26, fontStyle: "italic", color: textColor, textAlign: "center", lineHeight: 1.9, marginBottom: 24 }}>
        You said what needed<br/>to be said.
      </p>
      <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: dimColor, letterSpacing: "0.1em", textAlign: "center", lineHeight: 1.9, marginBottom: 48 }}>
        Nothing was saved.<br/>Nothing was sent.<br/>You are lighter now.
      </p>
      <button onClick={() => setScreen("home")}
        style={{ background: "none", border: "1px solid " + dimColor, borderRadius: 2, padding: "14px 32px", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.16em", color: textColor, cursor: "pointer" }}>
        Return to sanctuary
      </button>
    </div>
  );

  return (
    <div style={{ position: "fixed", inset: 0, background: bgColor, zIndex: 600, display: "flex", flexDirection: "column", padding: "60px 28px 40px", overflowY: "auto" }}>
      <button onClick={() => setScreen("home")}
        style={{ position: "absolute", top: 20, right: 20, background: "none", border: "none", color: dimColor, fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.12em", cursor: "pointer" }}>
        Leave
      </button>

      <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: dimColor, letterSpacing: "0.2em", marginBottom: 32 }}>THE UNSENT LETTER</p>

      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 18, fontStyle: "italic", color: textColor, lineHeight: 1.9, marginBottom: 32 }}>
        Write to someone you can't talk to.<br/>
        This letter will never be sent.<br/>
        Nothing is saved.
      </p>

      <div style={{ marginBottom: 20 }}>
        <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: dimColor, letterSpacing: "0.14em", marginBottom: 8 }}>TO</p>
        <input
          value={to}
          onChange={e => setTo(e.target.value)}
          placeholder="a person, yourself, grief, fear, the past..."
          style={{ width: "100%", background: "none", border: "none", borderBottom: "1px solid " + dimColor, padding: "10px 0", fontFamily: "'Cormorant Garamond', serif", fontSize: 18, fontStyle: "italic", color: textColor, outline: "none", caretColor: accentColor, boxSizing: "border-box" }}
        />
      </div>

      <div style={{ marginBottom: 16, flex: 1 }}>
        <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: dimColor, letterSpacing: "0.14em", marginBottom: 8 }}>YOUR LETTER</p>
        <textarea
          value={body}
          onChange={e => setBody(e.target.value)}
          placeholder="Start anywhere. There is no right way to begin."
          rows={10}
          style={{ width: "100%", background: "none", border: "none", borderBottom: "1px solid " + dimColor, padding: "10px 0", fontFamily: "'Cormorant Garamond', serif", fontSize: 17, fontStyle: "italic", color: textColor, outline: "none", caretColor: accentColor, resize: "none", lineHeight: 1.9, boxSizing: "border-box" }}
          autoFocus
        />
      </div>

      <button onClick={() => setShowPrompts(!showPrompts)}
        style={{ background: "none", border: "none", fontFamily: "'Jost', sans-serif", fontSize: 12, color: dimColor, letterSpacing: "0.12em", cursor: "pointer", textAlign: "left", marginBottom: 12, padding: 0 }}>
        {showPrompts ? "Hide prompts" : "Need a prompt? ✦"}
      </button>

      {showPrompts && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 20 }}>
          {prompts.map(p => (
            <button key={p} onClick={() => { setBody(p); setShowPrompts(false); }}
              style={{ background: "none", border: "1px solid " + dimColor, borderRadius: 2, padding: "6px 12px", fontFamily: "'Jost', sans-serif", fontWeight: 300, fontSize: 14, fontStyle: "italic", color: textColor, cursor: "pointer" }}>
              {p}
            </button>
          ))}
        </div>
      )}

      <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: "#5A4F48", lineHeight: 1.8, margin: "8px 0 16px", textAlign: "center" }}>If you are in crisis, call or text <strong style={{ color: "#8B6914" }}>988</strong> or call <strong style={{ color: "#8B6914" }}>911</strong>. Pure Rêve is not a crisis service.</p>
          <button onClick={handleBurn}
        style={{ width: "100%", background: "none", border: "1px solid " + (body.trim() ? accentColor : dimColor), borderRadius: 2, padding: "16px", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.18em", color: body.trim() ? textColor : dimColor, cursor: body.trim() ? "pointer" : "default", marginTop: 16 }}>
        {body.trim() ? "Burn this letter ✦" : "Write your letter first..."}
      </button>

      <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: dimColor, textAlign: "center", margin: "16px 0 0", letterSpacing: "0.1em" }}>
        {getMidnightMsg()}
      </p>
    </div>
  );
};


const Wall3am = ({ setScreen }) => {
  const [mode, setMode] = useState(null); // null | 'breathe' | 'vent' | 'here'
  const [ventText, setVentText] = useState("");
  const [ventDone, setVentDone] = useState(false);
  const [breathPhase, setBreathPhase] = useState("ready");
  const [breathCount, setBreathCount] = useState(0);

  const hour = new Date().getHours();
  const isNight = hour >= 23 || hour < 4;

  const bgColor = "radial-gradient(ellipse at center, #0D3B5E 0%, #071E30 70%, #050F1A 100%)";
  const textColor = "#C4B5A0";
  const dimColor = "#6B5D52";
  const accentColor = "#8B6914";

  const startBreath = () => {
    setBreathPhase("in");
    let phase = "in";
    let count = 0;
    const cycle = () => {
      if (phase === "in") {
        setTimeout(() => { setBreathPhase("hold"); phase = "hold"; cycle(); }, 4000);
      } else if (phase === "hold") {
        setTimeout(() => { setBreathPhase("out"); phase = "out"; cycle(); }, 4000);
      } else {
        setTimeout(() => {
          count++;
          setBreathCount(count);
          if (count < 4) { setBreathPhase("in"); phase = "in"; cycle(); }
          else { setBreathPhase("done"); }
        }, 8000);
      }
    };
    cycle();
  };

  const handleVentSubmit = () => {
    if (!ventText.trim()) return;
    setVentDone(true);
    setTimeout(() => { setVentText(""); setVentDone(false); setMode(null); }, 3000);
  };

  if (mode === "breathe") {
    const getScale = () => breathPhase === "in" ? 1.4 : breathPhase === "hold" ? 1.4 : breathPhase === "out" ? 0.7 : 1;
    const getDuration = () => breathPhase === "in" ? "4s" : breathPhase === "hold" ? "0.3s" : breathPhase === "out" ? "8s" : "0.3s";
    const getLabel = () => breathPhase === "in" ? "Breathe in..." : breathPhase === "hold" ? "Hold..." : breathPhase === "out" ? "Breathe out..." : "";

    return (
      <div style={{ position: "fixed", inset: 0, background: bgColor, zIndex: 600, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "40px 28px" }}>
        <button onClick={() => { setMode(null); setBreathPhase("ready"); setBreathCount(0); }}
          style={{ position: "absolute", top: 24, left: 24, background: "none", border: "none", color: dimColor, fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.12em", cursor: "pointer" }}>
          ← Back
        </button>

        {breathPhase === "ready" && (
          <>
            <img src="/pure-reve-icon-light.svg" style={{ width: 80, height: 80, display: "block", margin: "0 auto 32px", objectFit: "contain" }} alt="Pure Reve" />
            <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 22, fontStyle: "italic", color: textColor, textAlign: "center", lineHeight: 1.8, marginBottom: 12 }}>
              Let's breathe together.
            </p>
            <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: dimColor, letterSpacing: "0.1em", marginBottom: 48 }}>Four slow cycles · 4 — 4 — 8</p>
            <button onClick={startBreath}
              style={{ background: "none", border: "1px solid " + dimColor, borderRadius: 2, padding: "14px 32px", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.16em", color: textColor, cursor: "pointer" }}>
              Begin
            </button>
          </>
        )}

        {breathPhase !== "ready" && breathPhase !== "done" && (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <div style={{ position: "relative", width: 180, height: 180, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 40 }}>
              <div style={{
                position: "absolute", borderRadius: "50%",
                width: "100%", height: "100%",
                background: "radial-gradient(circle, " + accentColor + "30 0%, transparent 70%)",
                transform: "scale(" + getScale() + ")",
                transition: "transform " + getDuration() + " ease-in-out, opacity " + getDuration() + " ease-in-out",
                opacity: breathPhase === "out" ? 0.2 : 0.8,
              }} />
              <div style={{
                width: 72, height: 72,
                position: "relative", zIndex: 1,
                transform: "scale(" + getScale() + ")",
                transition: "transform " + getDuration() + " ease-in-out, opacity " + getDuration() + " ease-in-out",
                opacity: breathPhase === "out" ? 0.3 : 1,
              }}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" width="100%" height="100%">
                  <circle cx="100" cy="100" r="88" fill="none" stroke="#D6C9B6" strokeWidth="0.5"/>
                  <circle cx="100" cy="100" r="64" fill="none" stroke="#EDE5D8" strokeWidth="0.5"/>
                  <path d="M100 18 C124 34 134 62 100 100 C66 138 76 162 100 182" fill="none" stroke="#C4B5A0" strokeWidth="1.6" strokeLinecap="round"/>
                  <path d="M76 26 C100 46 114 72 100 100 C86 128 66 142 74 170" fill="none" stroke="#8B6914" strokeWidth="1" strokeLinecap="round"/>
                  <path d="M122 28 C140 52 128 76 100 100 C72 124 82 152 98 178" fill="none" stroke="#D6C9B6" strokeWidth="0.6" strokeLinecap="round"/>
                  <circle cx="100" cy="100" r="4" fill="#8B6914"/>
                </svg></div>
            </div>
            <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 30, fontStyle: "italic", color: textColor, marginBottom: 8 }}>{getLabel()}</p>
            <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: dimColor, letterSpacing: "0.12em" }}>Cycle {breathCount + 1} of 4</p>
          </div>
        )}

        {breathPhase === "done" && (
          <>
            <img src="/pure-reve-icon-light.svg" style={{ width: 80, height: 80, display: "block", margin: "0 auto 32px", objectFit: "contain" }} alt="Pure Reve" />
            <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 26, fontStyle: "italic", color: textColor, textAlign: "center", lineHeight: 1.8, marginBottom: 48 }}>
              You breathed through it.<br/>That took courage.
            </p>
            <button onClick={() => { setMode(null); setBreathPhase("ready"); setBreathCount(0); }}
              style={{ background: "none", border: "1px solid " + dimColor, borderRadius: 2, padding: "14px 32px", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.16em", color: textColor, cursor: "pointer" }}>
              Return
            </button>
          </>
        )}
      </div>
    );
  }

  if (mode === "vent") return (
    <div style={{ position: "fixed", inset: 0, background: bgColor, zIndex: 600, display: "flex", flexDirection: "column", padding: "80px 28px 40px" }}>
      <button onClick={() => { setMode(null); setVentText(""); setVentDone(false); }}
        style={{ position: "absolute", top: 24, left: 24, background: "none", border: "none", color: dimColor, fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.12em", cursor: "pointer" }}>
        ← Back
      </button>
      {ventDone ? (
        <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 26, fontStyle: "italic", color: textColor, textAlign: "center", lineHeight: 1.8 }}>
            You said it out loud.<br/>That matters. ✦
          </p>
          <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: dimColor, marginTop: 16, letterSpacing: "0.1em" }}>
            Nothing was saved.
          </p>
        </div>
      ) : (
        <>
          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontStyle: "italic", color: textColor, lineHeight: 1.8, marginBottom: 24 }}>
            Say whatever you need to say.<br/>No one will read this. Nothing is saved.
          </p>
          <textarea value={ventText} onChange={e => setVentText(e.target.value)}
            placeholder="Start anywhere..."
            style={{ flex: 1, background: "none", border: "none", borderBottom: "1px solid " + dimColor, padding: "16px 0", fontFamily: "'Cormorant Garamond', serif", fontSize: 18, fontStyle: "italic", color: textColor, lineHeight: 1.9, resize: "none", outline: "none", caretColor: accentColor }}
            autoFocus
          />
          <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: "#5A4F48", lineHeight: 1.8, margin: "10px 0", textAlign: "center" }}>If you are in crisis, call or text <strong style={{ color: "#8B6914" }}>988</strong> or call <strong style={{ color: "#8B6914" }}>911</strong>. Pure Rêve is not a crisis service.</p>
          <button onClick={handleVentSubmit}
            style={{ marginTop: 24, background: "none", border: "1px solid " + dimColor, borderRadius: 2, padding: "14px", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.16em", color: textColor, cursor: "pointer", width: "100%" }}>
            Let it go ✦
          </button>
        </>
      )}
    </div>
  );

  if (mode === "here") return (
    <div style={{ position: "fixed", inset: 0, background: bgColor, zIndex: 600, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "40px 28px" }}>
      <button onClick={() => setMode(null)}
        style={{ position: "absolute", top: 24, left: 24, background: "none", border: "none", color: dimColor, fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.12em", cursor: "pointer" }}>
        ← Back
      </button>
      <p style={{ fontFamily: "'Jost', sans-serif", fontWeight: 300, fontSize: 14, color: dimColor, letterSpacing: "0.2em", marginBottom: 32 }}>PURE RÊVE<sup style={{ fontSize: "0.55em", letterSpacing: 0, marginLeft: 2, verticalAlign: "super" }}>™</sup></p>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 26, fontStyle: "italic", color: textColor, textAlign: "center", lineHeight: 1.9, marginBottom: 48 }}>
        You don't have to say anything.<br/>You don't have to do anything.<br/><br/>Just be here for a moment.<br/>You are not alone.
      </p>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 32, color: accentColor }}>✦</p>
      <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: dimColor, marginTop: 48, letterSpacing: "0.12em", textAlign: "center" }}>
        This moment will pass.<br/>You will be okay.
      </p>
    </div>
  );

  return (
    <div style={{ position: "fixed", inset: 0, background: bgColor, zIndex: 600, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "40px 28px", overflowY: "auto" }}>
      <button onClick={() => setScreen("home")}
        style={{ position: "absolute", top: 24, right: 24, background: "none", border: "none", color: dimColor, fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.12em", cursor: "pointer" }}>
        Leave
      </button>

      <p style={{ fontFamily: "'Jost', sans-serif", fontWeight: 300, fontSize: 14, color: dimColor, letterSpacing: "0.2em", marginBottom: 48 }}>
        {isNight ? "THE 3AM WALL" : "THE WALL · ALWAYS OPEN"}
      </p>

      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 30, fontStyle: "italic", color: textColor, textAlign: "center", lineHeight: 1.6, marginBottom: 16 }}>
        You're awake.
      </p>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 30, color: textColor, textAlign: "center", lineHeight: 1.6, marginBottom: 16 }}>
        You're not alone.
      </p>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontStyle: "italic", color: dimColor, textAlign: "center", lineHeight: 1.8, marginBottom: 64 }}>
        What do you need right now?
      </p>

      <div style={{ display: "flex", flexDirection: "column", gap: 16, width: "100%" }}>
        <button onClick={() => { setMode("breathe"); }}
          style={{ background: "none", border: "1px solid " + dimColor, borderRadius: 2, padding: "18px 24px", fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontStyle: "italic", color: textColor, cursor: "pointer", textAlign: "left" }}>
          Breathe with me
          <span style={{ display: "block", fontFamily: "'Jost', sans-serif", fontSize: 12, color: dimColor, letterSpacing: "0.1em", marginTop: 4, fontStyle: "normal" }}>A slow 4-cycle breathing practice</span>
        </button>
        
        <button onClick={() => setMode("here")}
          style={{ background: "none", border: "1px solid " + dimColor, borderRadius: 2, padding: "18px 24px", fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontStyle: "italic", color: textColor, cursor: "pointer", textAlign: "left" }}>
          Just be here
          <span style={{ display: "block", fontFamily: "'Jost', sans-serif", fontSize: 12, color: dimColor, letterSpacing: "0.1em", marginTop: 4, fontStyle: "normal" }}>No words needed. Just presence.</span>
        </button>
      </div>

      <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: dimColor, marginTop: 48, letterSpacing: "0.1em", textAlign: "center", lineHeight: 1.9 }}>
        Nothing here is saved or tracked.<br/>This space exists only for right now.
      </p>
    </div>
  );
};


const CommunityScreen = ({ appLang, user }) => {
  const [vents, setVents] = useState(SEED_VENTS);
  const [ventText, setVentText] = useState("");
  const [ventSubmitted, setVentSubmitted] = useState(false);
  const [activeSection, setActiveSection] = useState("venting");
  const [trackerData, setTrackerData] = useState({ cracks: 0, gold: 0 });

  useEffect(() => {
    if (!user) return;
    Promise.all([
      supabase.from('dump_history').select('date_str').eq('user_id', user.id),
      supabase.from('tracker').select('date_str').eq('user_id', user.id),
    ]).then(([dumps, tracks]) => {
      setTrackerData({
        cracks: dumps.data?.length || 0,
        gold: tracks.data?.length || 0,
      });
    });
  }, [user]);

  const handleVent = () => {
    if (!ventText.trim()) return;
    setVents([{ id: Date.now(), text: ventText.trim(), time: "Just now" }, ...vents]);
    setVentText("");
    setVentSubmitted(true);
    setTimeout(() => setVentSubmitted(false), 3000);
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({ title: "Pure Rêve", text: "I found something that helps me. A wellness sanctuary called Pure Rêve.", url: "https://purereve.app" });
    } else {
      navigator.clipboard.writeText("https://purereve.app");
      alert("Link copied!");
    }
  };

  const getMilestones = () => {
    const gold = trackerData.gold;
    const cracks = trackerData.cracks;
    const milestones = [];
    if (gold >= 1) milestones.push({ label: "First Stillness", desc: "You showed up for yourself.", icon: "✦" });
    if (gold >= 7) milestones.push({ label: "One Week Strong", desc: "7 nights of stillness. A habit is forming.", icon: "✨" });
    if (gold >= 30) milestones.push({ label: "A Month of Peace", desc: "30 nights. You are transforming.", icon: "🌟" });
    if (cracks >= 1) milestones.push({ label: "First Crack Named", desc: "You marked something hard. That takes courage.", icon: "❤️" });
    if (cracks >= 10) milestones.push({ label: "Ten Cracks Carried", desc: "Ten hard moments named and held.", icon: "🙏" });
    if (gold >= 1 && cracks >= 1) milestones.push({ label: "The Kintsugi Way", desc: "Cracks and gold. This is the path.", icon: "🛡️" });
    return milestones;
  };

  const tabs = [
    { id: "venting", label: "Venting Wall" },
    { id: "journey", label: "Your Journey" },
    { id: "philosophy", label: "The Philosophy" },
    { id: "light", label: "Spread the Light" },
  ];

  return (
    <div style={{ padding: "56px 0 100px" }}>
      <FadeIn>
        <div style={{ padding: "0 28px 24px" }}>
          <Label style={{ marginBottom: 8 }}>Community</Label>
          <Serif size={28} italic style={{ display: "block", lineHeight: 1.3 }}>You are not alone here.</Serif>
        </div>
      </FadeIn>

      <div style={{ display: "flex", borderBottom: "1px solid " + T.sand, marginBottom: 28, overflowX: "auto", padding: "0 28px" }}>
        {tabs.map(t => (
          <button key={t.id} onClick={() => setActiveSection(t.id)}
            style={{ background: "none", border: "none", borderBottom: activeSection === t.id ? "2px solid " + T.ink : "2px solid transparent", padding: "10px 14px 10px 0", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.1em", textTransform: "uppercase", color: activeSection === t.id ? T.ink : T.inkGhost, cursor: "pointer", whiteSpace: "nowrap", marginBottom: -1 }}>
            {t.label}
          </button>
        ))}
      </div>

      {/* VENTING WALL */}
      {activeSection === "venting" && (
        <FadeIn>
          <div style={{ padding: "0 28px" }}>
            <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkSoft, fontWeight: 300, lineHeight: 1.9, margin: "0 0 20px" }}>
              This is a safe space. Say what you need to say. No names. No judgment.
            </p>
            <textarea value={ventText} onChange={e => setVentText(e.target.value)}
              placeholder="What's on your heart right now..."
              rows={4}
              style={{ width: "100%", background: T.sand, border: "1px solid " + T.sandMid, borderRadius: 2, padding: "14px 16px", fontFamily: "'Jost', sans-serif", fontSize: 16, fontWeight: 300, color: T.ink, lineHeight: 1.9, resize: "none", outline: "none", boxSizing: "border-box", marginBottom: 12 }} />
            {ventSubmitted ? (
              <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 16, fontStyle: "italic", color: T.inkSoft, textAlign: "center", margin: "0 0 20px" }}>You are heard. ✦</p>
            ) : (
              <button onClick={handleVent} style={{ width: "100%", background: T.ink, color: T.ivory, border: "none", borderRadius: 2, padding: "13px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.16em", textTransform: "uppercase", cursor: "pointer", marginBottom: 28 }}>
                Release it ✦
              </button>
            )}
            <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: "#A89880", lineHeight: 1.8, margin: "4px 0 16px", textAlign: "center" }}>
              If you are in crisis, call or text <strong>988</strong> or call <strong>911</strong>. Pure Rêve is a wellness tool, not a crisis service.
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {vents.map(v => (
                <div key={v.id} style={{ background: T.sand, borderRadius: 2, padding: "16px 18px", borderLeft: "2px solid " + T.sandDark }}>
                  <Serif size={14} italic color={T.inkMid} style={{ display: "block", lineHeight: 1.8, marginBottom: 8 }}>"{v.text}"</Serif>
                  <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, letterSpacing: "0.08em" }}>{v.time}</span>
                </div>
              ))}
            </div>
          </div>
        </FadeIn>
      )}

      {/* YOUR JOURNEY */}
      {activeSection === "journey" && (
        <FadeIn>
          <div style={{ padding: "0 28px" }}>
            <div style={{ display: "flex", gap: 16, marginBottom: 28 }}>
              <div style={{ flex: 1, background: T.sand, borderRadius: 2, padding: "20px", textAlign: "center" }}>
                <Serif size={36} style={{ display: "block", color: T.ink }}>{trackerData.gold}</Serif>
                <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, letterSpacing: "0.14em" }}>NIGHTS OF STILLNESS</span>
              </div>
              <div style={{ flex: 1, background: T.sand, borderRadius: 2, padding: "20px", textAlign: "center" }}>
                <Serif size={36} style={{ display: "block", color: "#8B6914" }}>{trackerData.cracks}</Serif>
                <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, letterSpacing: "0.14em" }}>MOMENTS NAMED</span>
              </div>
            </div>

            <Label style={{ marginBottom: 16 }}>Milestones</Label>
            {getMilestones().length === 0 ? (
              <div style={{ background: T.sand, borderRadius: 2, padding: "24px 20px", textAlign: "center" }}>
                <Serif size={16} italic color={T.inkMid} style={{ display: "block", lineHeight: 1.8 }}>Your journey is just beginning.
Every night of stillness is a milestone.</Serif>
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                {getMilestones().map((m, i) => (
                  <div key={i} style={{ background: T.sand, borderRadius: 2, padding: "16px 20px", display: "flex", alignItems: "center", gap: 16 }}>
                    <span style={{ fontSize: 28 }}>{m.icon}</span>
                    <div>
                      <Serif size={16} style={{ display: "block", marginBottom: 4 }}>{m.label}</Serif>
                      <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, fontWeight: 300 }}>{m.desc}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </FadeIn>
      )}

      {/* THE PHILOSOPHY */}
      {activeSection === "philosophy" && (
        <FadeIn>
          <div style={{ padding: "0 28px" }}>
            <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 40, color: T.sandDark, display: "block", textAlign: "center", marginBottom: 24 }}>✦</span>

            <Serif size={22} italic style={{ display: "block", lineHeight: 1.6, marginBottom: 20 }}>
              Pure Rêve was built for the version of you that doesn't have the words.
            </Serif>

            <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkSoft, fontWeight: 300, lineHeight: 2, marginBottom: 20 }}>
              Not the version that journals every morning or meditates for twenty minutes. The version that is exhausted in a way sleep doesn't fix. The version carrying things that aren't theirs. The version awake at 3am with no one to call.
            </p>

            <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkSoft, fontWeight: 300, lineHeight: 2, marginBottom: 28 }}>
              This app was built for that person.
            </p>

            <div style={{ borderLeft: "2px solid " + T.sandDark, paddingLeft: 20, marginBottom: 28 }}>
              <Serif size={18} italic color={T.inkMid} style={{ display: "block", lineHeight: 1.9 }}>
                Kintsugi is the Japanese art of repairing broken pottery with gold. The philosophy is this: breakage and repair are part of the history of an object, not something to hide.
              </Serif>
            </div>

            <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkSoft, fontWeight: 300, lineHeight: 2, marginBottom: 20 }}>
              Your Kintsugi Vessel works the same way. Every hard moment you name becomes a crack. Every night of stillness becomes gold. The vessel doesn't pretend the breaks didn't happen. It makes them beautiful.
            </p>

            <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkSoft, fontWeight: 300, lineHeight: 2, marginBottom: 28 }}>
              Pure Rêve is not a productivity tool. It is not a habit tracker. It is not a place to optimize your morning routine. It is a sanctuary — a space that holds you without asking you to perform, without judging what you bring, without rushing you toward okay.
            </p>

            <div style={{ borderLeft: "2px solid " + T.sandDark, paddingLeft: 20, marginBottom: 28 }}>
              <Serif size={18} italic color={T.inkMid} style={{ display: "block", lineHeight: 1.9 }}>
                You are allowed to not be okay. You are allowed to take as long as you need. The sanctuary does not close.
              </Serif>
            </div>

            <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkSoft, fontWeight: 300, lineHeight: 2, marginBottom: 20 }}>
              There are no experts here. No coaches. No one watching your progress. Just you, and a space that was built with the belief that you already carry more wisdom than you know — you just need a place to set it down for a moment.
            </p>

            <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 16, fontStyle: "italic", color: T.inkGhost, textAlign: "center", lineHeight: 1.9, marginTop: 32 }}>
              "The wound is the place where the light enters you." — Rumi
            </p>

            <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 15, fontStyle: "italic", color: T.inkGhost, textAlign: "center", lineHeight: 1.9, marginTop: 12 }}>
              "He heals the brokenhearted and binds up their wounds." — Psalm 147:3
            </p>

            <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkGhost, textAlign: "center", marginTop: 32, letterSpacing: "0.12em" }}>
              — Shelove Calixte, Founder · Pure Rêve LLC
            </p>
          </div>
        </FadeIn>
      )}

      {/* SPREAD THE LIGHT */}
      {activeSection === "light" && (
        <FadeIn>
          <div style={{ padding: "0 28px", textAlign: "center" }}>
            <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 52, color: T.sandDark, display: "block", marginBottom: 16 }}>✦</span>
            <Serif size={28} italic style={{ display: "block", lineHeight: 1.3, marginBottom: 16 }}>Spread the Light.</Serif>
            <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 14, color: T.inkSoft, fontWeight: 300, lineHeight: 1.9, margin: "0 0 36px" }}>
              Pure Rêve was built for anyone carrying something heavy. If this sanctuary has helped you — pass it on. The way light actually travels.
            </p>
            <button onClick={handleShare}
              style={{ background: T.ink, color: T.ivory, border: "none", borderRadius: 2, padding: "16px 32px", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.18em", textTransform: "uppercase", cursor: "pointer", marginBottom: 32 }}>
              ✦ Share Pure Rêve
            </button>
            <div style={{ padding: "20px", background: T.sand, borderRadius: 2, marginTop: 16 }}>
              <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, margin: "0 0 6px", letterSpacing: "0.08em" }}>Or share the link directly</p>
              <Serif size={16} italic color={T.inkMid} style={{ display: "block" }}>purereve.app</Serif>
            </div>
          </div>
        </FadeIn>
      )}
    </div>
  );
};
const MONTH_NAMES = ["January","February","March","April","May","June","July","August","September","October","November","December"];

const SCRIPTURES = [
  {m:1,d:1,v:"For I know the plans I have for you, declares the Lord, plans to prosper you and not to harm you.",r:"Jeremiah 29:11 NIV"},
  {m:1,d:2,v:"The Lord is my shepherd, I lack nothing.",r:"Psalm 23:1 NIV"},
  {m:1,d:3,v:"Trust in the Lord with all your heart and lean not on your own understanding.",r:"Proverbs 3:5 NIV"},
  {m:1,d:4,v:"I can do all this through him who gives me strength.",r:"Philippians 4:13 NIV"},
  {m:1,d:5,v:"Be strong and courageous. Do not be afraid; do not be discouraged, for the Lord your God will be with you wherever you go.",r:"Joshua 1:9 NIV"},
  {m:1,d:6,v:"Cast all your anxiety on him because he cares for you.",r:"1 Peter 5:7 NIV"},
  {m:1,d:7,v:"God is our refuge and strength, an ever-present help in trouble.",r:"Psalm 46:1 NIV"},
  {m:1,d:8,v:"But those who hope in the Lord will renew their strength. They will soar on wings like eagles.",r:"Isaiah 40:31 NIV"},
  {m:1,d:9,v:"The Lord is close to the brokenhearted and saves those who are crushed in spirit.",r:"Psalm 34:18 NIV"},
  {m:1,d:10,v:"Do not be anxious about anything, but in every situation, by prayer and petition, with thanksgiving, present your requests to God.",r:"Philippians 4:6 NIV"},
  {m:1,d:11,v:"And the peace of God, which transcends all understanding, will guard your hearts and your minds in Christ Jesus.",r:"Philippians 4:7 NIV"},
  {m:1,d:12,v:"He gives strength to the weary and increases the power of the weak.",r:"Isaiah 40:29 NIV"},
  {m:1,d:13,v:"Be still, and know that I am God.",r:"Psalm 46:10 NIV"},
  {m:1,d:14,v:"The Lord will fight for you; you need only to be still.",r:"Exodus 14:14 NIV"},
  {m:1,d:15,v:"Come to me, all you who are weary and burdened, and I will give you rest.",r:"Matthew 11:28 NIV"},
  {m:1,d:16,v:"For we live by faith, not by sight.",r:"2 Corinthians 5:7 NIV"},
  {m:1,d:17,v:"The Lord your God is with you, the Mighty Warrior who saves.",r:"Zephaniah 3:17 NIV"},
  {m:1,d:18,v:"I praise you because I am fearfully and wonderfully made.",r:"Psalm 139:14 NIV"},
  {m:1,d:19,v:"Love is patient, love is kind. It does not envy, it does not boast, it is not proud.",r:"1 Corinthians 13:4 NIV"},
  {m:1,d:20,v:"And we know that in all things God works for the good of those who love him.",r:"Romans 8:28 NIV"},
  {m:1,d:21,v:"The name of the Lord is a fortified tower; the righteous run to it and are safe.",r:"Proverbs 18:10 NIV"},
  {m:1,d:22,v:"He heals the brokenhearted and binds up their wounds.",r:"Psalm 147:3 NIV"},
  {m:1,d:23,v:"Delight yourself in the Lord, and he will give you the desires of your heart.",r:"Psalm 37:4 NIV"},
  {m:1,d:24,v:"The Lord is my light and my salvation — whom shall I fear?",r:"Psalm 27:1 NIV"},
  {m:1,d:25,v:"Your word is a lamp for my feet, a light on my path.",r:"Psalm 119:105 NIV"},
  {m:1,d:26,v:"In all your ways submit to him, and he will make your paths straight.",r:"Proverbs 3:6 NIV"},
  {m:1,d:27,v:"For nothing will be impossible with God.",r:"Luke 1:37 NIV"},
  {m:1,d:28,v:"Peace I leave with you; my peace I give you.",r:"John 14:27 NIV"},
  {m:1,d:29,v:"The Lord bless you and keep you; the Lord make his face shine on you.",r:"Numbers 6:24-25 NIV"},
  {m:1,d:30,v:"Even though I walk through the darkest valley, I will fear no evil, for you are with me.",r:"Psalm 23:4 NIV"},
  {m:1,d:31,v:"Create in me a pure heart, O God, and renew a steadfast spirit within me.",r:"Psalm 51:10 NIV"},
  {m:2,d:1,v:"And my God will meet all your needs according to the riches of his glory in Christ Jesus.",r:"Philippians 4:19 NIV"},
  {m:2,d:2,v:"Wait for the Lord; be strong and take heart and wait for the Lord.",r:"Psalm 27:14 NIV"},
  {m:2,d:3,v:"The steadfast love of the Lord never ceases; his mercies never come to an end.",r:"Lamentations 3:22 NIV"},
  {m:2,d:4,v:"They are new every morning; great is your faithfulness.",r:"Lamentations 3:23 NIV"},
  {m:2,d:5,v:"For the Spirit God gave us does not make us timid, but gives us power, love and self-discipline.",r:"2 Timothy 1:7 NIV"},
  {m:2,d:6,v:"Blessed are the pure in heart, for they will see God.",r:"Matthew 5:8 NIV"},
  {m:2,d:7,v:"Greater love has no one than this: to lay down one life for one friends.",r:"John 15:13 NIV"},
  {m:2,d:8,v:"For God so loved the world that he gave his one and only Son.",r:"John 3:16 NIV"},
  {m:2,d:9,v:"Let all that you do be done in love.",r:"1 Corinthians 16:14 NIV"},
  {m:2,d:10,v:"Above all, love each other deeply, because love covers over a multitude of sins.",r:"1 Peter 4:8 NIV"},
  {m:2,d:11,v:"We love because he first loved us.",r:"1 John 4:19 NIV"},
  {m:2,d:12,v:"There is no fear in love. But perfect love drives out fear.",r:"1 John 4:18 NIV"},
  {m:2,d:13,v:"And now these three remain: faith, hope and love. But the greatest of these is love.",r:"1 Corinthians 13:13 NIV"},
  {m:2,d:14,v:"Beloved, let us love one another, for love is from God.",r:"1 John 4:7 NIV"},
  {m:2,d:15,v:"The Lord appeared to us saying: I have loved you with an everlasting love.",r:"Jeremiah 31:3 NIV"},
  {m:2,d:16,v:"How wide and long and high and deep is the love of Christ.",r:"Ephesians 3:18 NIV"},
  {m:2,d:17,v:"Give thanks to the Lord, for he is good; his love endures forever.",r:"Psalm 107:1 NIV"},
  {m:2,d:18,v:"See what great love the Father has lavished on us, that we should be called children of God.",r:"1 John 3:1 NIV"},
  {m:2,d:19,v:"But God demonstrates his own love for us in this: While we were still sinners, Christ died for us.",r:"Romans 5:8 NIV"},
  {m:2,d:20,v:"Mercy, peace and love be yours in abundance.",r:"Jude 1:2 NIV"},
  {m:2,d:21,v:"The Lord is gracious and compassionate, slow to anger and rich in love.",r:"Psalm 145:8 NIV"},
  {m:2,d:22,v:"Be completely humble and gentle; be patient, bearing with one another in love.",r:"Ephesians 4:2 NIV"},
  {m:2,d:23,v:"And over all these virtues put on love, which binds them all together in perfect unity.",r:"Colossians 3:14 NIV"},
  {m:2,d:24,v:"A new command I give you: Love one another. As I have loved you, so you must love one another.",r:"John 13:34 NIV"},
  {m:2,d:25,v:"Though the mountains be shaken, yet my unfailing love for you will not be shaken.",r:"Isaiah 54:10 NIV"},
  {m:2,d:26,v:"Neither death nor life can separate us from the love of God.",r:"Romans 8:38-39 NIV"},
  {m:2,d:27,v:"Give thanks in all circumstances; for this is God will for you in Christ Jesus.",r:"1 Thessalonians 5:18 NIV"},
  {m:2,d:28,v:"This is the day the Lord has made; let us rejoice and be glad in it.",r:"Psalm 118:24 NIV"},
  {m:3,d:1,v:"Rejoice in the Lord always. I will say it again: Rejoice!",r:"Philippians 4:4 NIV"},
  {m:3,d:2,v:"The joy of the Lord is your strength.",r:"Nehemiah 8:10 NIV"},
  {m:3,d:3,v:"You will keep in perfect peace those whose minds are steadfast, because they trust in you.",r:"Isaiah 26:3 NIV"},
  {m:3,d:4,v:"Do not conform to the pattern of this world, but be transformed by the renewing of your mind.",r:"Romans 12:2 NIV"},
  {m:3,d:5,v:"I sought the Lord, and he answered me; he delivered me from all my fears.",r:"Psalm 34:4 NIV"},
  {m:3,d:6,v:"The Lord is my strength and my shield; my heart trusts in him, and he helps me.",r:"Psalm 28:7 NIV"},
  {m:3,d:7,v:"Let your light shine before others, that they may see your good deeds and glorify your Father in heaven.",r:"Matthew 5:16 NIV"},
  {m:3,d:8,v:"Seek first his kingdom and his righteousness, and all these things will be given to you as well.",r:"Matthew 6:33 NIV"},
  {m:3,d:9,v:"With God all things are possible.",r:"Matthew 19:26 NIV"},
  {m:3,d:10,v:"Ask and it will be given to you; seek and you will find; knock and the door will be opened.",r:"Matthew 7:7 NIV"},
  {m:3,d:11,v:"If God is for us, who can be against us?",r:"Romans 8:31 NIV"},
  {m:3,d:12,v:"My grace is sufficient for you, for my power is made perfect in weakness.",r:"2 Corinthians 12:9 NIV"},
  {m:3,d:13,v:"Now to him who is able to do immeasurably more than all we ask or imagine.",r:"Ephesians 3:20 NIV"},
  {m:3,d:14,v:"Draw near to God, and he will draw near to you.",r:"James 4:8 NIV"},
  {m:3,d:15,v:"He who began a good work in you will carry it on to completion.",r:"Philippians 1:6 NIV"},
  {m:3,d:16,v:"For I am the Lord your God who takes hold of your right hand and says, Do not fear; I will help you.",r:"Isaiah 41:13 NIV"},
  {m:3,d:17,v:"Let the morning bring me word of your unfailing love, for I have put my trust in you.",r:"Psalm 143:8 NIV"},
  {m:3,d:18,v:"My soul finds rest in God alone; my salvation comes from him.",r:"Psalm 62:1 NIV"},
  {m:3,d:19,v:"The Lord is good, a refuge in times of trouble. He cares for those who trust in him.",r:"Nahum 1:7 NIV"},
  {m:3,d:20,v:"I will lie down and sleep in peace, for you alone, Lord, make me dwell in safety.",r:"Psalm 4:8 NIV"},
  {m:3,d:21,v:"Let the peace of Christ rule in your hearts, since as members of one body you were called to peace.",r:"Colossians 3:15 NIV"},
  {m:3,d:22,v:"Whatever you do, work at it with all your heart, as working for the Lord.",r:"Colossians 3:23 NIV"},
  {m:3,d:23,v:"For we are God handiwork, created in Christ Jesus to do good works.",r:"Ephesians 2:10 NIV"},
  {m:3,d:24,v:"The Lord is my rock, my fortress and my deliverer.",r:"Psalm 18:2 NIV"},
  {m:3,d:25,v:"Taste and see that the Lord is good; blessed is the one who takes refuge in him.",r:"Psalm 34:8 NIV"},
  {m:3,d:26,v:"The Lord is compassionate and gracious, slow to anger, abounding in love.",r:"Psalm 103:8 NIV"},
  {m:3,d:27,v:"Therefore, if anyone is in Christ, the new creation has come: The old has gone, the new is here!",r:"2 Corinthians 5:17 NIV"},
  {m:3,d:28,v:"For it is by grace you have been saved, through faith — it is the gift of God.",r:"Ephesians 2:8 NIV"},
  {m:3,d:29,v:"May the God of hope fill you with all joy and peace as you trust in him.",r:"Romans 15:13 NIV"},
  {m:3,d:30,v:"The Lord watches over you — the Lord is your shade at your right hand.",r:"Psalm 121:5 NIV"},
  {m:3,d:31,v:"The Lord will keep you from all harm — he will watch over your life.",r:"Psalm 121:7 NIV"},
  {m:4,d:1,v:"Jesus said, I am the resurrection and the life. The one who believes in me will live.",r:"John 11:25 NIV"},
  {m:4,d:2,v:"Thanks be to God! He gives us the victory through our Lord Jesus Christ.",r:"1 Corinthians 15:57 NIV"},
  {m:4,d:3,v:"Therefore, if anyone is in Christ, the new creation has come.",r:"2 Corinthians 5:17 NIV"},
  {m:4,d:4,v:"Jesus answered, I am the way and the truth and the life.",r:"John 14:6 NIV"},
  {m:4,d:5,v:"I have come that they may have life, and have it to the full.",r:"John 10:10 NIV"},
  {m:4,d:6,v:"The Lord is my light and my salvation — whom shall I fear?",r:"Psalm 27:1 NIV"},
  {m:4,d:7,v:"And my God will meet all your needs according to the riches of his glory in Christ Jesus.",r:"Philippians 4:19 NIV"},
  {m:4,d:8,v:"Christ has indeed been raised from the dead.",r:"1 Corinthians 15:20 NIV"},
  {m:4,d:9,v:"I am the vine; you are the branches. If you remain in me you will bear much fruit.",r:"John 15:5 NIV"},
  {m:4,d:10,v:"Now the Lord is the Spirit, and where the Spirit of the Lord is, there is freedom.",r:"2 Corinthians 3:17 NIV"},
  {m:4,d:11,v:"He was pierced for our transgressions; the punishment that brought us peace was on him.",r:"Isaiah 53:5 NIV"},
  {m:4,d:12,v:"May the God of hope fill you with all joy and peace as you trust in him.",r:"Romans 15:13 NIV"},
  {m:4,d:13,v:"I have been crucified with Christ and I no longer live, but Christ lives in me.",r:"Galatians 2:20 NIV"},
  {m:4,d:14,v:"For it is by grace you have been saved, through faith — it is the gift of God.",r:"Ephesians 2:8 NIV"},
  {m:4,d:15,v:"A heart at peace gives life to the body.",r:"Proverbs 14:30 NIV"},
  {m:4,d:16,v:"Surely goodness and love will follow me all the days of my life.",r:"Psalm 23:6 NIV"},
  {m:4,d:17,v:"Commit to the Lord whatever you do, and he will establish your plans.",r:"Proverbs 16:3 NIV"},
  {m:4,d:18,v:"Blessed are the peacemakers, for they will be called children of God.",r:"Matthew 5:9 NIV"},
  {m:4,d:19,v:"Blessed are those who mourn, for they will be comforted.",r:"Matthew 5:4 NIV"},
  {m:4,d:20,v:"The earth is the Lord, and everything in it.",r:"Psalm 24:1 NIV"},
  {m:4,d:21,v:"In all your ways submit to him, and he will make your paths straight.",r:"Proverbs 3:6 NIV"},
  {m:4,d:22,v:"The Lord will guide you always; he will satisfy your needs.",r:"Isaiah 58:11 NIV"},
  {m:4,d:23,v:"My soul finds rest in God alone; my salvation comes from him.",r:"Psalm 62:1 NIV"},
  {m:4,d:24,v:"I lift up my eyes to the mountains — where does my help come from? My help comes from the Lord.",r:"Psalm 121:1-2 NIV"},
  {m:4,d:25,v:"The Lord bless you and keep you; the Lord make his face shine on you.",r:"Numbers 6:24-25 NIV"},
  {m:4,d:26,v:"Be still, and know that I am God.",r:"Psalm 46:10 NIV"},
  {m:4,d:27,v:"Cast all your anxiety on him because he cares for you.",r:"1 Peter 5:7 NIV"},
  {m:4,d:28,v:"God is our refuge and strength, an ever-present help in trouble.",r:"Psalm 46:1 NIV"},
  {m:4,d:29,v:"Do not be anxious about anything, but present your requests to God.",r:"Philippians 4:6 NIV"},
  {m:4,d:30,v:"And the peace of God will guard your hearts and your minds in Christ Jesus.",r:"Philippians 4:7 NIV"},
  {m:5,d:1,v:"Every good and perfect gift is from above, coming down from the Father.",r:"James 1:17 NIV"},
  {m:5,d:2,v:"If any of you lacks wisdom, you should ask God, who gives generously to all.",r:"James 1:5 NIV"},
  {m:5,d:3,v:"Humble yourselves before the Lord, and he will lift you up.",r:"James 4:10 NIV"},
  {m:5,d:4,v:"The prayer of a righteous person is powerful and effective.",r:"James 5:16 NIV"},
  {m:5,d:5,v:"Draw near to God, and he will draw near to you.",r:"James 4:8 NIV"},
  {m:5,d:6,v:"Submit yourselves, then, to God. Resist the devil, and he will flee from you.",r:"James 4:7 NIV"},
  {m:5,d:7,v:"Honor your father and your mother, so that you may live long in the land.",r:"Exodus 20:12 NIV"},
  {m:5,d:8,v:"She is clothed with strength and dignity; she can laugh at the days to come.",r:"Proverbs 31:25 NIV"},
  {m:5,d:9,v:"Charm is deceptive, and beauty is fleeting; but a woman who fears the Lord is to be praised.",r:"Proverbs 31:30 NIV"},
  {m:5,d:10,v:"Children are a heritage from the Lord, offspring a reward from him.",r:"Psalm 127:3 NIV"},
  {m:5,d:11,v:"Her children arise and call her blessed; her husband also, and he praises her.",r:"Proverbs 31:28 NIV"},
  {m:5,d:12,v:"Let the little children come to me, for the kingdom of heaven belongs to such as these.",r:"Matthew 19:14 NIV"},
  {m:5,d:13,v:"Jesus Christ is the same yesterday and today and forever.",r:"Hebrews 13:8 NIV"},
  {m:5,d:14,v:"Now faith is confidence in what we hope for and assurance about what we do not see.",r:"Hebrews 11:1 NIV"},
  {m:5,d:15,v:"Let us run with perseverance the race marked out for us, fixing our eyes on Jesus.",r:"Hebrews 12:1-2 NIV"},
  {m:5,d:16,v:"Make every effort to live in peace with everyone and to be holy.",r:"Hebrews 12:14 NIV"},
  {m:5,d:17,v:"Do not forget to show hospitality to strangers, for some have shown hospitality to angels.",r:"Hebrews 13:2 NIV"},
  {m:5,d:18,v:"May the God of peace equip you with everything good for doing his will.",r:"Hebrews 13:20-21 NIV"},
  {m:5,d:19,v:"His divine power has given us everything we need for a godly life.",r:"2 Peter 1:3 NIV"},
  {m:5,d:20,v:"Grow in the grace and knowledge of our Lord and Savior Jesus Christ.",r:"2 Peter 3:18 NIV"},
  {m:5,d:21,v:"The Lord is not slow in keeping his promise. Instead he is patient with you.",r:"2 Peter 3:9 NIV"},
  {m:5,d:22,v:"But in keeping with his promise we are looking forward to a new heaven and a new earth.",r:"2 Peter 3:13 NIV"},
  {m:5,d:23,v:"Consider it pure joy whenever you face trials, because the testing of your faith produces perseverance.",r:"James 1:2-3 NIV"},
  {m:5,d:24,v:"Blessed is the one who perseveres under trial; that person will receive the crown of life.",r:"James 1:12 NIV"},
  {m:5,d:25,v:"Do not merely listen to the word, and so deceive yourselves. Do what it says.",r:"James 1:22 NIV"},
  {m:5,d:26,v:"Add to your faith goodness; and to goodness, knowledge; and to knowledge, self-control.",r:"2 Peter 1:5-6 NIV"},
  {m:5,d:27,v:"Let us hold unswervingly to the hope we profess, for he who promised is faithful.",r:"Hebrews 10:23 NIV"},
  {m:5,d:28,v:"Keep your lives free from the love of money and be content with what you have.",r:"Hebrews 13:5 NIV"},
  {m:5,d:29,v:"Through Jesus, let us continually offer to God a sacrifice of praise.",r:"Hebrews 13:15 NIV"},
  {m:5,d:30,v:"And do not forget to do good and to share with others, for with such sacrifices God is pleased.",r:"Hebrews 13:16 NIV"},
  {m:5,d:31,v:"May the God of peace equip you with everything good for doing his will.",r:"Hebrews 13:20-21 NIV"},
  {m:6,d:1,v:"The fruit of the Spirit is love, joy, peace, forbearance, kindness, goodness, faithfulness.",r:"Galatians 5:22 NIV"},
  {m:6,d:2,v:"Since we live by the Spirit, let us keep in step with the Spirit.",r:"Galatians 5:25 NIV"},
  {m:6,d:3,v:"Carry each other burdens, and in this way you will fulfill the law of Christ.",r:"Galatians 6:2 NIV"},
  {m:6,d:4,v:"Let us not become weary in doing good, for at the proper time we will reap a harvest.",r:"Galatians 6:9 NIV"},
  {m:6,d:5,v:"There is neither Jew nor Gentile, neither slave nor free, for you are all one in Christ Jesus.",r:"Galatians 3:28 NIV"},
  {m:6,d:6,v:"Be on your guard; stand firm in the faith; be courageous; be strong.",r:"1 Corinthians 16:13 NIV"},
  {m:6,d:7,v:"Finally, whatever is true, whatever is noble, whatever is right — think about such things.",r:"Philippians 4:8 NIV"},
  {m:6,d:8,v:"I press on toward the goal to win the prize for which God has called me heavenward.",r:"Philippians 3:14 NIV"},
  {m:6,d:9,v:"In your relationships with one another, have the same mindset as Christ Jesus.",r:"Philippians 2:5 NIV"},
  {m:6,d:10,v:"Do nothing out of selfish ambition. Rather, in humility value others above yourselves.",r:"Philippians 2:3 NIV"},
  {m:6,d:11,v:"For to me, to live is Christ and to die is gain.",r:"Philippians 1:21 NIV"},
  {m:6,d:12,v:"The Lord has done great things for us, and we are filled with joy.",r:"Psalm 126:3 NIV"},
  {m:6,d:13,v:"Those who sow with tears will reap with songs of joy.",r:"Psalm 126:5 NIV"},
  {m:6,d:14,v:"Unless the Lord builds the house, the builders labor in vain.",r:"Psalm 127:1 NIV"},
  {m:6,d:15,v:"How good and pleasant it is when God people live together in unity!",r:"Psalm 133:1 NIV"},
  {m:6,d:16,v:"Shout for joy to the Lord, all the earth. Worship the Lord with gladness.",r:"Psalm 100:1-2 NIV"},
  {m:6,d:17,v:"Know that the Lord is God. It is he who made us, and we are his.",r:"Psalm 100:3 NIV"},
  {m:6,d:18,v:"Enter his gates with thanksgiving and his courts with praise.",r:"Psalm 100:4 NIV"},
  {m:6,d:19,v:"For the Lord is good and his love endures forever; his faithfulness continues through all generations.",r:"Psalm 100:5 NIV"},
  {m:6,d:20,v:"O Lord, you have searched me and you know me.",r:"Psalm 139:1 NIV"},
  {m:6,d:21,v:"For you created my inmost being; you knit me together in my mother womb.",r:"Psalm 139:13 NIV"},
  {m:6,d:22,v:"Search me, God, and know my heart; test me and know my anxious thoughts.",r:"Psalm 139:23 NIV"},
  {m:6,d:23,v:"I will give thanks to you, Lord, with all my heart; I will tell of all your wonderful deeds.",r:"Psalm 9:1 NIV"},
  {m:6,d:24,v:"The Lord reigns, let the earth be glad; let the distant shores rejoice.",r:"Psalm 97:1 NIV"},
  {m:6,d:25,v:"I praise you because I am fearfully and wonderfully made.",r:"Psalm 139:14 NIV"},
  {m:6,d:26,v:"Your word is a lamp for my feet, a light on my path.",r:"Psalm 119:105 NIV"},
  {m:6,d:27,v:"Delight yourself in the Lord, and he will give you the desires of your heart.",r:"Psalm 37:4 NIV"},
  {m:6,d:28,v:"The Lord is my shepherd, I lack nothing. He makes me lie down in green pastures.",r:"Psalm 23:1-2 NIV"},
  {m:6,d:29,v:"Surely goodness and love will follow me all the days of my life.",r:"Psalm 23:6 NIV"},
  {m:6,d:30,v:"Be still, and know that I am God; I will be exalted among the nations.",r:"Psalm 46:10 NIV"},
  {m:7,d:1,v:"Blessed is the nation whose God is the Lord.",r:"Psalm 33:12 NIV"},
  {m:7,d:2,v:"If my people will humble themselves and pray and seek my face, I will heal their land.",r:"2 Chronicles 7:14 NIV"},
  {m:7,d:3,v:"Righteousness exalts a nation, but sin condemns any people.",r:"Proverbs 14:34 NIV"},
  {m:7,d:4,v:"I urge that petitions and thanksgiving be made for all people — for kings and all those in authority.",r:"1 Timothy 2:1-2 NIV"},
  {m:7,d:5,v:"Do to others as you would have them do to you.",r:"Luke 6:31 NIV"},
  {m:7,d:6,v:"But love your enemies, do good to them, and lend to them without expecting to get anything back.",r:"Luke 6:35 NIV"},
  {m:7,d:7,v:"Do not judge, and you will not be judged. Forgive, and you will be forgiven.",r:"Luke 6:37 NIV"},
  {m:7,d:8,v:"In the beginning was the Word, and the Word was with God, and the Word was God.",r:"John 1:1 NIV"},
  {m:7,d:9,v:"The Word became flesh and made his dwelling among us.",r:"John 1:14 NIV"},
  {m:7,d:10,v:"God is spirit, and his worshipers must worship in the Spirit and in truth.",r:"John 4:24 NIV"},
  {m:7,d:11,v:"I am the bread of life. Whoever comes to me will never go hungry.",r:"John 6:35 NIV"},
  {m:7,d:12,v:"I am the light of the world. Whoever follows me will never walk in darkness.",r:"John 8:12 NIV"},
  {m:7,d:13,v:"The truth will set you free.",r:"John 8:32 NIV"},
  {m:7,d:14,v:"I am the good shepherd. The good shepherd lays down his life for the sheep.",r:"John 10:11 NIV"},
  {m:7,d:15,v:"Do not let your hearts be troubled. You believe in God; believe also in me.",r:"John 14:1 NIV"},
  {m:7,d:16,v:"As the Father has loved me, so have I loved you. Now remain in my love.",r:"John 15:9 NIV"},
  {m:7,d:17,v:"You did not choose me, but I chose you and appointed you so that you might go and bear fruit.",r:"John 15:16 NIV"},
  {m:7,d:18,v:"In this world you will have trouble. But take heart! I have overcome the world.",r:"John 16:33 NIV"},
  {m:7,d:19,v:"My sheep listen to my voice; I know them, and they follow me.",r:"John 10:27 NIV"},
  {m:7,d:20,v:"Salvation is found in no one else, for there is no other name under heaven given to mankind by which we must be saved.",r:"Acts 4:12 NIV"},
  {m:7,d:21,v:"In him we live and move and have our being.",r:"Acts 17:28 NIV"},
  {m:7,d:22,v:"I am not ashamed of the gospel, because it is the power of God that brings salvation.",r:"Romans 1:16 NIV"},
  {m:7,d:23,v:"For all have sinned and fall short of the glory of God.",r:"Romans 3:23 NIV"},
  {m:7,d:24,v:"For the wages of sin is death, but the gift of God is eternal life in Christ Jesus our Lord.",r:"Romans 6:23 NIV"},
  {m:7,d:25,v:"If you declare with your mouth Jesus is Lord, and believe in your heart that God raised him, you will be saved.",r:"Romans 10:9 NIV"},
  {m:7,d:26,v:"For from him and through him and for him are all things. To him be the glory forever!",r:"Romans 11:36 NIV"},
  {m:7,d:27,v:"Offer your bodies as a living sacrifice, holy and pleasing to God.",r:"Romans 12:1 NIV"},
  {m:7,d:28,v:"Be joyful in hope, patient in affliction, faithful in prayer.",r:"Romans 12:12 NIV"},
  {m:7,d:29,v:"Do not be overcome by evil, but overcome evil with good.",r:"Romans 12:21 NIV"},
  {m:7,d:30,v:"The kingdom of God is not eating and drinking, but righteousness, peace and joy in the Holy Spirit.",r:"Romans 14:17 NIV"},
  {m:7,d:31,v:"Heaven and earth will pass away, but my words will never pass away.",r:"Luke 21:33 NIV"},
  {m:8,d:1,v:"For the message of the cross is foolishness to those who are perishing, but to us it is the power of God.",r:"1 Corinthians 1:18 NIV"},
  {m:8,d:2,v:"No eye has seen, no ear has heard, no mind has conceived what God has prepared for those who love him.",r:"1 Corinthians 2:9 NIV"},
  {m:8,d:3,v:"Do you not know that your bodies are temples of the Holy Spirit?",r:"1 Corinthians 6:19 NIV"},
  {m:8,d:4,v:"So whether you eat or drink or whatever you do, do it all for the glory of God.",r:"1 Corinthians 10:31 NIV"},
  {m:8,d:5,v:"If I speak in the tongues of men or of angels, but do not have love, I am only a resounding gong.",r:"1 Corinthians 13:1 NIV"},
  {m:8,d:6,v:"Love never fails.",r:"1 Corinthians 13:8 NIV"},
  {m:8,d:7,v:"And now these three remain: faith, hope and love. But the greatest of these is love.",r:"1 Corinthians 13:13 NIV"},
  {m:8,d:8,v:"Death has been swallowed up in victory. Where, O death, is your sting?",r:"1 Corinthians 15:54-55 NIV"},
  {m:8,d:9,v:"Therefore, my dear brothers and sisters, stand firm. Let nothing move you.",r:"1 Corinthians 15:58 NIV"},
  {m:8,d:10,v:"For our light and momentary troubles are achieving for us an eternal glory that far outweighs them all.",r:"2 Corinthians 4:17 NIV"},
  {m:8,d:11,v:"We fix our eyes not on what is seen, but on what is unseen, since what is seen is temporary.",r:"2 Corinthians 4:18 NIV"},
  {m:8,d:12,v:"We are therefore Christ ambassadors, as though God were making his appeal through us.",r:"2 Corinthians 5:20 NIV"},
  {m:8,d:13,v:"Now is the time of God favor, now is the day of salvation.",r:"2 Corinthians 6:2 NIV"},
  {m:8,d:14,v:"God loves a cheerful giver.",r:"2 Corinthians 9:7 NIV"},
  {m:8,d:15,v:"When I am weak, then I am strong.",r:"2 Corinthians 12:10 NIV"},
  {m:8,d:16,v:"May the grace of the Lord Jesus Christ, and the love of God, and the fellowship of the Holy Spirit be with you all.",r:"2 Corinthians 13:14 NIV"},
  {m:8,d:17,v:"For it is God who works in you to will and to act in order to fulfill his good purpose.",r:"Philippians 2:13 NIV"},
  {m:8,d:18,v:"Pray continually.",r:"1 Thessalonians 5:17 NIV"},
  {m:8,d:19,v:"The one who calls you is faithful, and he will do it.",r:"1 Thessalonians 5:24 NIV"},
  {m:8,d:20,v:"May God himself, the God of peace, sanctify you through and through.",r:"1 Thessalonians 5:23 NIV"},
  {m:8,d:21,v:"Set your minds on things above, not on earthly things.",r:"Colossians 3:2 NIV"},
  {m:8,d:22,v:"And whatever you do, whether in word or deed, do it all in the name of the Lord Jesus.",r:"Colossians 3:17 NIV"},
  {m:8,d:23,v:"Devote yourselves to prayer, being watchful and thankful.",r:"Colossians 4:2 NIV"},
  {m:8,d:24,v:"Let your conversation be always full of grace, seasoned with salt.",r:"Colossians 4:6 NIV"},
  {m:8,d:25,v:"Therefore encourage one another and build each other up.",r:"1 Thessalonians 5:11 NIV"},
  {m:8,d:26,v:"Test everything that is said. Hold on to what is good.",r:"1 Thessalonians 5:21 NIV"},
  {m:8,d:27,v:"For he has rescued us from the dominion of darkness and brought us into the kingdom of the Son he loves.",r:"Colossians 1:13 NIV"},
  {m:8,d:28,v:"Love must be sincere. Hate what is evil; cling to what is good.",r:"Romans 12:9 NIV"},
  {m:8,d:29,v:"Never be lacking in zeal, but keep your spiritual fervor, serving the Lord.",r:"Romans 12:11 NIV"},
  {m:8,d:30,v:"Let no debt remain outstanding, except the continuing debt to love one another.",r:"Romans 13:8 NIV"},
  {m:8,d:31,v:"The night is nearly over; the day is almost here. So let us put aside the deeds of darkness.",r:"Romans 13:12 NIV"},
  {m:9,d:1,v:"For now we see only a reflection as in a mirror; but then we shall see face to face.",r:"1 Corinthians 13:12 NIV"},
  {m:9,d:2,v:"My grace is sufficient for you, for my power is made perfect in weakness.",r:"2 Corinthians 12:9 NIV"},
  {m:9,d:3,v:"For the Spirit God gave us does not make us timid, but gives us power, love and self-discipline.",r:"2 Timothy 1:7 NIV"},
  {m:9,d:4,v:"All Scripture is God-breathed and is useful for teaching, rebuking, correcting and training in righteousness.",r:"2 Timothy 3:16 NIV"},
  {m:9,d:5,v:"I have fought the good fight, I have finished the race, I have kept the faith.",r:"2 Timothy 4:7 NIV"},
  {m:9,d:6,v:"The Lord will rescue me from every evil attack and will bring me safely to his heavenly kingdom.",r:"2 Timothy 4:18 NIV"},
  {m:9,d:7,v:"Fight the good fight of the faith. Take hold of the eternal life to which you were called.",r:"1 Timothy 6:12 NIV"},
  {m:9,d:8,v:"Godliness with contentment is great gain.",r:"1 Timothy 6:6 NIV"},
  {m:9,d:9,v:"For the grace of God has appeared that offers salvation to all people.",r:"Titus 2:11 NIV"},
  {m:9,d:10,v:"He saved us, not because of righteous things we had done, but because of his mercy.",r:"Titus 3:5 NIV"},
  {m:9,d:11,v:"For the word of God is alive and active. Sharper than any double-edged sword.",r:"Hebrews 4:12 NIV"},
  {m:9,d:12,v:"Let us then approach God throne of grace with confidence, so that we may receive mercy.",r:"Hebrews 4:16 NIV"},
  {m:9,d:13,v:"Without faith it is impossible to please God.",r:"Hebrews 11:6 NIV"},
  {m:9,d:14,v:"Therefore, since we are surrounded by such a great cloud of witnesses, let us throw off everything that hinders.",r:"Hebrews 12:1 NIV"},
  {m:9,d:15,v:"Endure hardship as discipline; God is treating you as his children.",r:"Hebrews 12:7 NIV"},
  {m:9,d:16,v:"And do not forget to do good and to share with others, for with such sacrifices God is pleased.",r:"Hebrews 13:16 NIV"},
  {m:9,d:17,v:"This is the message we have heard: God is light; in him there is no darkness at all.",r:"1 John 1:5 NIV"},
  {m:9,d:18,v:"If we confess our sins, he is faithful and just and will forgive us our sins.",r:"1 John 1:9 NIV"},
  {m:9,d:19,v:"Do not love the world or anything in the world. If anyone loves the world, love for the Father is not in them.",r:"1 John 2:15 NIV"},
  {m:9,d:20,v:"The world and its desires pass away, but whoever does the will of God lives forever.",r:"1 John 2:17 NIV"},
  {m:9,d:21,v:"This is how we know what love is: Jesus Christ laid down his life for us.",r:"1 John 3:16 NIV"},
  {m:9,d:22,v:"Dear children, let us not love with words or speech but with actions and in truth.",r:"1 John 3:18 NIV"},
  {m:9,d:23,v:"God is love. Whoever lives in love lives in God, and God in them.",r:"1 John 4:16 NIV"},
  {m:9,d:24,v:"For everyone born of God overcomes the world. This is the victory that has overcome the world, even our faith.",r:"1 John 5:4 NIV"},
  {m:9,d:25,v:"This is the confidence we have: if we ask anything according to his will, he hears us.",r:"1 John 5:14 NIV"},
  {m:9,d:26,v:"I have no greater joy than to hear that my children are walking in the truth.",r:"3 John 1:4 NIV"},
  {m:9,d:27,v:"Mercy, peace and love be yours in abundance.",r:"Jude 1:2 NIV"},
  {m:9,d:28,v:"To him who is able to keep you from stumbling and to present you before his glorious presence.",r:"Jude 1:24 NIV"},
  {m:9,d:29,v:"He who was seated on the throne said, I am making everything new!",r:"Revelation 21:5 NIV"},
  {m:9,d:30,v:"It is done. I am the Alpha and the Omega, the Beginning and the End.",r:"Revelation 21:6 NIV"},
  {m:10,d:1,v:"Do your best to present yourself to God as one approved, a worker who does not need to be ashamed.",r:"2 Timothy 2:15 NIV"},
  {m:10,d:2,v:"The Lord is my rock, my fortress and my deliverer.",r:"Psalm 18:2 NIV"},
  {m:10,d:3,v:"The Lord is my light and my salvation — whom shall I fear?",r:"Psalm 27:1 NIV"},
  {m:10,d:4,v:"Taste and see that the Lord is good; blessed is the one who takes refuge in him.",r:"Psalm 34:8 NIV"},
  {m:10,d:5,v:"God is our refuge and strength, an ever-present help in trouble.",r:"Psalm 46:1 NIV"},
  {m:10,d:6,v:"Create in me a pure heart, O God, and renew a steadfast spirit within me.",r:"Psalm 51:10 NIV"},
  {m:10,d:7,v:"He heals the brokenhearted and binds up their wounds.",r:"Psalm 147:3 NIV"},
  {m:10,d:8,v:"The Lord is my shepherd, I lack nothing.",r:"Psalm 23:1 NIV"},
  {m:10,d:9,v:"Even though I walk through the darkest valley, I will fear no evil, for you are with me.",r:"Psalm 23:4 NIV"},
  {m:10,d:10,v:"Surely goodness and love will follow me all the days of my life.",r:"Psalm 23:6 NIV"},
  {m:10,d:11,v:"Your word is a lamp for my feet, a light on my path.",r:"Psalm 119:105 NIV"},
  {m:10,d:12,v:"I lift up my eyes to the mountains — where does my help come from? My help comes from the Lord.",r:"Psalm 121:1-2 NIV"},
  {m:10,d:13,v:"The Lord will keep you from all harm — he will watch over your life.",r:"Psalm 121:7 NIV"},
  {m:10,d:14,v:"How good and pleasant it is when God people live together in unity!",r:"Psalm 133:1 NIV"},
  {m:10,d:15,v:"I praise you because I am fearfully and wonderfully made; your works are wonderful.",r:"Psalm 139:14 NIV"},
  {m:10,d:16,v:"Search me, God, and know my heart; test me and know my anxious thoughts.",r:"Psalm 139:23 NIV"},
  {m:10,d:17,v:"Trust in the Lord with all your heart and lean not on your own understanding.",r:"Proverbs 3:5 NIV"},
  {m:10,d:18,v:"In all your ways submit to him, and he will make your paths straight.",r:"Proverbs 3:6 NIV"},
  {m:10,d:19,v:"Commit to the Lord whatever you do, and he will establish your plans.",r:"Proverbs 16:3 NIV"},
  {m:10,d:20,v:"A heart at peace gives life to the body.",r:"Proverbs 14:30 NIV"},
  {m:10,d:21,v:"The name of the Lord is a fortified tower; the righteous run to it and are safe.",r:"Proverbs 18:10 NIV"},
  {m:10,d:22,v:"For I know the plans I have for you, declares the Lord, plans to prosper you.",r:"Jeremiah 29:11 NIV"},
  {m:10,d:23,v:"He gives strength to the weary and increases the power of the weak.",r:"Isaiah 40:29 NIV"},
  {m:10,d:24,v:"But those who hope in the Lord will renew their strength.",r:"Isaiah 40:31 NIV"},
  {m:10,d:25,v:"For I am the Lord your God who takes hold of your right hand and says, Do not fear; I will help you.",r:"Isaiah 41:13 NIV"},
  {m:10,d:26,v:"You will keep in perfect peace those whose minds are steadfast, because they trust in you.",r:"Isaiah 26:3 NIV"},
  {m:10,d:27,v:"The Lord appeared to us saying: I have loved you with an everlasting love.",r:"Jeremiah 31:3 NIV"},
  {m:10,d:28,v:"Be alert and of sober mind. Your enemy the devil prowls around like a roaring lion.",r:"1 Peter 5:8 NIV"},
  {m:10,d:29,v:"Cast all your anxiety on him because he cares for you.",r:"1 Peter 5:7 NIV"},
  {m:10,d:30,v:"And the God of all grace will himself restore you and make you strong.",r:"1 Peter 5:10 NIV"},
  {m:10,d:31,v:"Submit yourselves, then, to God. Resist the devil, and he will flee from you.",r:"James 4:7 NIV"},
  {m:11,d:1,v:"Give thanks to the Lord, for he is good; his love endures forever.",r:"Psalm 107:1 NIV"},
  {m:11,d:2,v:"Enter his gates with thanksgiving and his courts with praise.",r:"Psalm 100:4 NIV"},
  {m:11,d:3,v:"Give thanks to the Lord, call on his name; make known among the nations what he has done.",r:"Psalm 105:1 NIV"},
  {m:11,d:4,v:"I will give thanks to you, Lord, with all my heart.",r:"Psalm 9:1 NIV"},
  {m:11,d:5,v:"Oh give thanks to the Lord, for he is good, for his steadfast love endures forever!",r:"Psalm 118:1 NIV"},
  {m:11,d:6,v:"Let the peace of Christ rule in your hearts. And be thankful.",r:"Colossians 3:15 NIV"},
  {m:11,d:7,v:"Devote yourselves to prayer, being watchful and thankful.",r:"Colossians 4:2 NIV"},
  {m:11,d:8,v:"Give thanks in all circumstances; for this is God will for you in Christ Jesus.",r:"1 Thessalonians 5:18 NIV"},
  {m:11,d:9,v:"Thanks be to God for his indescribable gift!",r:"2 Corinthians 9:15 NIV"},
  {m:11,d:10,v:"The Lord is gracious and compassionate, slow to anger and rich in love.",r:"Psalm 145:8 NIV"},
  {m:11,d:11,v:"Give thanks to the Lord, for he is good; his love endures forever.",r:"1 Chronicles 16:34 NIV"},
  {m:11,d:12,v:"Now, our God, we give you thanks, and praise your glorious name.",r:"1 Chronicles 29:13 NIV"},
  {m:11,d:13,v:"This is the day the Lord has made; let us rejoice and be glad in it.",r:"Psalm 118:24 NIV"},
  {m:11,d:14,v:"The Lord has done great things for us, and we are filled with joy.",r:"Psalm 126:3 NIV"},
  {m:11,d:15,v:"The joy of the Lord is your strength.",r:"Nehemiah 8:10 NIV"},
  {m:11,d:16,v:"Rejoice in the Lord always. I will say it again: Rejoice!",r:"Philippians 4:4 NIV"},
  {m:11,d:17,v:"Every good and perfect gift is from above, coming down from the Father.",r:"James 1:17 NIV"},
  {m:11,d:18,v:"Do not be anxious about anything, but in every situation present your requests to God with thanksgiving.",r:"Philippians 4:6 NIV"},
  {m:11,d:19,v:"And the peace of God will guard your hearts and your minds in Christ Jesus.",r:"Philippians 4:7 NIV"},
  {m:11,d:20,v:"I have learned, in whatever state I am, to be content.",r:"Philippians 4:11 NIV"},
  {m:11,d:21,v:"And my God will meet all your needs according to the riches of his glory in Christ Jesus.",r:"Philippians 4:19 NIV"},
  {m:11,d:22,v:"Her children arise and call her blessed; her husband also, and he praises her.",r:"Proverbs 31:28 NIV"},
  {m:11,d:23,v:"She is clothed with strength and dignity; she can laugh at the days to come.",r:"Proverbs 31:25 NIV"},
  {m:11,d:24,v:"Charm is deceptive, and beauty is fleeting; but a woman who fears the Lord is to be praised.",r:"Proverbs 31:30 NIV"},
  {m:11,d:25,v:"Children are a heritage from the Lord, offspring a reward from him.",r:"Psalm 127:3 NIV"},
  {m:11,d:26,v:"Honor your father and your mother, so that you may live long in the land.",r:"Exodus 20:12 NIV"},
  {m:11,d:27,v:"He who began a good work in you will carry it on to completion.",r:"Philippians 1:6 NIV"},
  {m:11,d:28,v:"For I am convinced that neither death nor life can separate us from the love of God.",r:"Romans 8:38-39 NIV"},
  {m:11,d:29,v:"If God is for us, who can be against us?",r:"Romans 8:31 NIV"},
  {m:11,d:30,v:"May the God of hope fill you with all joy and peace as you trust in him.",r:"Romans 15:13 NIV"},
  {m:12,d:1,v:"For to us a child is born, to us a son is given, and the government will be on his shoulders.",r:"Isaiah 9:6 NIV"},
  {m:12,d:2,v:"And he will be called Wonderful Counselor, Mighty God, Everlasting Father, Prince of Peace.",r:"Isaiah 9:6 NIV"},
  {m:12,d:3,v:"The Lord himself will give you a sign: The virgin will conceive and give birth to a son, and will call him Immanuel.",r:"Isaiah 7:14 NIV"},
  {m:12,d:4,v:"He tends his flock like a shepherd: He gathers the lambs in his arms and carries them close to his heart.",r:"Isaiah 40:11 NIV"},
  {m:12,d:5,v:"The people walking in darkness have seen a great light; on those living in the land of deep darkness a light has dawned.",r:"Isaiah 9:2 NIV"},
  {m:12,d:6,v:"Arise, shine, for your light has come, and the glory of the Lord rises upon you.",r:"Isaiah 60:1 NIV"},
  {m:12,d:7,v:"How beautiful on the mountains are the feet of those who bring good news, who proclaim peace.",r:"Isaiah 52:7 NIV"},
  {m:12,d:8,v:"Do not be afraid. I bring you good news that will cause great joy for all the people.",r:"Luke 2:10 NIV"},
  {m:12,d:9,v:"Today in the town of David a Savior has been born to you; he is the Messiah, the Lord.",r:"Luke 2:11 NIV"},
  {m:12,d:10,v:"Glory to God in the highest heaven, and on earth peace to those on whom his favor rests.",r:"Luke 2:14 NIV"},
  {m:12,d:11,v:"But Mary treasured up all these things and pondered them in her heart.",r:"Luke 2:19 NIV"},
  {m:12,d:12,v:"The true light that gives light to everyone was coming into the world.",r:"John 1:9 NIV"},
  {m:12,d:13,v:"Yet to all who did receive him, to those who believed in his name, he gave the right to become children of God.",r:"John 1:12 NIV"},
  {m:12,d:14,v:"She will give birth to a son, and you are to give him the name Jesus, because he will save his people from their sins.",r:"Matthew 1:21 NIV"},
  {m:12,d:15,v:"They saw the child with his mother Mary, and they bowed down and worshiped him.",r:"Matthew 2:11 NIV"},
  {m:12,d:16,v:"Where is the one who has been born king of the Jews? We saw his star when it rose and have come to worship him.",r:"Matthew 2:2 NIV"},
  {m:12,d:17,v:"For God so loved the world that he gave his one and only Son, that whoever believes in him shall not perish but have eternal life.",r:"John 3:16 NIV"},
  {m:12,d:18,v:"Thanks be to God for his indescribable gift!",r:"2 Corinthians 9:15 NIV"},
  {m:12,d:19,v:"For to us a child is born. Of the greatness of his government and peace there will be no end.",r:"Isaiah 9:6-7 NIV"},
  {m:12,d:20,v:"The Lord himself will give you a sign: The virgin will conceive — God with us.",r:"Isaiah 7:14 NIV"},
  {m:12,d:21,v:"A voice of one calling: In the wilderness prepare the way for the Lord.",r:"Isaiah 40:3 NIV"},
  {m:12,d:22,v:"For nothing will be impossible with God.",r:"Luke 1:37 NIV"},
  {m:12,d:23,v:"Blessed is she who has believed that the Lord would fulfill his promises to her!",r:"Luke 1:45 NIV"},
  {m:12,d:24,v:"She wrapped him in cloths and placed him in a manger, because there was no guest room available for them.",r:"Luke 2:7 NIV"},
  {m:12,d:25,v:"Today in the town of David a Savior has been born to you; he is the Messiah, the Lord.",r:"Luke 2:11 NIV"},
  {m:12,d:26,v:"The shepherds returned, glorifying and praising God for all the things they had heard and seen.",r:"Luke 2:20 NIV"},
  {m:12,d:27,v:"Let the word of Christ dwell in you richly, teaching and admonishing one another in all wisdom.",r:"Colossians 3:16 NIV"},
  {m:12,d:28,v:"Now, our God, we give you thanks, and praise your glorious name.",r:"1 Chronicles 29:13 NIV"},
  {m:12,d:29,v:"The steadfast love of the Lord never ceases; his mercies never come to an end.",r:"Lamentations 3:22 NIV"},
  {m:12,d:30,v:"He who was seated on the throne said, I am making everything new!",r:"Revelation 21:5 NIV"},
  {m:12,d:31,v:"It is done. I am the Alpha and the Omega, the Beginning and the End.",r:"Revelation 21:6 NIV"},
];

const ScriptureScreen = () => {
  const today = new Date();
  const [selectedMonth, setSelectedMonth] = useState(today.getMonth() + 1);
  const [selectedDay, setSelectedDay] = useState(today.getDate());
  const scripture = SCRIPTURES.find(s => s.m === selectedMonth && s.d === selectedDay);
  const daysInMonth = new Date(today.getFullYear(), selectedMonth, 0).getDate();
  const isToday = selectedMonth === today.getMonth() + 1 && selectedDay === today.getDate();
  return (
    <div style={{ padding: "56px 28px 100px" }}>
      <FadeIn>
        <Label style={{ marginBottom: 12 }}>Daily Scripture</Label>
        <Serif size={30} italic style={{ display: "block", lineHeight: 1.25, marginBottom: 6 }}>A word for</Serif>
        <Serif size={30} style={{ display: "block", lineHeight: 1.25, marginBottom: 32 }}>today.</Serif>
      </FadeIn>
      <FadeIn delay={100}>
        <Label style={{ marginBottom: 10 }}>Month</Label>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 20 }}>
          {MONTH_NAMES.map((m, i) => (
            <button key={i} onClick={() => { setSelectedMonth(i + 1); setSelectedDay(1); }}
              style={{ padding: "6px 10px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.1em", textTransform: "uppercase", background: selectedMonth === i + 1 ? T.ink : T.sand, color: selectedMonth === i + 1 ? T.ivory : T.inkSoft, border: "none", borderRadius: 2, cursor: "pointer" }}>
              {m.substring(0, 3)}
            </button>
          ))}
        </div>
      </FadeIn>
      <FadeIn delay={150}>
        <Label style={{ marginBottom: 10 }}>Day</Label>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 5, marginBottom: 28 }}>
          {Array.from({ length: daysInMonth }, (_, i) => i + 1).map(d => (
            <button key={d} onClick={() => setSelectedDay(d)}
              style={{ width: 34, height: 34, fontFamily: "'Jost', sans-serif", fontSize: 12, background: selectedDay === d ? T.ink : T.sand, color: selectedDay === d ? T.ivory : T.inkSoft, border: "none", borderRadius: 2, cursor: "pointer" }}>
              {d}
            </button>
          ))}
        </div>
      </FadeIn>
      {scripture && (
        <FadeIn delay={200}>
          <div style={{ background: T.sand, borderRadius: 2, padding: "28px 24px", borderLeft: "3px solid " + T.ink }}>
            <Label style={{ marginBottom: 14 }}>{MONTH_NAMES[selectedMonth - 1]} {selectedDay}</Label>
            <Serif size={20} italic color={T.inkMid} style={{ display: "block", lineHeight: 1.75, marginBottom: 18 }}>
              {"“"}{scripture.v}{"”"}
            </Serif>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div style={{ height: 1, flex: 1, background: T.sandMid }} />
              <Serif size={13} color={T.inkSoft} style={{ fontStyle: "normal" }}>{scripture.r}</Serif>
            </div>
          </div>
        </FadeIn>
      )}
      {!isToday && (
        <FadeIn delay={250}>
          <button onClick={() => { setSelectedMonth(today.getMonth() + 1); setSelectedDay(today.getDate()); }}
            style={{ marginTop: 20, width: "100%", background: "none", border: "1px solid " + T.sandMid, borderRadius: 2, padding: "12px", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.14em", textTransform: "uppercase", color: T.inkSoft, cursor: "pointer" }}>
            Back to Today
          </button>
        </FadeIn>
      )}
    </div>
  );
};


const MoodIcon = ({ type }) => {
  const icons = {
    heavy: (
      <svg width="48" height="48" viewBox="0 0 56 56">
        <ellipse cx="28" cy="28" r="26" fill="#EDE5D8" stroke="#1C1610" strokeWidth="0.5"/>
        <path d="M28 14 C34 22 36 30 28 42" fill="none" stroke="#1C1610" strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M28 14 C22 22 20 30 28 42" fill="none" stroke="#1C1610" strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M22 24 C25 22 31 22 34 24" fill="none" stroke="#1C1610" strokeWidth="1" strokeLinecap="round"/>
        <path d="M21 31 C25 29 31 29 35 31" fill="none" stroke="#1C1610" strokeWidth="1" strokeLinecap="round"/>
        <line x1="28" y1="14" x2="28" y2="42" stroke="#1C1610" strokeWidth="1" strokeLinecap="round"/>
      </svg>
    ),
    anxious: (
      <svg width="48" height="48" viewBox="0 0 56 56">
        <ellipse cx="28" cy="28" r="26" fill="#EDE5D8" stroke="#1C1610" strokeWidth="0.5"/>
        <path d="M28 28 C28 22 34 18 38 22 C42 26 40 36 32 40 C22 44 12 36 12 26 C12 14 22 8 34 10" fill="none" stroke="#1C1610" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
    numb: (
      <svg width="48" height="48" viewBox="0 0 56 56">
        <ellipse cx="28" cy="28" r="26" fill="#EDE5D8" stroke="#1C1610" strokeWidth="0.5"/>
        <line x1="14" y1="30" x2="42" y2="30" stroke="#1C1610" strokeWidth="1.5" strokeLinecap="round"/>
        <circle cx="20" cy="22" r="2" fill="#1C1610"/>
        <circle cx="28" cy="22" r="2" fill="#1C1610"/>
        <circle cx="36" cy="22" r="2" fill="#1C1610"/>
      </svg>
    ),
    okay: (
      <svg width="48" height="48" viewBox="0 0 56 56">
        <ellipse cx="28" cy="28" r="26" fill="#EDE5D8" stroke="#1C1610" strokeWidth="0.5"/>
        <path d="M28 40 C18 32 16 18 28 12 C40 18 38 32 28 40Z" fill="none" stroke="#1C1610" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <line x1="28" y1="40" x2="28" y2="12" stroke="#1C1610" strokeWidth="1" strokeLinecap="round" strokeDasharray="2,2"/>
      </svg>
    ),
    grateful: (
      <svg width="48" height="48" viewBox="0 0 56 56">
        <ellipse cx="28" cy="28" r="26" fill="#EDE5D8" stroke="#1C1610" strokeWidth="0.5"/>
        <line x1="28" y1="14" x2="28" y2="42" stroke="#1C1610" strokeWidth="1.5" strokeLinecap="round"/>
        <line x1="14" y1="28" x2="42" y2="28" stroke="#1C1610" strokeWidth="1.5" strokeLinecap="round"/>
        <line x1="18" y1="18" x2="38" y2="38" stroke="#1C1610" strokeWidth="1" strokeLinecap="round"/>
        <line x1="38" y1="18" x2="18" y2="38" stroke="#1C1610" strokeWidth="1" strokeLinecap="round"/>
        <circle cx="28" cy="28" r="3" fill="#1C1610"/>
      </svg>
    ),
  };
  return icons[type] || null;
};

const MoodCheckIn = ({ onSelect, onSkip }) => {
  const moods = [
    { type: "heavy", label: "Heavy", sub: "I am carrying something today", screen: "journal" },
    { type: "anxious", label: "Anxious", sub: "My mind will not quiet down", screen: "ritual" },
    { type: "numb", label: "Numb", sub: "I feel a little disconnected", screen: "scripture" },
    { type: "okay", label: "Okay", sub: "Just checking in today", screen: "community" },
    { type: "grateful", label: "Grateful", sub: "I want to reflect and grow", screen: "library" },
  ];
  return (
    <div style={{ position: "fixed", inset: 0, top: 0, left: 0, right: 0, bottom: 0, background: "radial-gradient(ellipse at center, #0D3B5E 0%, #071E30 70%, #050F1A 100%)", zIndex: 500, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "32px 28px", overflowY: "auto" }}>
      <div style={{ width: "100%", maxWidth: 380 }}>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <img src="/pure-reve-icon-light.svg" style={{ width: 52, height: 52, display: "block", margin: "0 auto 12px" }} alt="Pure Reve" />
          <Serif size={13} color="#EDE5D8" style={{ display: "block", letterSpacing: "0.2em", textTransform: "uppercase", fontStyle: "normal", marginTop: 10, marginBottom: 8, opacity: 0.5 }}>Pure Rêve<sup style={{ fontSize: "0.55em", letterSpacing: 0, marginLeft: 2, verticalAlign: "super" }}>™</sup></Serif>
          <Serif size={28} italic color="#FAF7F2" style={{ display: "block", lineHeight: 1.3, marginBottom: 4 }}>{TRANSLATIONS.en.howArriving}</Serif>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {moods.map((mood, i) => (
            <button key={i} onClick={() => onSelect(mood.screen)}
              style={{ background: "rgba(237,229,216,0.07)", border: "1px solid rgba(237,229,216,0.15)", borderRadius: 2, padding: "12px 18px", cursor: "pointer", textAlign: "left", display: "flex", alignItems: "center", gap: 16, transition: "background 0.2s" }}
              onMouseEnter={e => e.currentTarget.style.background = "rgba(237,229,216,0.14)"}
              onMouseLeave={e => e.currentTarget.style.background = "rgba(237,229,216,0.07)"}>
              <MoodIcon type={mood.type} />
              <div>
                <Serif size={17} color="#FAF7F2" style={{ display: "block", marginBottom: 2 }}>{mood.label}</Serif>
                <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: "#A89880", fontWeight: 300 }}>{mood.sub}</span>
              </div>
            </button>
          ))}
        </div>
        <button onClick={onSkip} style={{ marginTop: 18, width: "100%", background: "none", border: "none", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.14em", textTransform: "uppercase", color: "#7A6A58", cursor: "pointer", padding: "12px" }}>
          Enter the Sanctuary →
        </button>
      </div>
    </div>
  );
};




const StillnessTracker = ({ user, appLang }) => {
  const today = new Date();
  const todayStr = today.toDateString();
  const [checked, setChecked] = useState([]);
  const [justChecked, setJustChecked] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

  if (!user) { setLoading(false); return; }
    supabase.from('tracker').select('date_str').eq('user_id', user.id)
      .then(({ data }) => {
        if (data) setChecked(data.map(r => r.date_str));
        setLoading(false);
      });
  }, [user]);

  const saveCheck = async () => {
    if (checked.includes(todayStr) || !user) return;
    const { error } = await supabase.from('tracker').insert({ user_id: user.id, date_str: todayStr });
    if (!error) {
      setChecked([...checked, todayStr]);
      setJustChecked(true);
      setTimeout(() => setJustChecked(false), 3000);
    }
  };

  const streak = (() => {
    let count = 0;
    const d = new Date();
    while (true) {
      if (checked.includes(d.toDateString())) { count++; d.setDate(d.getDate() - 1); }
      else break;
    }
    return count;
  })();

  const doneToday = checked.includes(todayStr);
  const month = today.getMonth();
  const year = today.getFullYear();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const firstDay = new Date(year, month, 1).getDay();
  const MONTH_NAMES = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  const DAY_NAMES = ["Su","Mo","Tu","We","Th","Fr","Sa"];

  const INSIGHTS = [
    "Stillness is not the absence of noise. It is the presence of peace.",
    "Seven evenings of rest have prepared you for seven mornings of strength.",
    "Consistency is the quietest form of courage. You are building something real.",
    "What you tend to grows. You have tended to your peace for a week.",
    "The body remembers every night you gave it rest. It is grateful.",
    "You are not just taking a gummy. You are choosing yourself, every night.",
    "Seven days. Seven acts of self-love. The sanctuary is becoming yours.",
  ];
  const insight = streak >= 7 ? INSIGHTS[Math.min(Math.floor(streak / 7) - 1, INSIGHTS.length - 1)] : null;

  if (loading) return <div style={{ marginTop: 32, textAlign: "center" }}><Serif size={14} italic color={T.inkGhost} style={{ display: "block" }}>Loading your sanctuary...</Serif></div>;

  return (
    <div style={{ marginTop: 32 }}>
      <div style={{ height: 1, background: T.sand, margin: "0 0 28px" }} />
      <Label style={{ marginBottom: 8 }}>Stillness Tracker</Label>
      <Serif size={22} italic style={{ display: "block", marginBottom: 4 }}>Build your practice.</Serif>
      <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkSoft, fontWeight: 300, display: "block", marginBottom: 24 }}>Mark each night you took your Stillness Gummy.</span>

      <div style={{ background: T.ink, borderRadius: 2, padding: "18px 22px", marginBottom: 20, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div>
          <Label style={{ color: T.sandDark, marginBottom: 6 }}>Current Streak</Label>
          <Serif size={36} color={T.ivory} style={{ display: "block", lineHeight: 1 }}>{streak}</Serif>
          <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.sandDark, letterSpacing: "0.1em", textTransform: "uppercase" }}>{streak === 1 ? "night" : "nights"}</span>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 42, color: T.sandDark, lineHeight: 1 }}>✦</div>
          {streak >= 7 && <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.sandDark, letterSpacing: "0.14em", textTransform: "uppercase" }}>Deep Stillness</span>}
        </div>
      </div>

      <div style={{ background: T.sand, borderRadius: 2, padding: "16px 18px", marginBottom: 20 }}>
        <Label style={{ marginBottom: 12 }}>{MONTH_NAMES[month]} {year}</Label>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 4, marginBottom: 8 }}>
          {DAY_NAMES.map(d => (
            <div key={d} style={{ textAlign: "center", fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, letterSpacing: "0.08em", paddingBottom: 4 }}>{d}</div>
          ))}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 4 }}>
          {Array.from({ length: firstDay }, (_, i) => <div key={"e" + i} />)}
          {Array.from({ length: daysInMonth }, (_, i) => {
            const d = new Date(year, month, i + 1);
            const dStr = d.toDateString();
            const isChecked = checked.includes(dStr);
            const isToday = dStr === todayStr;
            return (
              <div key={i} style={{ aspectRatio: "1", borderRadius: "50%", background: isChecked ? T.ink : isToday ? T.sandMid : "transparent", border: isToday && !isChecked ? "1px solid " + T.sandDark : "none", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: isChecked ? T.ivory : isToday ? T.inkMid : T.inkGhost, fontWeight: isToday ? 500 : 300 }}>{i + 1}</span>
              </div>
            );
          })}
        </div>
      </div>

      {!doneToday ? (
        <div style={{ background: T.sand, borderRadius: 2, padding: "4px 16px 16px", marginBottom: 8 }}>
          <GummyDissolveTimer onComplete={saveCheck} />
        </div>
      ) : (
        <div style={{ textAlign: "center", padding: "16px 0", marginBottom: 8 }}>
          <Serif size={18} italic color={T.inkMid} style={{ display: "block", marginBottom: 4 }}>
            {justChecked ? "Marked. Rest well tonight. ✦" : "Tonight is complete. ✦"}
          </Serif>
          <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkGhost, fontWeight: 300 }}>Come back tomorrow to continue your streak.</span>
        </div>
      )}

      {streak >= 7 && insight && (
        <div style={{ marginTop: 16, padding: "18px 20px", borderLeft: "2px solid " + T.ink, background: T.sand, borderRadius: 2 }}>
          <Label style={{ marginBottom: 8 }}>Deep Stillness — Day {streak}</Label>
          <Serif size={15} italic color={T.inkMid} style={{ display: "block", lineHeight: 1.8 }}>"{insight}"</Serif>
        </div>
      )}

      {streak >= 30 && (
        <div style={{ marginTop: 16, padding: "18px 20px", background: T.ink, borderRadius: 2, textAlign: "center" }}>
          <Label style={{ color: T.sandDark, marginBottom: 8 }}>30-Day Sanctuary Achievement</Label>
          <Serif size={18} italic color={T.ivory} style={{ display: "block", marginBottom: 12 }}>You have earned your sanctuary.</Serif>
          <div style={{ background: T.sandDark, borderRadius: 2, padding: "10px 16px", display: "inline-block" }}>
            <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.ink, letterSpacing: "0.18em" }}>STILLNESS30</span>
          </div>
          <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, display: "block", marginTop: 8, fontWeight: 300 }}>Use this code for 20% off your next order.</span>
        </div>
      )}

      {streak < 30 && (
        <div style={{ marginTop: 16 }}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
            <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkGhost, letterSpacing: "0.1em", textTransform: "uppercase" }}>Next milestone</span>
            <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkGhost }}>{streak < 7 ? 7 - streak + " nights to Deep Stillness" : 30 - streak + " nights to 20% off"}</span>
          </div>
          <div style={{ height: 3, background: T.sand, borderRadius: 2 }}>
            <div style={{ height: 3, background: T.ink, borderRadius: 2, width: (streak < 7 ? (streak / 7) * 100 : (streak / 30) * 100) + "%", transition: "width 0.5s ease" }} />
          </div>
        </div>
      )}

      <div style={{ marginTop: 24 }}>
        <SunsetButton />
        <DumpHistory user={user} />
      </div>
    </div>
  );
};
const SunsetButton = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      {open && <DigitalSunset onClose={() => setOpen(false)} />}
      <button onClick={() => setOpen(true)}
        style={{ width: "100%", background: "radial-gradient(ellipse at center, #0D3B5E 0%, #071E30 70%, #050F1A 100%)", color: "#B8A48C", border: "1px solid #3D3228", borderRadius: 2, padding: "16px", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.16em", textTransform: "uppercase", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}>
        <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 18 }}>✦</span>
        Ready for your Digital Sunset?
      </button>
    </>
  );
};


const ReleaseWall = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    supabase.from('release_wall').select('text, created_at').order('created_at', { ascending: false }).limit(30)
      .then(({ data }) => { if (data) setPosts(data); setLoading(false); });
  }, []);
  if (loading) return null;
  return (
    <div style={{ marginTop: 24 }}>
      <div style={{ height: 1, background: "rgba(237,229,216,0.15)", margin: "0 0 16px" }} />
      <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.18em", textTransform: "uppercase", color: "#7A6A58", margin: "0 0 14px" }}>What others released tonight</p>
      {posts.length === 0 ? (
        <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 15, fontStyle: "italic", color: "#7A6A58", margin: 0 }}>Be the first to release something tonight.</p>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {posts.map((post, i) => (
            <div key={i} style={{ borderLeft: "1px solid rgba(184,164,140,0.3)", paddingLeft: 14 }}>
              <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 15, fontStyle: "italic", color: "#EDE5D8", margin: "0 0 3px", lineHeight: 1.6 }}>"{post.text}"</p>
              <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: "#5F5E5A", margin: 0 }}>{new Date(post.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
const DigitalSunset = ({ onClose, appLang }) => {
  const [step, setStep] = useState(0);
  const [thought, setThought] = useState("");
  const [released, setReleased] = useState(false);
  const today = new Date();
  const MONTH_NAMES = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  const SCRIPTURES_SUNSET = [
    {v:"Be still, and know that I am God.",r:"Psalm 46:10 NIV"},
    {v:"I will lie down and sleep in peace, for you alone, Lord, make me dwell in safety.",r:"Psalm 4:8 NIV"},
    {v:"Come to me, all you who are weary and burdened, and I will give you rest.",r:"Matthew 11:28 NIV"},
    {v:"Cast all your anxiety on him because he cares for you.",r:"1 Peter 5:7 NIV"},
    {v:"The Lord gives strength to his people; the Lord blesses his people with peace.",r:"Psalm 29:11 NIV"},
    {v:"Peace I leave with you; my peace I give you.",r:"John 14:27 NIV"},
    {v:"And the peace of God will guard your hearts and your minds in Christ Jesus.",r:"Philippians 4:7 NIV"},
  ];
  const scripture = SCRIPTURES_SUNSET[today.getDay()];
  const base = { position: "fixed", inset: 0, top: 0, left: 0, right: 0, bottom: 0, background: "radial-gradient(ellipse at center, #0D3B5E 0%, #071E30 70%, #050F1A 100%)", zIndex: 300, display: "flex", flexDirection: "column" };
  const NBtn = ({ onClick, label="Next →" }) => (
    <button onClick={onClick} style={{ background: "#B8A48C", color: "#0D3B5E", border: "none", borderRadius: 2, padding: "13px 24px", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.14em", textTransform: "uppercase", cursor: "pointer" }}>{label}</button>
  );
  const BBtn = ({ onClick }) => (
    <button onClick={onClick} style={{ background: "none", color: "#7A6A58", border: "1px solid #3D3228", borderRadius: 2, padding: "13px 24px", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.14em", textTransform: "uppercase", cursor: "pointer" }}>← Back</button>
  );
  const Hdr = ({ n, title }) => (
    <div style={{ marginBottom: 28 }}>
      <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 36, color: "#B8A48C" }}>✦</span>
      <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.2em", textTransform: "uppercase", color: "#7A6A58", margin: "10px 0 4px" }}>Digital Sunset · Step {n} of 3</p>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 30, fontStyle: "italic", color: "#FAF7F2", margin: 0 }}>{title}</p>
    </div>
  );
  if (step === 0) return (
    <div style={base}>
      <div style={{ width: "100%", maxWidth: 380, margin: "0 auto" }}>
        <Hdr n="1" title="The Dump" />
        <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 14, color: "#A89880", fontWeight: 300, lineHeight: 1.8, margin: "0 0 20px" }}>Leave one thought you do not need to carry into sleep.</p>
        <textarea value={thought} onChange={e => setThought(e.target.value)} placeholder="Write it and release it..." rows={4}
          style={{ width: "100%", background: "rgba(237,229,216,0.06)", border: "1px solid rgba(237,229,216,0.15)", borderRadius: 2, padding: "16px 18px", fontFamily: "'Jost', sans-serif", fontSize: 14, fontWeight: 300, color: "#FAF7F2", lineHeight: 1.9, resize: "none", outline: "none", boxSizing: "border-box", marginBottom: 14 }} />
        {released ? (
          <div style={{ padding: "12px 0 8px" }}>
            <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 18, fontStyle: "italic", color: "#B8A48C", margin: "0 0 4px" }}>Released. ✦</p>
            <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: "#7A6A58", margin: 0, fontWeight: 300 }}>You are held. You are safe.</p>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 8 }}>
            <button onClick={async () => {
              if (thought.trim()) { try { await supabase.from('release_wall').insert({ text: thought.trim() }); } catch(e) {} }
              setReleased(true);
            }} style={{ width: "100%", background: "#B8A48C", color: "#0D3B5E", border: "none", borderRadius: 2, padding: "13px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", cursor: "pointer" }}>✦ Release and Share Anonymously</button>
            <button onClick={() => setReleased(true)}
              style={{ width: "100%", background: "none", color: "#B8A48C", border: "1px solid #3D3228", borderRadius: 2, padding: "13px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", cursor: "pointer" }}>Release Forever (Private)</button>
            <button onClick={async () => {
              if (thought.trim()) { try { const res = await supabase.auth.getUser(); const user = res.data.user; if (user) await supabase.from('dump_history').insert({ user_id: user.id, text: thought.trim(), date_str: new Date().toDateString() }); } catch(e) {} }
              setReleased(true);
            }} style={{ width: "100%", background: "none", color: "#B8A48C", border: "1px solid #3D3228", borderRadius: 2, padding: "13px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", cursor: "pointer" }}>Release and Remember (Private)</button>
            <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: "#3D3228", textAlign: "center", margin: "4px 0 0" }}>Anonymous shares appear on the Release Wall below.</p>
          </div>
        )}
        <ReleaseWall />
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 24 }}>
          <button onClick={onClose} style={{ background: "none", border: "none", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.12em", textTransform: "uppercase", color: "#3D3228", cursor: "pointer", padding: 0 }}>← Close</button>
          <NBtn onClick={() => setStep(1)} />
        </div>
      </div>
    </div>
  );
  if (step === 1) return (
    <div style={base}>
      <div style={{ width: "100%", maxWidth: 380, margin: "0 auto" }}>
        <Hdr n="2" title="The Nourishment" />
        <div style={{ background: "rgba(184,164,140,0.08)", border: "1px solid rgba(184,164,140,0.2)", borderRadius: 2, padding: "28px 24px", marginBottom: 32 }}>
          <div style={{ width: 60, height: 60, borderRadius: "50%", border: "1px solid #B8A48C", margin: "0 auto 16px", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 28, color: "#B8A48C" }}>✦</span>
          </div>
          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontStyle: "italic", color: "#FAF7F2", lineHeight: 1.8, margin: "0 0 10px", textAlign: "center" }}>Take your Stillness Gummy</p>
          <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: "#7A6A58", fontWeight: 300, lineHeight: 1.6, margin: 0, textAlign: "center" }}>Let it begin its work while you rest in tonight's scripture.</p>
        </div>
        <button onClick={() => setStep(2)} style={{ width: "100%", background: "#B8A48C", color: "#0D3B5E", border: "none", borderRadius: 2, padding: "15px", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.16em", textTransform: "uppercase", cursor: "pointer" }}>I Took My Gummy → Continue</button>
      </div>
    </div>
  );
  if (step === 2) return (
    <div style={base}>
      <div style={{ width: "100%", maxWidth: 380, margin: "0 auto" }}>
        <Hdr n="3" title="The Anchor" />
        <div style={{ borderLeft: "2px solid #B8A48C", paddingLeft: 20, marginBottom: 32 }}>
          <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.16em", textTransform: "uppercase", color: "#7A6A58", margin: "0 0 12px" }}>{MONTH_NAMES[today.getMonth()]} {today.getDate()}</p>
          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 22, fontStyle: "italic", color: "#FAF7F2", lineHeight: 1.75, margin: "0 0 14px" }}>"{scripture.v}"</p>
          <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: "#7A6A58", fontWeight: 300, margin: 0 }}>{scripture.r}</p>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <BBtn onClick={() => setStep(1)} />
          <NBtn onClick={() => setStep(3)} label="Receive this Word →" />
        </div>
      </div>
    </div>
  );
  return (
    <div style={{ position: "fixed", inset: 0, background: "radial-gradient(ellipse at center, #0D3B5E 0%, #071E30 70%, #050F1A 100%)", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center", padding: "48px 32px" }}>
      <div style={{ maxWidth: 380 }}>
        <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 56, color: "#B8A48C" }}>✦</span>
        <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 34, fontStyle: "italic", color: "#FAF7F2", lineHeight: 1.4, margin: "24px 0 16px" }}>Rest well.</p>
        <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, color: "#7A6A58", lineHeight: 1.6, margin: "0 0 4px" }}>The sanctuary is closed</p>
        <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, color: "#7A6A58", lineHeight: 1.6, margin: 0 }}>until morning.</p>
      </div>
    </div>
  );
};

const AuthScreen = ({ onAuth, onShowTerms, onShowPrivacy }) => {
  const [showDoc, setShowDoc] = useState(null); // "terms" | "privacy" | null
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const [ageOk, setAgeOk] = useState(false);
  const [marketingOk, setMarketingOk] = useState(false);

  const handleSubmit = async () => {
    if (!email || !password) { setError("Please enter your email and password."); return; }
    if (mode === "signup" && !ageOk) { setError("Please confirm you are at least 18 and agree to the Terms and Privacy Policy."); return; }
    setLoading(true); setError(""); setMessage("");
    try {
      if (mode === "signup") {
        const { error } = await supabase.auth.signUp({ email, password });
        if (!error && marketingOk) await subscribeToKlaviyo(email);
        if (error) throw error;
        setMessage("Check your email to confirm your account. Then log in.");
      } else {
        const { data, error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) throw error;
        onAuth(data.user);
      }
    } catch (e) {
      setError(e.message);
    }
    setLoading(false);
  };

  const handleGoogle = async () => {
    if (mode === "signup" && !ageOk) { setError("Please confirm you are at least 18 and agree to the Terms and Privacy Policy."); return; }
    setLoading(true);
    const { error } = await supabase.auth.signInWithOAuth({ provider: "google" });
    if (error) setError(error.message);
    setLoading(false);
  };

  if (showDoc) return (
    <div style={{ position: "fixed", inset: 0, background: T.ivory, zIndex: 900, overflowY: "auto", padding: "48px 24px 40px" }}>
      <button onClick={() => setShowDoc(null)} style={{ background: "none", border: "none", fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkSoft, cursor: "pointer", marginBottom: 24, padding: 0 }}>← Back</button>
      {showDoc === 'terms' ? <TermsScreen setScreen={() => setShowDoc(null)} /> : <PrivacyScreen setScreen={() => setShowDoc(null)} />}
    </div>
  );

  return (
    <div style={{ minHeight: "100vh", background: T.ivory, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "48px 28px" }}>
      <FadeIn>
        <div style={{ width: "100%", maxWidth: 380, textAlign: "center" }}>
          <img src="/pure-reve-icon.svg" style={{ width: 72, height: 72, display: "block", margin: "0 auto 24px" }} alt="Pure Reve" />
          <Serif size={13} color={T.inkGhost} style={{ display: "block", letterSpacing: "0.22em", textTransform: "uppercase", fontStyle: "normal", margin: "12px 0 4px" }}>Pure Rêve<sup style={{ fontSize: "0.55em", letterSpacing: 0, marginLeft: 2, verticalAlign: "super" }}>™</sup></Serif>
          <Serif size={28} italic style={{ display: "block", marginBottom: 4 }}>{mode === "signup" ? "Create your" : "Return to your"}</Serif>
          <Serif size={28} style={{ display: "block", marginBottom: 36 }}>sanctuary.</Serif>

          <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 20 }}>
            <input value={email} onChange={e => setEmail(e.target.value)} placeholder="Email address" type="email"
              style={{ width: "100%", background: T.sand, border: "1px solid " + T.sandMid, borderRadius: 2, padding: "13px 16px", fontFamily: "'Jost', sans-serif", fontSize: 13, fontWeight: 300, color: T.ink, outline: "none", boxSizing: "border-box" }} />
            <input value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" type="password"
              onKeyDown={e => e.key === "Enter" && handleSubmit()}
              style={{ width: "100%", background: T.sand, border: "1px solid " + T.sandMid, borderRadius: 2, padding: "13px 16px", fontFamily: "'Jost', sans-serif", fontSize: 13, fontWeight: 300, color: T.ink, outline: "none", boxSizing: "border-box" }} />
          </div>

          {mode === "signup" && (
            <label style={{ display: "flex", alignItems: "flex-start", gap: 10, textAlign: "left", margin: "0 0 14px", cursor: "pointer" }}>
              <input type="checkbox" checked={ageOk} onChange={e => setAgeOk(e.target.checked)} style={{ marginTop: 3, accentColor: T.ink }} />
              <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkSoft, lineHeight: 1.6 }}>I am at least 18 years old and I agree to the Terms of Service and Privacy Policy.</span>
            </label>
          )}
          {mode === "signup" && (
            <label style={{ display: "flex", alignItems: "flex-start", gap: 10, textAlign: "left", margin: "0 0 14px", cursor: "pointer" }}>
              <input type="checkbox" checked={marketingOk} onChange={e => setMarketingOk(e.target.checked)} style={{ marginTop: 3, accentColor: T.ink }} />
              <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkSoft, lineHeight: 1.6 }}>Send me occasional emails from Pure Rêve. I can unsubscribe anytime. (Optional)</span>
            </label>
          )}
          {error && <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: "#C0392B", margin: "0 0 12px", lineHeight: 1.5 }}>{error}</p>}
          {message && <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkSoft, margin: "0 0 12px", lineHeight: 1.5 }}>{message}</p>}

          <button onClick={handleSubmit} disabled={loading}
            style={{ width: "100%", background: T.ink, color: T.ivory, border: "none", borderRadius: 2, padding: "14px", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.16em", textTransform: "uppercase", cursor: "pointer", marginBottom: 10, opacity: loading ? 0.6 : 1 }}>
            {loading ? "Please wait..." : mode === "signup" ? "Create Sanctuary" : "Enter Sanctuary"}
          </button>

          <div style={{ display: "flex", alignItems: "center", gap: 12, margin: "16px 0" }}>
            <div style={{ flex: 1, height: 1, background: T.sand }} />
            <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkGhost, letterSpacing: "0.1em" }}>OR</span>
            <div style={{ flex: 1, height: 1, background: T.sand }} />
          </div>

          <button onClick={handleGoogle} disabled={loading}
            style={{ width: "100%", background: "white", color: T.inkMid, border: "1px solid " + T.sandMid, borderRadius: 2, padding: "13px", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.12em", textTransform: "uppercase", cursor: "pointer", marginBottom: 20, display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}>
            <svg width="16" height="16" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
            Continue with Google
          </button>

          <button onClick={() => { setMode(mode === "login" ? "signup" : "login"); setError(""); setMessage(""); }}
            style={{ background: "none", border: "none", fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkSoft, cursor: "pointer", textDecoration: "underline" }}>
            {mode === "login" ? "New here? Create your sanctuary" : "Already have an account? Sign in"}
          </button>
          {mode === "login" && (
            <button onClick={async () => { if (!email) { setError("Enter your email above first."); return; } setLoading(true); setError(""); const { error } = await supabase.auth.resetPasswordForEmail(email, { redirectTo: "https://purereve.app" }); setLoading(false); if (error) setError(error.message); else setMessage("Check your email for a password reset link."); }}
              style={{ background: "none", border: "none", fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkGhost, cursor: "pointer", textDecoration: "underline", display: "block", margin: "8px auto 0" }}>
              Forgot password?
            </button>
          )}
        <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 11, color: T.inkGhost, textAlign: "center", lineHeight: 1.8, margin: "20px 0 0" }}>
          By continuing you confirm you are at least 18 and agree to our{' '}
          <button onClick={() => setShowDoc('terms')} style={{ background: "none", border: "none", padding: 0, textDecoration: "underline", cursor: "pointer", color: T.inkSoft, fontFamily: "'Jost', sans-serif", fontSize: 11 }}>Terms of Service</button>
          {' '}and{' '}
          <button onClick={() => setShowDoc('privacy')} style={{ background: "none", border: "none", padding: 0, textDecoration: "underline", cursor: "pointer", color: T.inkSoft, fontFamily: "'Jost', sans-serif", fontSize: 11 }}>Privacy Policy</button>.
        </p>
        </div>
      </FadeIn>
    </div>
  );
};


const GummyDissolveTimer = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);
  const [phase, setPhase] = useState("ready");
  const [opacity, setOpacity] = useState(1);

  const startDissolve = () => {
    setPhase("dissolving");
    let p = 0;
    const interval = setInterval(() => {
      p += 1;
      setProgress(p);
      setOpacity(1 - (p / 100) * 0.85);
      if (p >= 100) {
        clearInterval(interval);
        setPhase("complete");
        setTimeout(() => onComplete(), 800);
      }
    }, 1800);
  };

  if (phase === "ready") return (
    <div style={{ textAlign: "center", padding: "28px 0" }}>
      <Serif size={14} italic color={T.inkSoft} style={{ display: "block", marginBottom: 24, lineHeight: 1.6 }}>
        Take your Stillness Gummy and enter a moment of peace.
      </Serif>
      <div style={{ position: "relative", width: 120, height: 120, margin: "0 auto 24px" }}>
        <svg width="120" height="120" viewBox="0 0 120 120">
          <ellipse cx="60" cy="68" rx="34" ry="22" fill="#C9A98A" opacity="0.3"/>
          <rect x="28" y="28" width="64" height="52" rx="22" fill="#EDE5D8" stroke="#B8A48C" strokeWidth="1.5"/>
          <ellipse cx="60" cy="30" rx="32" ry="10" fill="#FAF7F2" opacity="0.6"/>
          <text x="60" y="62" textAnchor="middle" fontFamily="Georgia,serif" fontSize="22" fill="#7A6A58" fontStyle="italic">✦</text>
        </svg>
      </div>
      <button onClick={startDissolve} style={{ background: T.ink, color: T.ivory, border: "none", borderRadius: 2, padding: "13px 28px", fontFamily: "Jost,sans-serif", fontSize: 12, letterSpacing: "0.16em", textTransform: "uppercase", cursor: "pointer" }}>
        Take my Gummy
      </button>
    </div>
  );

  if (phase === "dissolving") return (
    <div style={{ textAlign: "center", padding: "28px 0" }}>
      <Serif size={14} italic color={T.inkSoft} style={{ display: "block", marginBottom: 20, lineHeight: 1.6 }}>
        Breathe deeply. Be still. You are held.
      </Serif>
      <div style={{ position: "relative", width: 120, height: 120, margin: "0 auto 20px" }}>
        <svg width="120" height="120" viewBox="0 0 120 120">
          <ellipse cx="60" cy="68" rx="34" ry="22" fill="#C9A98A" opacity={0.3 * opacity}/>
          <rect x="28" y="28" width="64" height="52" rx="22" fill="#EDE5D8" stroke="#B8A48C" strokeWidth="1.5" opacity={opacity}/>
          <ellipse cx="60" cy="30" rx="32" ry="10" fill="#FAF7F2" opacity={0.6 * opacity}/>
          <text x="60" y="62" textAnchor="middle" fontFamily="Georgia,serif" fontSize="22" fill="#7A6A58" fontStyle="italic" opacity={opacity}>✦</text>
          {[...Array(8)].map((_, i) => (
            <circle key={i}
              cx={60 + Math.cos((i / 8) * Math.PI * 2) * (20 + progress * 0.3)}
              cy={60 + Math.sin((i / 8) * Math.PI * 2) * (20 + progress * 0.3)}
              r={2 + Math.random() * 2}
              fill="#B8A48C"
              opacity={(1 - opacity) * 0.6}
            />
          ))}
        </svg>
      </div>
      <div style={{ width: "80%", margin: "0 auto 12px", height: 2, background: T.sand, borderRadius: 1 }}>
        <div style={{ height: 2, background: T.ink, borderRadius: 1, width: progress + "%", transition: "width 0.6s ease" }} />
      </div>
      <span style={{ fontFamily: "Jost,sans-serif", fontSize: 12, color: T.inkGhost, letterSpacing: "0.12em" }}>
        {Math.round(progress)}% dissolved
      </span>
    </div>
  );

  return (
    <div style={{ padding: "28px 0 0" }}>
      <div style={{ textAlign: "center", marginBottom: 20 }}>
        <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 44, color: T.sandDark, marginBottom: 12 }}>✦</div>
        <Serif size={20} italic style={{ display: "block", marginBottom: 8 }}>You are held. You are safe.</Serif>
        <Serif size={14} color={T.inkSoft} style={{ display: "block", lineHeight: 1.6 }}>Rest well tonight. ✦</Serif>
      </div>
      <SanctuarySoundscape />
    </div>
  );
};


const SanctuarySoundscape = () => {
  const [playing, setPlaying] = useState(localStorage.getItem('pr_sound') || null);
  const [timeLeft, setTimeLeft] = useState(600);
  const [started, setStarted] = useState(false);
  const audioRef = useRef(null);
  const timerRef = useRef(null);

  const tracks = [
    { id: "brown", label: "Deep Rest", sub: "Brown noise for deep sleep", freq: 100 },
    { id: "rain", label: "Still Waters", sub: "Gentle rain on leaves", freq: 200 },
    { id: "silence", label: "Sacred Silence", sub: "Pure stillness with soft tone", freq: 440 },
  ];

  const playTone = (freq) => {
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const bufferSize = ctx.sampleRate * 10;
      const buffer = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
      const data = buffer.getChannelData(0);
      
      if (freq === 100) {
        // Brown noise
        let lastOut = 0;
        for (let i = 0; i < bufferSize; i++) {
          const white = Math.random() * 2 - 1;
          data[i] = (lastOut + (0.02 * white)) / 1.02;
          lastOut = data[i];
          data[i] *= 3.5;
        }
      } else if (freq === 200) {
        // Rain-like noise
        for (let i = 0; i < bufferSize; i++) {
          data[i] = (Math.random() * 2 - 1) * 0.15;
        }
      } else {
        // Soft tone
        for (let i = 0; i < bufferSize; i++) {
          data[i] = Math.sin(2 * Math.PI * freq * i / ctx.sampleRate) * 0.05;
        }
      }

      const source = ctx.createBufferSource();
      source.buffer = buffer;
      source.loop = true;

      const gainNode = ctx.createGain();
      gainNode.gain.setValueAtTime(0, ctx.currentTime);
      gainNode.gain.linearRampToValueAtTime(0.4, ctx.currentTime + 2);

      source.connect(gainNode);
      gainNode.connect(ctx.destination);
      source.start();

      audioRef.current = { source, gainNode, ctx };
    } catch(e) {
      console.log('Audio error:', e);
    }
  };

  const stopAudio = () => {
    if (audioRef.current) {
      try {
        audioRef.current.gainNode.gain.linearRampToValueAtTime(0, audioRef.current.ctx.currentTime + 1);
        setTimeout(() => {
          try { audioRef.current.source.stop(); } catch(e) {}
        }, 1000);
      } catch(e) {}
      audioRef.current = null;
    }
  };

  const selectTrack = (track) => {
    stopAudio();
    clearInterval(timerRef.current);
    setPlaying(track.id);
    setTimeLeft(600);
    setStarted(true);
    playTone(track.freq);
    timerRef.current = setInterval(() => {
      setTimeLeft(t => {
        if (t <= 1) {
          clearInterval(timerRef.current);
          stopAudio();
          setPlaying(null);
          setStarted(false);
          return 600;
        }
        return t - 1;
      });
    }, 1000);
  };

  const stopTrack = () => {
    stopAudio();
    clearInterval(timerRef.current);
    setPlaying(null);
    setStarted(false);
    setTimeLeft(600);
  };

  const mins = Math.floor(timeLeft / 60);
  const secs = timeLeft % 60;

  return (
    <div style={{ marginTop: 24, padding: "20px 22px", background: T.ink, borderRadius: 2 }}>
      <Label style={{ color: T.sandDark, marginBottom: 8 }}>Stillness Frequency</Label>
      <Serif size={18} italic color={T.ivory} style={{ display: "block", marginBottom: 4 }}>Your audio sanctuary.</Serif>
      <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkGhost, display: "block", marginBottom: 20, fontWeight: 300 }}>Choose a sound to carry you into rest.</span>

      <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 16 }}>
        {tracks.map(track => (
          <button key={track.id} onClick={() => playing === track.id ? stopTrack() : selectTrack(track)}
            style={{ background: playing === track.id ? T.sandDark : "rgba(237,229,216,0.08)", border: "1px solid " + (playing === track.id ? T.sandDark : "rgba(237,229,216,0.15)"), borderRadius: 2, padding: "12px 16px", cursor: "pointer", textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div>
              <Serif size={15} color={playing === track.id ? T.ink : T.ivory} style={{ display: "block", marginBottom: 2 }}>{track.label}</Serif>
              <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: playing === track.id ? T.inkMid : T.inkGhost, fontWeight: 300 }}>{track.sub}</span>
            </div>
            <div style={{ width: 32, height: 32, borderRadius: "50%", border: "1px solid " + (playing === track.id ? T.ink : "rgba(237,229,216,0.3)"), display: "flex", alignItems: "center", justifyContent: "center" }}>
              <span style={{ color: playing === track.id ? T.ink : T.ivory, fontSize: 14 }}>{playing === track.id ? "◼" : "▶"}</span>
            </div>
          </button>
        ))}
      </div>

      {started && (
        <div style={{ textAlign: "center", padding: "8px 0" }}>
          <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 28, color: T.sandDark }}>{mins}:{secs.toString().padStart(2, "0")}</span>
          <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkGhost, display: "block", marginTop: 4, letterSpacing: "0.1em" }}>remaining</span>
        </div>
      )}
    </div>
  );
};


const LumiereScreen = ({ appLang }) => {
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const send = async () => {
    if (!input.trim() || loading) return;
    const userMsg = { role: "user", content: input.trim() };
    const newMessages = [...messages, userMsg];
    setMessages(newMessages);
    setInput("");
    setLoading(true);

    try {
      const res = await fetch("/api/lumiere", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ messages: newMessages })
      });
      const data = await res.json();
      if (data.text) {
        setMessages([...newMessages, { role: "assistant", content: data.text }]);
      }
    } catch(e) {
      setMessages([...newMessages, { role: "assistant", content: "The sanctuary holds you tonight. You are not alone in what you carry. ✦" }]);
    }
    setLoading(false);
    setTimeout(scrollToBottom, 100);
  };

  const handleKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); }
  };

  return (
    <div style={{ padding: "0 0 120px" }}>
      <FadeIn>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <Serif size={13} color={T.inkGhost} style={{ display: "block", letterSpacing: "0.22em", textTransform: "uppercase", fontStyle: "normal", marginBottom: 10 }}>Lumière</Serif>
          <Serif size={30} italic style={{ display: "block", marginBottom: 6 }}>Your sanctuary guide.</Serif>
          <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkGhost, margin: "6px 0 0", letterSpacing: "0.08em", lineHeight: 1.8 }}>Lumière is an AI guide — not a therapist, counselor, or crisis service. If you are in crisis, call or text <strong>988</strong> or call <strong>911</strong>.</p>
          <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkSoft, fontWeight: 300 }}>{TRANSLATIONS.en.shareHeart}</span>
        </div>

        {messages.length === 0 && (
          <div style={{ background: T.sand, borderRadius: 2, padding: "20px 20px", marginBottom: 20, borderLeft: "2px solid " + T.sandDark }}>
            <Serif size={16} italic color={T.inkMid} style={{ display: "block", lineHeight: 1.8 }}>What does your soul need tonight? ✦</Serif>
            <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, fontWeight: 300, display: "block", marginTop: 6 }}>Lumière is listening.</span>
          </div>
        )}

        <div style={{ display: "flex", flexDirection: "column", gap: 14, marginBottom: 20 }}>
          {messages.map((msg, i) => (
            <div key={i} style={{ display: "flex", justifyContent: msg.role === "user" ? "flex-end" : "flex-start" }}>
              <div style={{
                maxWidth: "85%",
                background: msg.role === "user" ? T.ink : T.sand,
                borderRadius: 2,
                padding: "14px 18px",
                borderLeft: msg.role === "assistant" ? "2px solid " + T.sandDark : "none"
              }}>
                {msg.role === "assistant" && (
                  <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.14em", textTransform: "uppercase", color: T.inkGhost, display: "block", marginBottom: 6 }}>Lumière</span>
                )}
                <Serif size={15} color={msg.role === "user" ? T.ivory : T.inkMid} italic={msg.role === "assistant"} style={{ display: "block", lineHeight: 1.8 }}>{msg.content}</Serif>
              </div>
            </div>
          ))}
          {loading && (
            <div style={{ display: "flex", justifyContent: "flex-start" }}>
              <div style={{ background: T.sand, borderRadius: 2, padding: "14px 18px", borderLeft: "2px solid " + T.sandDark }}>
                <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.14em", textTransform: "uppercase", color: T.inkGhost, display: "block", marginBottom: 6 }}>Lumière</span>
                <Serif size={15} italic color={T.inkGhost} style={{ display: "block" }}>listening... ✦</Serif>
              </div>
            </div>
          )}
          <div ref={messagesEndRef} />
        </div>

        <div style={{ display: "flex", gap: 10, alignItems: "flex-end" }}>
          <textarea value={input} onChange={e => setInput(e.target.value)} onKeyDown={handleKey}
            placeholder={TRANSLATIONS.en.shareHeart}
            rows={2}
            style={{ flex: 1, background: T.sand, border: "1px solid " + T.sandMid, borderRadius: 2, padding: "12px 16px", fontFamily: "'Jost', sans-serif", fontSize: 14, fontWeight: 300, color: T.ink, lineHeight: 1.6, resize: "none", outline: "none", boxSizing: "border-box" }} />
          <button onClick={send} disabled={loading}
            style={{ background: T.ink, color: T.ivory, border: "none", borderRadius: 2, padding: "12px 18px", fontFamily: "'Jost', sans-serif", fontSize: 18, cursor: "pointer", flexShrink: 0, opacity: loading ? 0.5 : 1 }}>✦</button>
        </div>

        {messages.length > 0 && (
          <button onClick={() => setMessages([])}
            style={{ width: "100%", background: "none", border: "none", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", color: T.inkGhost, cursor: "pointer", padding: "16px 0 0" }}>{TRANSLATIONS.en.newConversation}</button>
        )}
      </FadeIn>
    </div>
  );
};


const KintsugiVessel = ({ user, appLang }) => {
  const [data, setData] = useState({ cracks: 0, gold: 0, crackDates: [], goldDates: [] });
  const [selectedCrack, setSelectedCrack] = useState(null);
  const [downloading, setDownloading] = useState(false);


  useEffect(() => {
    if (!user) return;
    Promise.all([
      supabase.from('dump_history').select('date_str').eq('user_id', user.id).order('created_at', { ascending: true }),
      supabase.from('tracker').select('date_str').eq('user_id', user.id).order('created_at', { ascending: true }),
    ]).then(([dumps, tracker]) => {
      setData({
        cracks: dumps.data?.length || 0,
        gold: tracker.data?.length || 0,
        crackDates: dumps.data?.map(d => d.date_str) || [],
        goldDates: tracker.data?.map(d => d.date_str) || [],
      });
    });
  }, [user]);

  const cracks = Math.min(data.cracks, 12);
  const gold = Math.min(data.gold, 12);
  const W = 200, H = 260;

  const crackPaths = [
    "M100,60 C95,90 88,110 82,140", "M100,60 C108,85 118,105 122,135",
    "M100,60 C85,80 75,95 68,125", "M100,60 C112,78 125,92 132,118",
    "M100,60 C92,95 78,115 70,148", "M100,60 C110,92 124,108 128,142",
    "M82,140 C75,160 72,175 74,195", "M122,135 C128,158 130,172 126,192",
    "M68,125 C60,148 58,165 62,188", "M132,118 C140,142 142,160 138,182",
    "M70,148 C65,168 66,182 70,200", "M128,142 C134,164 133,178 128,198",
  ];

  const crackTaps = [
    {x:88,y:100}, {x:112,y:98}, {x:76,y:103}, {x:122,y:95},
    {x:80,y:104}, {x:118,y:105}, {x:76,y:172}, {x:127,y:170},
    {x:60,y:166}, {x:137,y:162}, {x:67,y:175}, {x:131,y:172},
  ];

  const downloadVessel = () => {
    setDownloading(true);
    try {
      const canvas = document.createElement('canvas');
      canvas.width = 600; canvas.height = 700;
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#FAF7F2';
      ctx.fillRect(0, 0, 600, 700);
      ctx.fillStyle = '#B8A48C';
      ctx.font = '300 13px Georgia';
      ctx.textAlign = 'center';
      ctx.fillText('PURE REVE', 300, 48);
      ctx.fillStyle = '#7A6A58';
      ctx.font = 'italic 300 18px Georgia';
      ctx.fillText('Your Kintsugi Vessel', 300, 76);
      const scale = 2.2, ox = 300 - (W * scale) / 2, oy = 100;
      ctx.save();
      ctx.translate(ox, oy);
      ctx.scale(scale, scale);
      ctx.beginPath();
      ctx.moveTo(65,80); ctx.bezierCurveTo(55,90,45,120,48,160);
      ctx.bezierCurveTo(50,190,65,220,100,228);
      ctx.bezierCurveTo(135,220,150,190,152,160);
      ctx.bezierCurveTo(155,120,145,90,135,80);
      ctx.bezierCurveTo(125,65,100,58,100,58);
      ctx.bezierCurveTo(75,65,65,80,65,80);
      ctx.fillStyle = '#EDE5D8'; ctx.fill();
      ctx.strokeStyle = '#C4B8A8'; ctx.lineWidth = 1.5; ctx.stroke();
      crackPaths.slice(0, cracks).forEach((path, i) => {
        const p = new Path2D(path);
        ctx.strokeStyle = i < gold ? '#C9A84C' : '#8B7355';
        ctx.lineWidth = i < gold ? 2.5 : 1.5;
        ctx.globalAlpha = i < gold ? 1 : 0.6;
        ctx.stroke(p);
      });
      ctx.globalAlpha = 1;
      ctx.restore();
      ctx.fillStyle = '#1C1610';
      ctx.font = '300 28px Georgia';
      ctx.textAlign = 'center';
      ctx.fillText(data.cracks + ' cracks  ·  ' + data.gold + ' gilded', 300, 630);
      ctx.fillStyle = '#B8A48C';
      ctx.font = '300 12px Georgia';
      ctx.fillText('purereve.app', 300, 660);
      const link = document.createElement('a');
      link.download = 'my-kintsugi-vessel.png';
      link.href = canvas.toDataURL('image/png');
      link.click();
    } catch(e) { console.log(e); }
    setDownloading(false);
  };

  return (
    <div style={{ padding: "24px 0 8px", textAlign: "center" }}>
      <Label style={{ marginBottom: 4 }}>{TRANSLATIONS.en.vessel}</Label>
      <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, fontWeight: 300, display: "block", marginBottom: 16 }}>
        {data.cracks === 0 && data.gold === 0 ? TRANSLATIONS.en.vesselWhole :
         data.gold === 0 ? TRANSLATIONS.en.vesselMarked :
         TRANSLATIONS.en.vesselGold}
      </span>

      <div style={{ position: "relative", display: "inline-block" }}>
        <svg width={W} height={H} viewBox={"0 0 " + W + " " + H} style={{ overflow: "visible" }}>
          <path d="M65,80 C55,90 45,120 48,160 C50,190 65,220 100,228 C135,220 150,190 152,160 C155,120 145,90 135,80 C125,65 100,58 100,58 C100,58 75,65 65,80Z" fill="#EDE5D8" stroke="#C4B8A8" strokeWidth="1.5"/>
          <path d="M82,58 C82,48 118,48 118,58 C118,65 115,72 100,74 C85,72 82,65 82,58Z" fill="#EDE5D8" stroke="#C4B8A8" strokeWidth="1.5"/>
          <ellipse cx="100" cy="48" rx="20" ry="6" fill="#EDE5D8" stroke="#C4B8A8" strokeWidth="1.5"/>
          <path d="M72,90 C68,110 67,135 70,155" fill="none" stroke="white" strokeWidth="3" strokeOpacity="0.4" strokeLinecap="round"/>
          {crackPaths.slice(0, cracks).map((d, i) => (
            <g key={"c"+i} style={{ cursor: "pointer" }} onClick={() => setSelectedCrack(selectedCrack === i ? null : i)}>
              <path d={d} fill="none" stroke={i < gold ? "#C9A84C" : "#8B7355"} strokeWidth={selectedCrack === i ? 3.5 : (i < gold ? 2.5 : 1.5)} strokeOpacity={i < gold ? 1 : 0.6} strokeLinecap="round"/>
              <circle cx={crackTaps[i].x} cy={crackTaps[i].y} r={12} fill="transparent"/>
            </g>
          ))}
          {Array.from({length: Math.min(gold * 3, 24)}, (_, i) => (
            <circle key={"d"+i} cx={85 + Math.sin(i * 1.2) * 25} cy={90 + i * 5} r={1.5} fill="#C9A84C" opacity={0.6}/>
          ))}
        </svg>

        {selectedCrack !== null && selectedCrack < cracks && (
          <div style={{ position: "absolute", top: Math.max(10, crackTaps[selectedCrack].y - 65), left: "50%", transform: "translateX(-50%)", background: T.ink, borderRadius: 2, padding: "12px 16px", minWidth: 170, zIndex: 10 }}>
            <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.1em", textTransform: "uppercase", color: selectedCrack < gold ? "#C9A84C" : T.sandDark, margin: "0 0 5px" }}>
              {selectedCrack < gold ? "✦ Gilded" : "Crack " + (selectedCrack + 1)}
            </p>
            <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 14, fontStyle: "italic", color: T.ivory, margin: 0, lineHeight: 1.5 }}>
              {data.crackDates[selectedCrack] || "A struggle you carried"}
            </p>
            {selectedCrack < gold && data.goldDates[selectedCrack] && (
              <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: "#C9A84C", margin: "5px 0 0" }}>Gilded on {data.goldDates[selectedCrack]}</p>
            )}
            <button onClick={() => setSelectedCrack(null)} style={{ marginTop: 8, background: "none", border: "none", fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, cursor: "pointer", padding: 0, letterSpacing: "0.1em", textTransform: "uppercase" }}>close</button>
          </div>
        )}
      </div>

      <div style={{ display: "flex", justifyContent: "center", gap: 32, margin: "16px 0 12px" }}>
        <div style={{ textAlign: "center" }}>
          <Serif size={28} style={{ display: "block", lineHeight: 1 }}>{data.cracks}</Serif>
          <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, letterSpacing: "0.12em", textTransform: "uppercase" }}>Cracks</span>
        </div>
        <div style={{ width: 1, background: T.sandMid }} />
        <div style={{ textAlign: "center" }}>
          <Serif size={28} color="#C9A84C" style={{ display: "block", lineHeight: 1 }}>{data.gold}</Serif>
          <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, letterSpacing: "0.12em", textTransform: "uppercase" }}>Gilded</span>
        </div>
      </div>

      {cracks > 0 && (
        <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkGhost, margin: "0 0 12px", fontStyle: "italic" }}>{TRANSLATIONS.en.tapCrack}</p>
      )}

      
      <button onClick={downloadVessel} disabled={downloading}
        style={{ background: "none", border: "1px solid " + T.sandMid, borderRadius: 2, padding: "10px 20px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", color: T.inkSoft, cursor: "pointer", opacity: downloading ? 0.6 : 1 }}>
        {downloading ? "Creating..." : "✦ Share my vessel"}
      </button>
    </div>
  );
};

const DetenteScreen = ({ appLang }) => {
  const [active, setActive] = useState(null);
  const [breathPhase, setBreathPhase] = useState("ready");
  const [breathCount, setBreathCount] = useState(0);
  const [circleSize, setCircleSize] = useState(120);
  const [worry, setWorry] = useState("");
  const [worryReleased, setWorryReleased] = useState(false);
  const [worryOpacity, setWorryOpacity] = useState(1);
  const [gratitude, setGratitude] = useState(["", "", ""]);
  const [gratitudeSaved, setGratitudeSaved] = useState(false);

  const startBreathing = () => {
    setBreathPhase("inhale");
    setBreathCount(0);
    let count = 0;
    const cycle = () => {
      if (count >= 4) { setBreathPhase("done"); return; }
      setBreathPhase("inhale");
      setCircleSize(200);
      setTimeout(() => {
        setBreathPhase("hold");
        setTimeout(() => {
          setBreathPhase("exhale");
          setCircleSize(120);
          setTimeout(() => {
            count++;
            setBreathCount(count);
            cycle();
          }, 8000);
        }, 4000);
      }, 4000);
    };
    cycle();
  };

  const releaseWorry = () => {
    if (!worry.trim()) return;
    setWorryReleased(true);
    let op = 1;
    const fade = setInterval(() => {
      op -= 0.05;
      setWorryOpacity(Math.max(0, op));
      if (op <= 0) {
        clearInterval(fade);
        setWorry("");
        setWorryOpacity(1);
        setTimeout(() => setWorryReleased(false), 500);
      }
    }, 80);
  };

  const breathLabels = {
    ready: TRANSLATIONS.en.tapToBegin,
    inhale: TRANSLATIONS.en.breatheIn,
    hold: TRANSLATIONS.en.hold,
    exhale: TRANSLATIONS.en.breatheOut,
    done: TRANSLATIONS.en.wellDone
  };

  return (
    <div style={{ padding: "56px 28px 100px" }}>
      <FadeIn>
        <Label style={{ marginBottom: 12 }}>{TRANSLATIONS.en.detente}</Label>
        <Serif size={30} italic style={{ display: "block", lineHeight: 1.25, marginBottom: 6 }}>{TRANSLATIONS.en.easeTension}</Serif>
        <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkSoft, fontWeight: 300, display: "block", marginBottom: 32 }}>Three practices for any moment of the day.</span>
      </FadeIn>

      {/* Breathe */}
      <FadeIn delay={100}>
        <div style={{ marginBottom: 28 }}>
          <button onClick={() => setActive(active === "breathe" ? null : "breathe")}
            style={{ width: "100%", background: active === "breathe" ? T.ink : T.sand, border: "none", borderRadius: 2, padding: "18px 22px", cursor: "pointer", textAlign: "left", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <Label style={{ color: active === "breathe" ? T.sandDark : T.inkGhost, marginBottom: 4 }}>01</Label>
              <Serif size={20} color={active === "breathe" ? T.ivory : T.inkMid} style={{ display: "block" }}>{TRANSLATIONS.en.breathe}</Serif>
              <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: active === "breathe" ? T.sandDark : T.inkGhost, fontWeight: 300 }}>4 — 4 — 8 breathing cycle</span>
            </div>
            <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, color: active === "breathe" ? T.sandDark : T.inkGhost }}>{active === "breathe" ? "−" : "+"}</span>
          </button>

          {active === "breathe" && (
            <div style={{ background: T.sand, borderRadius: "0 0 2px 2px", padding: "32px 22px", textAlign: "center" }}>
              <div onClick={breathPhase === "ready" || breathPhase === "done" ? startBreathing : undefined}
                style={{ width: circleSize, height: circleSize, borderRadius: "50%", background: breathPhase === "inhale" ? "rgba(28,22,16,0.12)" : breathPhase === "hold" ? "rgba(28,22,16,0.08)" : T.ivory, border: "1.5px solid " + T.sandDark, margin: "0 auto 24px", display: "flex", alignItems: "center", justifyContent: "center", cursor: breathPhase === "ready" || breathPhase === "done" ? "pointer" : "default", transition: "all 4s ease-in-out" }}>
                <Serif size={14} italic color={T.inkMid} style={{ display: "block" }}>{breathLabels[breathPhase]}</Serif>
              </div>
              {breathPhase !== "ready" && breathPhase !== "done" && (
                <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, letterSpacing: "0.1em" }}>Cycle {breathCount + 1} of 4</span>
              )}
              {breathPhase === "done" && (
                <button onClick={() => { setBreathPhase("ready"); setCircleSize(120); setBreathCount(0); }}
                  style={{ background: "none", border: "1px solid " + T.sandMid, borderRadius: 2, padding: "10px 20px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", color: T.inkSoft, cursor: "pointer", marginTop: 12 }}>{TRANSLATIONS.en.beginAgain}</button>
              )}
            </div>
          )}
        </div>
      </FadeIn>

      {/* Release */}
      <FadeIn delay={150}>
        <div style={{ marginBottom: 28 }}>
          <button onClick={() => setActive(active === "release" ? null : "release")}
            style={{ width: "100%", background: active === "release" ? T.ink : T.sand, border: "none", borderRadius: 2, padding: "18px 22px", cursor: "pointer", textAlign: "left", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <Label style={{ color: active === "release" ? T.sandDark : T.inkGhost, marginBottom: 4 }}>02</Label>
              <Serif size={20} color={active === "release" ? T.ivory : T.inkMid} style={{ display: "block" }}>{TRANSLATIONS.en.release}</Serif>
              <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: active === "release" ? T.sandDark : T.inkGhost, fontWeight: 300 }}>{TRANSLATIONS.en.releaseSub}</span>
            </div>
            <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, color: active === "release" ? T.sandDark : T.inkGhost }}>{active === "release" ? "−" : "+"}</span>
          </button>

          {active === "release" && (
            <div style={{ background: T.sand, borderRadius: "0 0 2px 2px", padding: "24px 22px" }}>
              <Serif size={14} italic color={T.inkSoft} style={{ display: "block", lineHeight: 1.8, marginBottom: 16 }}>What is weighing on you right now? Write it. Then release it.</Serif>
              <textarea value={worry} onChange={e => setWorry(e.target.value)}
                placeholder={TRANSLATIONS.en.writeWorry}
                rows={4}
                style={{ width: "100%", background: T.ivory, border: "1px solid " + T.sandMid, borderRadius: 2, padding: "14px 16px", fontFamily: "'Jost', sans-serif", fontSize: 13, fontWeight: 300, color: T.ink, lineHeight: 1.9, resize: "none", outline: "none", boxSizing: "border-box", marginBottom: 12, opacity: worryOpacity, transition: "opacity 0.1s" }} />
              {!worryReleased ? (
                <button onClick={releaseWorry} style={{ width: "100%", background: T.ink, color: T.ivory, border: "none", borderRadius: 2, padding: "13px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.16em", textTransform: "uppercase", cursor: "pointer" }}>
                  Release it ✦
                </button>
              ) : (
                <div style={{ textAlign: "center", padding: "8px 0" }}>
                  <Serif size={16} italic color={T.inkSoft} style={{ display: "block" }}>{TRANSLATIONS.en.released}</Serif>
                </div>
              )}
            </div>
          )}
        </div>
      </FadeIn>

      {/* Gratitude */}
      <FadeIn delay={200}>
        <div style={{ marginBottom: 28 }}>
          <button onClick={() => setActive(active === "gratitude" ? null : "gratitude")}
            style={{ width: "100%", background: active === "gratitude" ? T.ink : T.sand, border: "none", borderRadius: 2, padding: "18px 22px", cursor: "pointer", textAlign: "left", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <Label style={{ color: active === "gratitude" ? T.sandDark : T.inkGhost, marginBottom: 4 }}>03</Label>
              <Serif size={20} color={active === "gratitude" ? T.ivory : T.inkMid} style={{ display: "block" }}>{TRANSLATIONS.en.gratitudeFull}</Serif>
              <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: active === "gratitude" ? T.sandDark : T.inkGhost, fontWeight: 300 }}>{TRANSLATIONS.en.gratitudeSub}</span>
            </div>
            <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, color: active === "gratitude" ? T.sandDark : T.inkGhost }}>{active === "gratitude" ? "−" : "+"}</span>
          </button>

          {active === "gratitude" && (
            <div style={{ background: T.sand, borderRadius: "0 0 2px 2px", padding: "24px 22px" }}>
              <Serif size={14} italic color={T.inkSoft} style={{ display: "block", lineHeight: 1.8, marginBottom: 20 }}>Gratitude shifts the mind. Name three things — however small.</Serif>
              {!gratitudeSaved ? (
                <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 16 }}>
                  {[0, 1, 2].map(i => (
                    <div key={i} style={{ display: "flex", alignItems: "center", gap: 12 }}>
                      <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 18, color: T.sandDark, minWidth: 20 }}>{i + 1}.</span>
                      <input value={gratitude[i]} onChange={e => { const g = [...gratitude]; g[i] = e.target.value; setGratitude(g); }}
                        placeholder={TRANSLATIONS.en.gratefulFor}
                        style={{ flex: 1, background: T.ivory, border: "1px solid " + T.sandMid, borderRadius: 2, padding: "12px 14px", fontFamily: "'Jost', sans-serif", fontSize: 13, fontWeight: 300, color: T.ink, outline: "none" }} />
                    </div>
                  ))}
                  <button onClick={() => { if (gratitude.some(g => g.trim())) setGratitudeSaved(true); }}
                    style={{ width: "100%", background: T.ink, color: T.ivory, border: "none", borderRadius: 2, padding: "13px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.16em", textTransform: "uppercase", cursor: "pointer", marginTop: 4 }}>{TRANSLATIONS.en.receiveThisMoment}</button>
                </div>
              ) : (
                <div style={{ textAlign: "center", padding: "16px 0" }}>
                  <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 36, color: T.sandDark, marginBottom: 12 }}>✦</div>
                  <Serif size={18} italic style={{ display: "block", marginBottom: 8 }}>{TRANSLATIONS.en.gratefulHeart}</Serif>
                  {gratitude.filter(g => g.trim()).map((g, i) => (
                    <Serif key={i} size={14} italic color={T.inkSoft} style={{ display: "block", marginBottom: 4, lineHeight: 1.6 }}>"{g}"</Serif>
                  ))}
                  <button onClick={() => { setGratitude(["", "", ""]); setGratitudeSaved(false); }}
                    style={{ marginTop: 16, background: "none", border: "1px solid " + T.sandMid, borderRadius: 2, padding: "10px 20px", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", color: T.inkSoft, cursor: "pointer" }}>{TRANSLATIONS.en.beginAgain}</button>
                </div>
              )}
            </div>
          )}
        </div>
      </FadeIn>

      <FadeIn delay={250}>
        <div style={{ padding: "18px 20px", borderLeft: "2px solid " + T.sandDark, background: T.sand, borderRadius: 2 }}>
          <Serif size={14} italic color={T.inkMid} style={{ display: "block", lineHeight: 1.8 }}>"You will keep in perfect peace those whose minds are steadfast, because they trust in you."</Serif>
          <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, display: "block", marginTop: 8 }}>Isaiah 26:3 NIV</span>
        </div>
      </FadeIn>
    </div>
  );
};

const SettingsScreen = ({ user, setScreen, setAppLang, appLang }) => {
  const [section, setSection] = useState(null);
  const [playingSound, setPlayingSound] = useState(null);
  const settingsAudioRef = useRef(null);

  const playSettingsSound = (trackId) => {
    // Stop current
    if (settingsAudioRef.current) {
      try { settingsAudioRef.current.source.stop(); } catch(e) {}
      settingsAudioRef.current = null;
    }
    if (playingSound === trackId) { setPlayingSound(null); return; }
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const bufferSize = ctx.sampleRate * 10;
      const buffer = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
      const data = buffer.getChannelData(0);
      if (trackId === 'brown') {
        let lastOut = 0;
        for (let i = 0; i < bufferSize; i++) {
          const white = Math.random() * 2 - 1;
          data[i] = (lastOut + (0.02 * white)) / 1.02;
          lastOut = data[i]; data[i] *= 3.5;
        }
      } else if (trackId === 'rain') {
        for (let i = 0; i < bufferSize; i++) { data[i] = (Math.random() * 2 - 1) * 0.15; }
      } else {
        for (let i = 0; i < bufferSize; i++) { data[i] = Math.sin(2 * Math.PI * 432 * i / ctx.sampleRate) * 0.1; }
      }
      const source = ctx.createBufferSource();
      source.buffer = buffer; source.loop = true;
      const gain = ctx.createGain();
      gain.gain.setValueAtTime(0, ctx.currentTime);
      gain.gain.linearRampToValueAtTime(0.4, ctx.currentTime + 1);
      source.connect(gain); gain.connect(ctx.destination); source.start();
      settingsAudioRef.current = { source, ctx };
      setPlayingSound(trackId);
    } catch(e) { console.log(e); }
  };
  const [name, setName] = useState(localStorage.getItem('pr_name') || "");
  const [nameSaved, setNameSaved] = useState(false);
  const [sound, setSound] = useState(localStorage.getItem('pr_sound') || 'forest');
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [exportDone, setExportDone] = useState(false);
  const [resetDone, setResetDone] = useState(false);

  const exportJournal = async () => {
    if (!user) return;
    const { data } = await supabase.from('dump_history').select('*').eq('user_id', user.id).order('created_at', { ascending: false });
    if (!data) return;
    const text = data.map(e => e.date_str + ' - ' + e.text).join(' | ');
    const blob = new Blob(['Pure Reve Journal ' + text], { type: 'text/plain' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'pure-reve-journal.txt';
    link.click();
    setExportDone(true);
    setTimeout(() => setExportDone(false), 3000);
  };

  const SR = ({ label, val, fn, danger }) => (
    <button onClick={fn} style={{ width: "100%", background: "none", border: "none", borderBottom: "1px solid " + T.sandMid, padding: "14px 0", display: "flex", justifyContent: "space-between", cursor: "pointer", textAlign: "left" }}>
      <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: danger ? "#C0392B" : T.inkMid, fontWeight: 300 }}>{label}</span>
      {val && <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkGhost }}>{val}</span>}
    </button>
  );

  return (
    <div style={{ padding: "56px 28px 100px" }}>
      <FadeIn>
        <Label style={{ marginBottom: 12 }}>{TRANSLATIONS.en.settingsTitle}</Label>
        <Serif size={28} italic style={{ display: "block", marginBottom: 32 }}>{TRANSLATIONS.en.settingsTagline}</Serif>
      </FadeIn>

      {[
        { id: "account", label: "Account" },
        { id: "preferences", label: "Preferences" },
        { id: "sanctuary", label: "My Sanctuary" },
        { id: "about", label: "About Pure Reve" },
      ].map((s, si) => (
        <FadeIn key={s.id} delay={si * 80}>
          <div style={{ marginBottom: 16 }}>
            <button onClick={() => setSection(section === s.id ? null : s.id)}
              style={{ width: "100%", background: section === s.id ? T.ink : T.sand, border: "none", borderRadius: 2, padding: "16px 20px", cursor: "pointer", textAlign: "left", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Serif size={17} color={section === s.id ? T.ivory : T.inkMid} style={{ display: "block" }}>{s.label}</Serif>
              <span style={{ color: section === s.id ? T.sandDark : T.inkGhost }}>{section === s.id ? "−" : "+"}</span>
            </button>

            {section === s.id && (
              <div style={{ background: T.sand, padding: "4px 20px 12px" }}>
                {s.id === "account" && (
                  <div>
                    <SR label="Email" val={user?.email} fn={() => {}} />
                    <div style={{ padding: "14px 0", borderBottom: "1px solid " + T.sandMid }}>
                      <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, display: "block", marginBottom: 8 }}>Display name</span>
                      <div style={{ display: "flex", gap: 8 }}>
                        <input value={name} onChange={e => setName(e.target.value)} placeholder="Your name"
                          style={{ flex: 1, background: T.ivory, border: "1px solid " + T.sandMid, borderRadius: 2, padding: "10px 12px", fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.ink, outline: "none" }} />
                        <button onClick={() => { localStorage.setItem('pr_name', name); setNameSaved(true); setTimeout(() => setNameSaved(false), 2000); }}
                          style={{ background: T.ink, color: T.ivory, border: "none", borderRadius: 2, padding: "10px 14px", cursor: "pointer", fontFamily: "'Jost', sans-serif", fontSize: 12 }}>
                          {nameSaved ? "✦" : "Save"}
                        </button>
                      </div>
                    </div>
                    <SR label="Change password" fn={async () => { await supabase.auth.resetPasswordForEmail(user?.email, { redirectTo: 'https://purereve.app' }); alert('Password reset email sent to ' + user?.email); }} />
                    <SR label="Manage subscription" fn={async () => { try { const { data: { session } } = await supabase.auth.getSession(); const r = await fetch("/api/create-portal", { method: "POST", headers: { Authorization: "Bearer " + session.access_token } }); const d = await r.json(); if (d.url) { window.location.href = d.url; } else { alert(d.error || "Could not open subscription settings."); } } catch (e) { alert("Could not open subscription settings."); } }} />
                    <SR label={TRANSLATIONS.en.signOutBtn} fn={() => supabase.auth.signOut()} />
                    <SR label="Delete account" fn={() => setConfirmDelete(!confirmDelete)} danger />
                    {confirmDelete && (
                      <div style={{ padding: "10px 0" }}>
                        <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: "#C0392B", margin: "0 0 8px" }}>Are you sure? This cannot be undone.</p>
                        <div style={{ display: "flex", gap: 8 }}>
                          <button onClick={() => setConfirmDelete(false)} style={{ flex: 1, background: "none", border: "1px solid " + T.sandMid, borderRadius: 2, padding: "8px", fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkSoft, cursor: "pointer" }}>Cancel</button>
                          <button onClick={async () => { try { const { data: { session } } = await supabase.auth.getSession(); const r = await fetch("/api/delete-account", { method: "POST", headers: { Authorization: "Bearer " + session.access_token } }); const d = await r.json(); if (d.ok) { alert("Your account has been deleted. Your data has been removed and any subscription has been canceled." + (d.mail && d.mail !== "sent" ? "\n\n(Email status: " + d.mail + ")" : "")); try { await supabase.auth.signOut(); } catch (e) {} window.location.href = "/"; } else { alert(d.error || "Could not delete your account. Please email hello@purereve.app."); } } catch (e) { alert("Could not delete your account. Please email hello@purereve.app."); } }} style={{ flex: 1, background: "#C0392B", border: "none", borderRadius: 2, padding: "8px", fontFamily: "'Jost', sans-serif", fontSize: 12, color: "white", cursor: "pointer" }}>Delete</button>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                {s.id === "preferences" && (
                  <div onClick={e => e.stopPropagation()}>
                    <div style={{ padding: "14px 0", borderBottom: "1px solid " + T.sandMid }}>
                      <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, display: "block", marginBottom: 10 }}>Default Stillness sound</span>
                      {[{id:"forest",label:"Forest Night",sub:"Gentle forest ambience"},{id:"rain",label:"Still Waters",sub:"Soft rain on leaves"},{id:"brown",label:"Deep Rest",sub:"Brown noise for deep sleep"}].map(opt => (
                        <div key={opt.id} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
                          <button onClick={() => { setSound(opt.id); localStorage.setItem('pr_sound', opt.id); }}
                            style={{ flex: 1, background: sound === opt.id ? T.ink : "none", border: "1px solid " + (sound === opt.id ? T.ink : T.sandMid), borderRadius: 2, padding: "10px 14px", fontFamily: "'Jost', sans-serif", fontSize: 12, color: sound === opt.id ? T.ivory : T.inkMid, cursor: "pointer", textAlign: "left" }}>
                            <span style={{ display: "block" }}>{sound === opt.id ? "✦ " : ""}{opt.label}</span>
                            <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: sound === opt.id ? T.sandDark : T.inkGhost }}>{opt.sub}</span>
                          </button>
                          <button onClick={() => playSettingsSound(opt.id)}
                            style={{ width: 40, height: 40, borderRadius: "50%", background: playingSound === opt.id ? T.ink : T.sand, border: "1px solid " + T.sandMid, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                            <span style={{ fontSize: 14, color: playingSound === opt.id ? T.ivory : T.inkMid }}>{playingSound === opt.id ? "■" : "▶"}</span>
                          </button>
                        </div>
                      ))}
                    </div>
                    <div style={{ padding: "14px 0", borderBottom: "1px solid " + T.sandMid }}>
                      <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, display: "block", marginBottom: 6 }}>Language</span>
                      <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, fontStyle: "italic" }}>✦ English · More languages coming soon</span>
                    </div>
                    <div style={{ padding: "14px 0", borderBottom: "1px solid " + T.sandMid }}>
                      <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, display: "block", marginBottom: 10 }}>Show Kintsugi Vessel on home</span>
                      <div style={{ display: "flex", gap: 8 }}>
                        {["Show","Hide"].map(opt => (
                          <button key={opt} onClick={() => localStorage.setItem('pr_vessel', opt === "Show" ? "1" : "0")}
                            style={{ flex: 1, background: (opt === "Show" ? localStorage.getItem('pr_vessel') !== "0" : localStorage.getItem('pr_vessel') === "0") ? T.ink : "none", border: "1px solid " + T.sandMid, borderRadius: 2, padding: "10px", fontFamily: "'Jost', sans-serif", fontSize: 12, color: (opt === "Show" ? localStorage.getItem('pr_vessel') !== "0" : localStorage.getItem('pr_vessel') === "0") ? T.ivory : T.inkMid, cursor: "pointer" }}>
                            {opt}
                          </button>
                        ))}
                      </div>
                    </div>
                    <div style={{ padding: "14px 0", borderBottom: "1px solid " + T.sandMid }}>
                      <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, display: "block", marginBottom: 10 }}>Text size</span>
                      <div style={{ display: "flex", gap: 8 }}>
                        {[{id:"sm",label:"Small"},{id:"md",label:"Medium"},{id:"lg",label:"Large"}].map(opt => (
                          <button key={opt.id} onClick={e => { e.stopPropagation(); localStorage.setItem('pr_font', opt.id); const root = document.getElementById('root'); if(root) root.style.zoom = opt.id === 'sm' ? '0.88' : opt.id === 'lg' ? '1.12' : '1'; document.querySelectorAll('[data-fontbtn]').forEach(b => { b.style.background = b.dataset.fontbtn === opt.id ? '#1C1610' : 'none'; b.style.color = b.dataset.fontbtn === opt.id ? '#FAF7F2' : '#A89880'; }); }}
                            data-fontbtn={opt.id} style={{ flex: 1, background: (localStorage.getItem('pr_font') || 'md') === opt.id ? T.ink : "none", border: "1px solid " + T.sandMid, borderRadius: 2, padding: "10px", fontFamily: "'Jost', sans-serif", fontSize: 13, color: (localStorage.getItem('pr_font') || 'md') === opt.id ? T.ivory : T.inkMid, cursor: "pointer" }}>
                            {opt.label}
                          </button>
                        ))}
                      </div>
                    </div>
                    <div style={{ padding: "14px 0" }}>
                      <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, display: "block", marginBottom: 6 }}>Evening reminder</span>
                      <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, fontStyle: "italic" }}>Add Pure Rêve to your home screen to receive evening reminders. Coming soon.</span>
                    </div>
                  </div>
                )}
                {s.id === "sanctuary" && (
                  <div>
                    <SR label="Take the sanctuary tour again" fn={() => { localStorage.removeItem('pr_onboarded'); window.location.reload(); }} />
                    <SR label="Export journal entries" fn={exportJournal} val={exportDone ? "✦ Done" : ""} />
                    <SR label={resetDone ? "Tracker reset ✦" : "Reset Tracker"} fn={async () => { if (!user) return; await supabase.from('tracker').delete().eq('user_id', user.id); setResetDone(true); }} danger={!resetDone} />
                  </div>
                )}
                {s.id === "about" && (
                  <div>
                    <SR label="Version" val="1.0.0" fn={() => {}} />
                    <SR label="Contact us" val="hello@purereve.com" fn={() => window.open('mailto:hello@purereve.com')} />
                    <SR label="Privacy Policy" fn={() => setScreen('privacy')} />
                    <SR label="Terms of Service" fn={() => setScreen('terms')} />
                    <div style={{ padding: "16px 0 4px", textAlign: "center" }}>
                      <img src="/pure-reve-icon.svg" style={{ width: 48, height: 48, display: "block", margin: "0 auto 8px" }} alt="Pure Reve" />
                      <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkGhost, margin: "6px 0 0" }}>© 2026 Pure Rêve LLC</p>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </FadeIn>
      ))}
    </div>
  );
};

const PrivacyScreen = ({ setScreen }) => {
  return (
    <div style={{ padding: "56px 28px 100px" }}>
      <FadeIn>
        <button onClick={() => setScreen("settings")} style={{ background: "none", border: "none", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", color: T.inkGhost, cursor: "pointer", padding: "0 0 20px", display: "block" }}>← Back to Settings</button>
        <Label style={{ marginBottom: 8 }}>Privacy Policy</Label>
        <Serif size={26} italic style={{ display: "block", marginBottom: 8 }}>Your privacy is sacred.</Serif>
        <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, display: "block", marginBottom: 28 }}>Last updated: May 2026  · Pure Rêve LLC</span>
      </FadeIn>

      {[
        {
          title: "Who We Are",
          body: "Pure Rêve LLC is a wellness company based in Orlando, Florida. We operate the Pure Rêve Digital Sanctuary app at purereve.app and the Pure Rêve shop at purereve.com. You can reach us at hello@purereve.com."
        },
        {
          title: "What We Collect",
          body: "We collect your email address when you create an account. We store the content you create inside the app — including journal entries, mood check-ins, stillness tracker records, and release wall posts. We do not collect your name, phone number, payment information (handled by Shopify), or location unless you provide it voluntarily."
        },
        {
          title: "How We Use Your Data",
          body: "Your data is used solely to provide and improve your sanctuary experience. We use your email to authenticate your account and send account-related communications. We never sell your personal information to third parties. We never use your journal entries or private content for advertising, AI training, or any purpose other than displaying it back to you."
        },
        {
          title: "How We Store Your Data",
          body: "Your data is stored securely using Supabase, a trusted cloud database provider. All data is encrypted in transit and at rest. We use industry-standard security practices to protect your information."
        },
        {
          title: "Your Rights",
          body: "You have the right to access, correct, or delete your personal data at any time. You can export your journal entries from Settings → My Sanctuary → Export Journal. You can delete your account from Settings → Account → Delete Account, which will permanently remove all your data from our servers within 30 days."
        },
        {
          title: "Third Party Services",
          body: "We use Supabase for data storage, Vercel for app hosting, Klaviyo for email communications, and Shopify for e-commerce. Each of these providers has their own privacy policy. We do not share your personal information with these providers beyond what is necessary to operate the app."
        },
        {
          title: "Children",
          body: "Pure Rêve is intended for users who are 18 years of age or older. We do not knowingly collect personal information from anyone under 18. If we become aware that a user is under 18, we will terminate their account immediately."
        },
        {
          title: "Changes to This Policy",
          body: "We may update this Privacy Policy from time to time. We will notify you of significant changes by posting the new policy on this page with an updated date. Your continued use of Pure Rêve after changes constitutes acceptance of the new policy."
        },
        {
          title: "Contact Us",
          body: "If you have any questions about this Privacy Policy or how we handle your data, please contact us at hello@purereve.com. Pure Rêve LLC, 6100 Lake Ellenor Dr, Suite 151 #1082, Orlando, FL 32809."
        },
      ].map((s, i) => (
        <FadeIn key={i} delay={i * 60}>
          <div style={{ marginBottom: 24, paddingBottom: 24, borderBottom: "1px solid " + T.sand }}>
            <Serif size={16} style={{ display: "block", marginBottom: 8 }}>{s.title}</Serif>
            <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkSoft, fontWeight: 300, lineHeight: 1.9, margin: 0 }}>{s.body}</p>
          </div>
        </FadeIn>
      ))}

      <FadeIn delay={600}>
        <div style={{ padding: "20px", background: T.sand, borderRadius: 2, textAlign: "center" }}>
          <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 22, color: T.sandDark }}>✦</span>
          <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkGhost, margin: "8px 0 0", letterSpacing: "0.08em" }}>© 2026 Pure Rêve LLC · All rights reserved</p>
        </div>
      </FadeIn>
    </div>
  );
};

const TermsScreen = ({ setScreen }) => {
  return (
    <div style={{ padding: "56px 28px 100px" }}>
      <FadeIn>
        <button onClick={() => setScreen("settings")} style={{ background: "none", border: "none", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", color: T.inkGhost, cursor: "pointer", padding: "0 0 20px", display: "block" }}>← Back to Settings</button>
        <Label style={{ marginBottom: 8 }}>Terms of Service</Label>
        <Serif size={26} italic style={{ display: "block", marginBottom: 8 }}>Your sanctuary, your agreement.</Serif>
        <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkGhost, display: "block", marginBottom: 28 }}>Last updated: May 2026 · Pure Rêve LLC</span>
      </FadeIn>

      {[
        {
          title: "Age Requirement",
          body: "You must be at least 18 years of age to use Pure Rêve. By accessing or using our app, you confirm that you are 18 or older. If you are under 18, you are not permitted to use this service. We reserve the right to terminate accounts belonging to users under 18 without notice."
        },
        {
          title: "Lumière AI Guide",
          body: "Lumière is an artificial intelligence conversational guide built on Claude by Anthropic. Lumière is not a licensed therapist, psychologist, counselor, or mental health professional. Conversations with Lumière do not constitute therapy, medical advice, or clinical treatment of any kind, and do not create a provider-patient relationship. Lumière may occasionally produce inaccurate or incomplete responses. Always consult a qualified healthcare or mental health professional for clinical concerns."
        },
        {
          title: "Not a Medical or Mental Health Service",
          body: "IMPORTANT: Pure Rêve is a wellness app designed for reflection, relaxation, and personal growth. It is NOT a medical service, mental health service, therapy platform, or crisis intervention service. Nothing in this app — including content from Lumière, our AI guide — constitutes medical advice, psychiatric advice, or professional mental health care. If you are experiencing a mental health crisis, suicidal thoughts, or a medical emergency, please contact a licensed professional immediately or call 988 (Suicide & Crisis Lifeline) or 911."
        },
        {
          title: "Supplement Disclaimer",
          body: "The Pure Rêve Stillness Gummy is a dietary supplement. These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease. Always consult your healthcare provider before starting any new supplement, especially if you are pregnant, nursing, taking medications, or have a medical condition."
        },
        {
          title: "Your Content",
          body: "You own the content you create in Pure Rêve — your journal entries, mood check-ins, and any other personal content. We do not claim ownership of your words. By using the app, you grant Pure Rêve LLC a limited license to store and display your content back to you within the app. We will never publish, sell, or share your private content without your explicit consent. Anonymous posts you share to the Release Wall are visible to other users by your choice."
        },
        {
          title: "Acceptable Use",
          body: "You agree not to use Pure Rêve for any unlawful purpose or in any way that could harm other users. You agree not to attempt to hack, reverse engineer, or disrupt the app. You agree not to post content on the Release Wall that is hateful, violent, sexually explicit, or harmful to others. We reserve the right to remove content and terminate accounts that violate these rules."
        },
        {
          title: "No Warranty",
          body: "Pure Rêve is provided 'as is' without warranties of any kind. We do not guarantee that the app will be available at all times, error-free, or that it will meet your specific needs. We are not responsible for any loss of data, emotional harm, or other damages arising from your use of the app."
        },
        {
          title: "Limitation of Liability",
          body: "To the maximum extent permitted by law, Pure Rêve LLC shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the app or our products. Our total liability to you for any claim shall not exceed the amount you paid us in the 12 months preceding the claim."
        },
        {
          title: "Governing Law",
          body: "These Terms of Service are governed by the laws of the State of Florida, United States, without regard to conflict of law principles. Any disputes arising from these terms or your use of Pure Rêve shall be resolved exclusively in the courts of Orange County, Florida."
        },
        {
          title: "Changes to Terms",
          body: "We may update these Terms of Service from time to time. We will notify you of significant changes by posting the new terms on this page with an updated date. Your continued use of Pure Rêve after changes constitutes acceptance of the new terms."
        },
        {
          title: "Contact",
          body: "For questions about these terms, contact us at hello@purereve.com. Pure Rêve LLC, 6100 Lake Ellenor Dr, Suite 151 #1082, Orlando, FL 32809."
        },
      ].map((s, i) => (
        <FadeIn key={i} delay={i * 60}>
          <div style={{ marginBottom: 24, paddingBottom: 24, borderBottom: "1px solid " + T.sand }}>
            <Serif size={16} style={{ display: "block", marginBottom: 8 }}>{s.title}</Serif>
            <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: T.inkSoft, fontWeight: 300, lineHeight: 1.9, margin: 0 }}>{s.body}</p>
              
          </div>
        </FadeIn>
      ))}

      <FadeIn delay={700}>
        <div style={{ padding: "20px", background: T.sand, borderRadius: 2, textAlign: "center" }}>
          <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 22, color: T.sandDark }}>✦</span>
          <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkGhost, margin: "8px 0 0", letterSpacing: "0.08em" }}>© 2026 Pure Rêve LLC · All rights reserved</p>
        </div>
      </FadeIn>
    </div>
  );
};


const WaitlistBanner = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!email.includes("@")) return;
    setLoading(true);
    try {
      await subscribeToKlaviyo(email);
    } catch(e) {}
    setSent(true);
    setLoading(false);
  };

  if (sent) return (
    <div style={{ background: "rgba(255,255,255,0.1)", borderRadius: 2, padding: "16px 20px", marginBottom: 20, textAlign: "center", border: "1px solid rgba(255,255,255,0.2)" }}>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 16, fontStyle: "italic", color: T.ivory, margin: 0 }}>You're on the list. We'll find you when it's time. ✦</p>
    </div>
  );

  return (
    <div style={{ background: "rgba(255,255,255,0.08)", borderRadius: 2, padding: "20px", marginBottom: 20, border: "1px solid rgba(255,255,255,0.15)" }}>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontStyle: "italic", color: T.ivory, lineHeight: 1.5, marginBottom: 6, marginTop: 0 }}>The sanctuary is almost ready.</p>
      <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: "rgba(250,247,242,0.7)", fontWeight: 300, lineHeight: 1.7, marginBottom: 16, marginTop: 0 }}>Be first to enter. Join the Pure Rêve waitlist.</p>
      <div style={{ display: "flex", gap: 8 }}>
        <input value={email} onChange={e => setEmail(e.target.value)} placeholder="Your email address"
          style={{ flex: 1, background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.2)", borderRadius: 2, padding: "11px 14px", fontFamily: "'Jost', sans-serif", fontSize: 12, fontWeight: 300, color: T.ivory, outline: "none" }} />
        <button onClick={handleSubmit} disabled={loading}
          style={{ background: "#B8965A", color: T.ivory, border: "none", borderRadius: 2, padding: "11px 16px", fontFamily: "'Jost', sans-serif", fontSize: 10, letterSpacing: "0.12em", textTransform: "uppercase", cursor: "pointer", whiteSpace: "nowrap" }}>
          {loading ? "..." : "Join ✦"}
        </button>
      </div>
    </div>
  );
};


const StripePaywall = ({ user, onSignIn }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const handleSubscribe = async () => {
    setLoading(true); setError("");
    try {
      const res = await fetch("/api/create-checkout", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email: user.email, userId: user.id, priceId: "price_1UQ5SNIDjRvABcswBRZwRoKr" }) });
      const data = await res.json();
      if (data.url) { window.location.href = data.url; } else { setError("Something went wrong."); }
    } catch(e) { setError("Something went wrong."); }
    setLoading(false);
  };
  return (<div style={{minHeight:"100vh",background:"radial-gradient(ellipse at center, #0D3B5E 0%, #071E30 70%, #050F1A 100%)",display:"flex",alignItems:"center",justifyContent:"center",padding:"40px 24px"}}><div style={{width:"100%",maxWidth:360,textAlign:"center"}}><span style={{fontFamily:"Jost,sans-serif",fontSize:11,letterSpacing:"0.3em",color:"rgba(250,247,242,0.75)",display:"block",marginBottom:32}}>PURE RÊVE<sup style={{ fontSize: "0.55em", letterSpacing: 0, marginLeft: 2, verticalAlign: "super" }}>™</sup></span><div style={{fontFamily:"Georgia,serif",fontSize:28,fontStyle:"italic",color:"#FAF7F2",lineHeight:1.3,marginBottom:12}}>Enter the Sanctuary.</div><p style={{fontFamily:"Jost,sans-serif",fontSize:13,color:"rgba(250,247,242,0.8)",fontWeight:300,lineHeight:1.8,marginBottom:32}}>Full access to your digital sanctuary. Cancel anytime.</p><div style={{background:"rgba(255,255,255,0.06)",border:"1px solid rgba(184,150,90,0.3)",borderRadius:4,padding:"24px 20px",marginBottom:24}}><div style={{fontFamily:"Georgia,serif",fontSize:42,color:"#B8965A",marginBottom:4}}>$4.99</div><span style={{fontFamily:"Jost,sans-serif",fontSize:12,color:"rgba(250,247,242,0.75)",letterSpacing:"0.1em"}}>PER MONTH</span></div>{error && <p style={{color:"#E88",fontSize:12,marginBottom:12}}>{error}</p>}<button onClick={handleSubscribe} disabled={loading} style={{width:"100%",background:"#B8965A",color:"#FAF7F2",border:"none",borderRadius:2,padding:"16px",fontFamily:"Jost,sans-serif",fontSize:12,letterSpacing:"0.2em",textTransform:"uppercase",cursor:loading?"not-allowed":"pointer",opacity:loading?0.7:1}}>{loading?"Please wait...":"Begin the Sanctuary"}</button><p style={{fontFamily:"Jost,sans-serif",fontSize:11,color:"rgba(250,247,242,0.65)",marginTop:16,lineHeight:1.7}}>Renews monthly at $4.99 until you cancel. Cancel anytime in Settings. Secured by Stripe.</p><p style={{fontFamily:"Jost,sans-serif",fontSize:12,color:"rgba(250,247,242,0.7)",marginTop:8}}>Already have an account? <button onClick={onSignIn} style={{background:"none",border:"none",color:"#c9a96e",fontFamily:"Jost,sans-serif",fontSize:12,cursor:"pointer",padding:0,textDecoration:"underline"}}>Sign in</button></p><p style={{fontFamily:"Jost,sans-serif",fontSize:10,color:"rgba(250,247,242,0.65)",marginTop:12,lineHeight:1.7}}>By subscribing you agree to our <a href="https://purereve.app/legal-info.html" target="_blank" style={{color:"rgba(250,247,242,0.75)"}}>Privacy Policy</a> and <a href="https://purereve.app/legal-info.html" target="_blank" style={{color:"rgba(250,247,242,0.75)"}}>Terms of Service</a>.</p></div></div>);
};

const BetaGate = ({ onAccess }) => {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [shake, setShake] = useState(false);

  const SECRET = "PUREREVE2026";

  const attempt = () => {
    if (code.trim().toUpperCase() === SECRET) {
      localStorage.setItem('pr_beta', '1');
      onAccess();
    } else {
      setError("That code is not recognized. Try again.");
      setShake(true);
      setTimeout(() => setShake(false), 500);
      setCode("");
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "radial-gradient(ellipse at center, #0D3B5E 0%, #071E30 70%, #050F1A 100%)", display: "flex", alignItems: "center", justifyContent: "center", padding: "40px 28px" }}>
      <div style={{ width: "100%", maxWidth: 360, textAlign: "center" }}>
        <WaitlistBanner />
        <img src="/pure-reve-icon-light.svg" style={{ width: 64, height: 64, display: "block", margin: "0 auto 24px" }} alt="Pure Reve" />
        <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.22em", textTransform: "uppercase", color: "#7A6A58", margin: "0 0 12px" }}>Pure Rêve<sup style={{ fontSize: "0.55em", letterSpacing: 0, marginLeft: 2, verticalAlign: "super" }}>™</sup></p>
        <Serif size={28} italic color="#FAF7F2" style={{ display: "block", lineHeight: 1.3, marginBottom: 8 }}>{TRANSLATIONS.en.privateBeta}</Serif>

        <div style={{ transform: shake ? "translateX(8px)" : "none", transition: "transform 0.1s" }}>
          <input
            value={code}
            onChange={e => { setCode(e.target.value); setError(""); }}
            onKeyDown={e => e.key === "Enter" && attempt()}
            placeholder={TRANSLATIONS.en.accessCode}
            style={{ width: "100%", background: "rgba(237,229,216,0.06)", border: "1px solid rgba(184,164,140,0.2)", borderRadius: 2, padding: "14px 16px", fontFamily: "'Jost', sans-serif", fontSize: 13, color: "#FAF7F2", outline: "none", boxSizing: "border-box", marginBottom: 12, textAlign: "center", letterSpacing: "0.12em", textTransform: "uppercase" }}
          />
          {error && <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: "#C0392B", margin: "0 0 12px" }}>{error}</p>}
          <button onClick={attempt} style={{ width: "100%", background: "#B8A48C", color: "#0D3B5E", border: "none", borderRadius: 2, padding: "15px", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.18em", textTransform: "uppercase", cursor: "pointer" }}>
            {TRANSLATIONS.en.enterSanctuaryBtn}
          </button>
        </div>

        <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: "#3D3228", margin: "28px 0 0", lineHeight: 1.9 }}>
          Don't have a code?<br />
          <a href="mailto:hello@purereve.com" style={{ color: "#7A6A58", textDecoration: "none" }}>hello@purereve.com</a>
        </p>
      </div>
    
      </div>
  );
};

const TRANSLATIONS = {
  en: {
    // Nav
    sanctuary: "Sanctuary", reframe: "Reframe", stillness: "Stillness",
    strength: "Strength", more: "More", collection: "Collection",
    community: "Community", detente: "Détente", lumiere: "Lumière",
    settings: "Settings", word: "Word",
    // Greetings
    goodMorning: "Good morning", goodAfternoon: "Good afternoon", goodEvening: "Good evening",
    // Home
    sanctuaryAwaits: "Your sanctuary awaits.", whereBegin: "Where would you like to begin?",
    digitalSanctuary: "Digital Sanctuary", signOut: "Sign out",
    // Mood
    howArriving: "How are you arriving today?", enterSanctuary: "ENTER THE SANCTUARY →",
    heavy: "Heavy", heavySub: "I am carrying something today",
    anxious: "Anxious", anxiousSub: "My mind will not quiet down",
    numb: "Numb", numbSub: "I feel a little disconnected",
    okay: "Okay", okaySub: "Just checking in today",
    grateful: "Grateful", gratefulSub: "I want to reflect and grow",
    // Auth
    returnSanctuary: "Return to your sanctuary.",
    enterBtn: "Enter Sanctuary", createBtn: "Create Sanctuary",
    continueGoogle: "Continue with Google",
    newHere: "New here? Create your sanctuary",
    alreadyHave: "Already have a sanctuary? Sign in",
    emailAddress: "Email address", password: "Password",
    // Beta
    privateBeta: "Private Beta",
    betaMessage: "Pure Rêve is currently in private beta. Enter your access code to continue.",
    accessCode: "Access code", enterSanctuaryBtn: "Enter the Sanctuary", noCode: "Don't have a code?",
    // Vessel
    vessel: "Your Kintsugi Vessel",
    vesselWhole: "Your vessel is whole. Begin your journey.",
    vesselMarked: "Life has marked your vessel. Stillness will gild it.",
    vesselGold: "Your struggles are becoming gold. ✦",
    cracks: "Cracks", gilded: "Gilded",
    tapCrack: "Tap a crack to see its story", shareVessel: "✦ Share my vessel",
    // Ritual
    nightlyStillness: "Nightly Stillness", releaseDay: "Release the day before sleep",
    startTimer: "Begin stillness", timerRunning: "Breathe. Be still.",
    takeGummy: "Take my Gummy", digitalSunset: "Digital Sunset",
    openSunset: "Begin the Digital Sunset",
    // Journal
    reframeStruggle: "Reframe a Struggle", turnDifficulty: "Turn difficulty into strength",
    // Library  
    strengthLibrary: "Strength Library", sevenMeditations: "Seven scriptures for the soul",
    // Détente
    easeTension: "Ease the tension.", threeAnchors: "Three practices for any moment of the day.",
    breathe: "Breathe", breatheSub: "4 — 4 — 8 breathing cycle",
    breatheIn: "Breathe in...", hold: "Hold...", breatheOut: "Breathe out...",
    tapToBegin: "Tap to begin", wellDone: "Well done. ✦", beginAgain: "Begin again",
    release: "Release", releaseSub: "Write a worry and let it dissolve",
    writeWorry: "Write it here...", releaseIt: "Release it ✦",
    released: "Released. You are lighter now. ✦",
    gratitudeFull: "Gratitude", gratitudeSub: "Three things you are grateful for",
    gratefulFor: "I am grateful for...", receiveThisMoment: "Receive this moment ✦",
    gratefulHeart: "A grateful heart is a peaceful heart.",
    // Settings
    settingsTitle: "Settings", settingsTagline: "Your sanctuary, your way.",
    account: "Account", preferences: "Preferences",
    mySanctuary: "My Sanctuary", aboutApp: "About Pure Rêve",
    email: "Email", displayName: "Display name", yourName: "Your name",
    save: "Save", changePassword: "Change password", signOutBtn: "Sign out",
    deleteAccount: "Delete account",
    defaultSound: "Default Stillness sound", showVessel: "Show Kintsugi Vessel on home",
    show: "Show", hide: "Hide", textSize: "Text size",
    small: "Small", medium: "Medium", large: "Large",
    language: "Language", eveningReminder: "Evening reminder",
    resetTour: "Reset onboarding tour", exportJournal: "Export journal entries",
    resetTracker: "Reset Stillness Tracker", trackerReset: "Tracker reset ✦",
    version: "Version", contactUs: "Contact us", privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service", rateApp: "Rate the app",
    // Community
    youAreNotAlone: "You are not alone here.",
    sanctuaryCollective: "The Sanctuary Collective", ventingWall: "Venting Wall",
    spreadLight: "Spread the Light", applyContribute: "Apply to contribute",
    safeSpace: "This is a safe space. Say what you need to say. No names. No judgment.",
    whatsOnHeart: "What's on your heart right now...",
    releaseItBtn: "Release it ✦", youAreHeard: "You are heard. ✦",
    spreadLightTitle: "Spread the Light.",
    spreadLightMsg: "Pure Rêve was built for anyone carrying something heavy. If this sanctuary has helped you — pass it on. The way light actually travels.",
    sharePureReve: "✦ Share Pure Rêve", orShareLink: "Or share the link directly",
    // Lumière
    lumiereTitle: "Lumière", lumiereSub: "Your sanctuary guide",
    shareHeart: "Share what is on your heart...", newConversation: "Begin a new conversation",
    // Scripture
    wordTitle: "The Word", todaysVerse: "Today's verse",
    // Onboarding
    next: "Next →", skipTour: "Skip tour", enterSanctuaryFinal: "Enter the Sanctuary ✦",
  },
  fr: {
    sanctuary: "Sanctuaire", reframe: "Recentrer", stillness: "Sérénité",
    strength: "Force", more: "Plus", collection: "Collection",
    community: "Communauté", detente: "Détente", lumiere: "Lumière",
    settings: "Paramètres", word: "Parole",
    goodMorning: "Bonjour", goodAfternoon: "Bon après-midi", goodEvening: "Bonsoir",
    sanctuaryAwaits: "Votre sanctuaire vous attend.", whereBegin: "Par où souhaitez-vous commencer ?",
    digitalSanctuary: "Sanctuaire Numérique", signOut: "Se déconnecter",
    howArriving: "Comment arrivez-vous aujourd'hui ?", enterSanctuary: "ENTRER DANS LE SANCTUAIRE →",
    heavy: "Lourd", heavySub: "Je porte quelque chose aujourd'hui",
    anxious: "Anxieux", anxiousSub: "Mon esprit n'arrive pas à se calmer",
    numb: "Engourdi", numbSub: "Je me sens un peu déconnecté",
    okay: "Bien", okaySub: "Je passe juste vous dire bonjour",
    grateful: "Reconnaissant", gratefulSub: "Je veux réfléchir et grandir",
    returnSanctuary: "Retournez à votre sanctuaire.",
    enterBtn: "Entrer dans le Sanctuaire", createBtn: "Créer mon Sanctuaire",
    continueGoogle: "Continuer avec Google",
    newHere: "Nouveau ? Créez votre sanctuaire",
    alreadyHave: "Déjà un sanctuaire ? Connectez-vous",
    emailAddress: "Adresse e-mail", password: "Mot de passe",
    privateBeta: "Bêta Privée",
    betaMessage: "Pure Rêve est actuellement en bêta privée. Entrez votre code d'accès pour continuer.",
    accessCode: "Code d'accès", enterSanctuaryBtn: "Entrer dans le Sanctuaire", noCode: "Vous n'avez pas de code ?",
    vessel: "Votre Vase Kintsugi",
    vesselWhole: "Votre vase est intact. Commencez votre voyage.",
    vesselMarked: "La vie a marqué votre vase. La sérénité le dorera.",
    vesselGold: "Vos épreuves deviennent de l'or. ✦",
    cracks: "Fissures", gilded: "Doré",
    tapCrack: "Touchez une fissure pour voir son histoire", shareVessel: "✦ Partager mon vase",
    nightlyStillness: "Sérénité Nocturne", releaseDay: "Libérez la journée avant de dormir",
    startTimer: "Commencer la sérénité", timerRunning: "Respirez. Soyez tranquille.",
    takeGummy: "Prendre mon Gummy", digitalSunset: "Coucher de Soleil Numérique",
    openSunset: "Commencer le Coucher de Soleil Numérique",
    reframeStruggle: "Recentrer une Lutte", turnDifficulty: "Transformez la difficulté en force",
    strengthLibrary: "Bibliothèque de Force", sevenMeditations: "Sept écritures pour l'âme",
    easeTension: "Apaisez la tension.", threeAnchors: "Trois pratiques pour tout moment de la journée.",
    breathe: "Respirer", breatheSub: "Cycle respiratoire 4 — 4 — 8",
    breatheIn: "Inspirez...", hold: "Retenez...", breatheOut: "Expirez...",
    tapToBegin: "Appuyez pour commencer", wellDone: "Bravo. ✦", beginAgain: "Recommencer",
    release: "Relâcher", releaseSub: "Écrivez une inquiétude et laissez-la se dissoudre",
    writeWorry: "Écrivez ici...", releaseIt: "Relâchez ✦",
    released: "Relâché. Vous vous sentez plus léger. ✦",
    gratitudeFull: "Gratitude", gratitudeSub: "Trois choses pour lesquelles vous êtes reconnaissant",
    gratefulFor: "Je suis reconnaissant pour...", receiveThisMoment: "Recevoir ce moment ✦",
    gratefulHeart: "Un cœur reconnaissant est un cœur en paix.",
    settingsTitle: "Paramètres", settingsTagline: "Votre sanctuaire, à votre façon.",
    account: "Compte", preferences: "Préférences",
    mySanctuary: "Mon Sanctuaire", aboutApp: "À propos de Pure Rêve",
    email: "E-mail", displayName: "Nom d'affichage", yourName: "Votre nom",
    save: "Enregistrer", changePassword: "Changer le mot de passe", signOutBtn: "Se déconnecter",
    deleteAccount: "Supprimer le compte",
    defaultSound: "Son de Sérénité par défaut", showVessel: "Afficher le Vase Kintsugi",
    show: "Afficher", hide: "Masquer", textSize: "Taille du texte",
    small: "Petit", medium: "Moyen", large: "Grand",
    language: "Langue", eveningReminder: "Rappel du soir",
    resetTour: "Réinitialiser la visite", exportJournal: "Exporter le journal",
    resetTracker: "Réinitialiser le Tracker", trackerReset: "Tracker réinitialisé ✦",
    version: "Version", contactUs: "Nous contacter", privacyPolicy: "Politique de confidentialité",
    termsOfService: "Conditions d'utilisation", rateApp: "Évaluer l'application",
    youAreNotAlone: "Vous n'êtes pas seul ici.",
    sanctuaryCollective: "Le Collectif Sanctuaire", ventingWall: "Mur d'Expression",
    spreadLight: "Propager la Lumière", applyContribute: "Candidater pour contribuer",
    safeSpace: "C'est un espace sûr. Dites ce que vous devez dire. Sans nom. Sans jugement.",
    whatsOnHeart: "Qu'avez-vous sur le cœur en ce moment...",
    releaseItBtn: "Relâchez ✦", youAreHeard: "Vous êtes entendu. ✦",
    spreadLightTitle: "Propager la Lumière.",
    spreadLightMsg: "Pure Rêve a été construit pour tous ceux qui portent quelque chose de lourd. Si ce sanctuaire vous a aidé — transmettez-le. La façon dont la lumière voyage vraiment.",
    sharePureReve: "✦ Partager Pure Rêve", orShareLink: "Ou partagez le lien directement",
    lumiereTitle: "Lumière", lumiereSub: "Votre guide du sanctuaire",
    shareHeart: "Partagez ce qui est sur votre cœur...", newConversation: "Commencer une nouvelle conversation",
    wordTitle: "La Parole", todaysVerse: "Le verset du jour",
    next: "Suivant →", skipTour: "Passer la visite", enterSanctuaryFinal: "Entrer dans le Sanctuaire ✦",
  },
  es: {
    sanctuary: "Santuario", reframe: "Reencuadrar", stillness: "Quietud",
    strength: "Fortaleza", more: "Más", collection: "Colección",
    community: "Comunidad", detente: "Distensión", lumiere: "Lumière",
    settings: "Ajustes", word: "Palabra",
    goodMorning: "Buenos días", goodAfternoon: "Buenas tardes", goodEvening: "Buenas noches",
    sanctuaryAwaits: "Tu santuario te espera.", whereBegin: "¿Por dónde te gustaría comenzar?",
    digitalSanctuary: "Santuario Digital", signOut: "Cerrar sesión",
    howArriving: "¿Cómo llegas hoy?", enterSanctuary: "ENTRAR AL SANTUARIO →",
    heavy: "Pesado", heavySub: "Llevo algo conmigo hoy",
    anxious: "Ansioso", anxiousSub: "Mi mente no logra calmarse",
    numb: "Entumecido", numbSub: "Me siento un poco desconectado",
    okay: "Bien", okaySub: "Solo pasando a decir hola",
    grateful: "Agradecido", gratefulSub: "Quiero reflexionar y crecer",
    returnSanctuary: "Regresa a tu santuario.",
    enterBtn: "Entrar al Santuario", createBtn: "Crear mi Santuario",
    continueGoogle: "Continuar con Google",
    newHere: "¿Nuevo aquí? Crea tu santuario",
    alreadyHave: "¿Ya tienes un santuario? Inicia sesión",
    emailAddress: "Correo electrónico", password: "Contraseña",
    privateBeta: "Beta Privada",
    betaMessage: "Pure Rêve está actualmente en beta privada. Ingresa tu código de acceso para continuar.",
    accessCode: "Código de acceso", enterSanctuaryBtn: "Entrar al Santuario", noCode: "¿No tienes un código?",
    vessel: "Tu Vasija Kintsugi",
    vesselWhole: "Tu vasija está entera. Comienza tu viaje.",
    vesselMarked: "La vida ha marcado tu vasija. La quietud la dorará.",
    vesselGold: "Tus luchas se están convirtiendo en oro. ✦",
    cracks: "Grietas", gilded: "Dorado",
    tapCrack: "Toca una grieta para ver su historia", shareVessel: "✦ Compartir mi vasija",
    nightlyStillness: "Quietud Nocturna", releaseDay: "Libera el día antes de dormir",
    startTimer: "Comenzar la quietud", timerRunning: "Respira. Quédate quieto.",
    takeGummy: "Tomar mi Gummy", digitalSunset: "Atardecer Digital",
    openSunset: "Comenzar el Atardecer Digital",
    reframeStruggle: "Reencuadrar una Lucha", turnDifficulty: "Convierte la dificultad en fortaleza",
    strengthLibrary: "Biblioteca de Fortaleza", sevenMeditations: "Siete escrituras para el alma",
    easeTension: "Alivia la tensión.", threeAnchors: "Tres prácticas para cualquier momento del día.",
    breathe: "Respirar", breatheSub: "Ciclo respiratorio 4 — 4 — 8",
    breatheIn: "Inhala...", hold: "Mantén...", breatheOut: "Exhala...",
    tapToBegin: "Toca para comenzar", wellDone: "Bien hecho. ✦", beginAgain: "Comenzar de nuevo",
    release: "Soltar", releaseSub: "Escribe una preocupación y déjala disolverse",
    writeWorry: "Escríbelo aquí...", releaseIt: "Suéltalo ✦",
    released: "Soltado. Ahora estás más ligero. ✦",
    gratitudeFull: "Gratitud", gratitudeSub: "Tres cosas por las que estás agradecido",
    gratefulFor: "Estoy agradecido por...", receiveThisMoment: "Recibir este momento ✦",
    gratefulHeart: "Un corazón agradecido es un corazón en paz.",
    settingsTitle: "Ajustes", settingsTagline: "Tu santuario, a tu manera.",
    account: "Cuenta", preferences: "Preferencias",
    mySanctuary: "Mi Santuario", aboutApp: "Acerca de Pure Rêve",
    email: "Correo", displayName: "Nombre de pantalla", yourName: "Tu nombre",
    save: "Guardar", changePassword: "Cambiar contraseña", signOutBtn: "Cerrar sesión",
    deleteAccount: "Eliminar cuenta",
    defaultSound: "Sonido de Quietud predeterminado", showVessel: "Mostrar Vasija Kintsugi",
    show: "Mostrar", hide: "Ocultar", textSize: "Tamaño de texto",
    small: "Pequeño", medium: "Mediano", large: "Grande",
    language: "Idioma", eveningReminder: "Recordatorio nocturno",
    resetTour: "Restablecer visita", exportJournal: "Exportar diario",
    resetTracker: "Restablecer Tracker", trackerReset: "Tracker restablecido ✦",
    version: "Versión", contactUs: "Contáctanos", privacyPolicy: "Política de privacidad",
    termsOfService: "Términos de servicio", rateApp: "Calificar la aplicación",
    youAreNotAlone: "No estás solo aquí.",
    sanctuaryCollective: "El Colectivo Santuario", ventingWall: "Muro de Expresión",
    spreadLight: "Difundir la Luz", applyContribute: "Solicitar contribuir",
    safeSpace: "Este es un espacio seguro. Di lo que necesitas decir. Sin nombres. Sin juicios.",
    whatsOnHeart: "¿Qué tienes en el corazón ahora mismo...",
    releaseItBtn: "Suéltalo ✦", youAreHeard: "Eres escuchado. ✦",
    spreadLightTitle: "Difundir la Luz.",
    spreadLightMsg: "Pure Rêve fue construido para cualquiera que carga algo pesado. Si este santuario te ha ayudado — pásalo. La forma en que la luz realmente viaja.",
    sharePureReve: "✦ Compartir Pure Rêve", orShareLink: "O comparte el enlace directamente",
    lumiereTitle: "Lumière", lumiereSub: "Tu guía del santuario",
    shareHeart: "Comparte lo que está en tu corazón...", newConversation: "Comenzar una nueva conversación",
    wordTitle: "La Palabra", todaysVerse: "El versículo de hoy",
    next: "Siguiente →", skipTour: "Omitir visita", enterSanctuaryFinal: "Entrar al Santuario ✦",
  },
  ht: {
    sanctuary: "Sanktiyè", reframe: "Rekadreman", stillness: "Trankilite",
    strength: "Fòs", more: "Plis", collection: "Koleksyon",
    community: "Kominote", detente: "Detant", lumiere: "Lumyè",
    settings: "Paramèt", word: "Pawòl",
    goodMorning: "Bonjou", goodAfternoon: "Bon apremidi", goodEvening: "Bonswa",
    sanctuaryAwaits: "Sanktiyè ou ap tann ou.", whereBegin: "Kote ou vle kòmanse ?",
    digitalSanctuary: "Sanktiyè Nimerik", signOut: "Dekonekte",
    howArriving: "Kijan ou rive jodi a ?", enterSanctuary: "ANTRE NAN SANKTIYÈ →",
    heavy: "Lou", heavySub: "Mwen pote yon bagay jodi a",
    anxious: "Enkyè", anxiousSub: "Lespri mwen pa ka kalme",
    numb: "Anestezi", numbSub: "Mwen santi yon ti jan dekonekte",
    okay: "Anfòm", okaySub: "Jis pase di bonjou",
    grateful: "Rekonèsan", gratefulSub: "Mwen vle reflechi ak grandi",
    returnSanctuary: "Retounen nan sanktiyè ou.",
    enterBtn: "Antre nan Sanktiyè", createBtn: "Kreye Sanktiyè Mwen",
    continueGoogle: "Kontinye ak Google",
    newHere: "Nouvo isit ? Kreye sanktiyè ou",
    alreadyHave: "Ou deja gen yon sanktiyè ? Konekte",
    emailAddress: "Adrès imèl", password: "Modpas",
    privateBeta: "Beta Prive",
    betaMessage: "Pure Rêve kounye a nan beta prive. Antre kòd aksè ou pou kontinye.",
    accessCode: "Kòd aksè", enterSanctuaryBtn: "Antre nan Sanktiyè", noCode: "Ou pa gen kòd ?",
    vessel: "Vaz Kintsugi Ou",
    vesselWhole: "Vaz ou antye. Kòmanse vwayaj ou.",
    vesselMarked: "Lavi te make vaz ou. Trankilite ap dore li.",
    vesselGold: "Batay ou yo ap vinn lò. ✦",
    cracks: "Fant", gilded: "Dore",
    tapCrack: "Touche yon fant pou wè istwa li", shareVessel: "✦ Pataje vaz mwen",
    nightlyStillness: "Trankilite Aswè", releaseDay: "Lage jounen an anvan ou dòmi",
    startTimer: "Kòmanse trankilite", timerRunning: "Respire. Rete trankil.",
    takeGummy: "Pran Gummy mwen", digitalSunset: "Kouche Solèy Nimerik",
    openSunset: "Kòmanse Kouche Solèy Nimerik",
    reframeStruggle: "Rekadreman yon Lit", turnDifficulty: "Chanje difikilte an fòs",
    strengthLibrary: "Bibliyotèk Fòs", sevenMeditations: "Sèt vèsè pou nanm nan",
    easeTension: "Kalme tansyon an.", threeAnchors: "Twa pratik pou nenpòt moman nan jounen an.",
    breathe: "Respire", breatheSub: "Sik respirasyon 4 — 4 — 8",
    breatheIn: "Respire antre...", hold: "Kenbe...", breatheOut: "Respire soti...",
    tapToBegin: "Touche pou kòmanse", wellDone: "Bravo. ✦", beginAgain: "Kòmanse ankò",
    release: "Lage", releaseSub: "Ekri yon enkyetid epi kite li disparèt",
    writeWorry: "Ekri li isit...", releaseIt: "Lage li ✦",
    released: "Lage. Ou pi lejè kounye a. ✦",
    gratitudeFull: "Gratitid", gratitudeSub: "Twa bagay ou rekonesan pou yo",
    gratefulFor: "Mwen rekonesan pou...", receiveThisMoment: "Resevwa moman sa a ✦",
    gratefulHeart: "Yon kè rekonesan se yon kè ki an pè.",
    settingsTitle: "Paramèt", settingsTagline: "Sanktiyè ou, jan ou vle li.",
    account: "Kont", preferences: "Preferans",
    mySanctuary: "Sanktiyè Mwen", aboutApp: "Sou Pure Rêve",
    email: "Imèl", displayName: "Non afichaj", yourName: "Non ou",
    save: "Sove", changePassword: "Chanje modpas", signOutBtn: "Dekonekte",
    deleteAccount: "Efase kont",
    defaultSound: "Son Trankilite default", showVessel: "Montre Vaz Kintsugi",
    show: "Montre", hide: "Kache", textSize: "Gwosè tèks",
    small: "Piti", medium: "Mwayen", large: "Gran",
    language: "Lang", eveningReminder: "Rapèl aswè",
    resetTour: "Reyinitialize vwayaj", exportJournal: "Ekspòte jounal",
    resetTracker: "Reyinitialize Tracker", trackerReset: "Tracker reyinisyalize ✦",
    version: "Vèsyon", contactUs: "Kontakte nou", privacyPolicy: "Politik vi prive",
    termsOfService: "Kondisyon sèvis", rateApp: "Evalye aplikasyon an",
    youAreNotAlone: "Ou pa poukont ou isit.",
    sanctuaryCollective: "Kolektif Sanktiyè a", ventingWall: "Mi Ekspresyon",
    spreadLight: "Gaye Limyè", applyContribute: "Aplike pou kontribye",
    safeSpace: "Sa a se yon espas ki an sekirite. Di sa ou bezwen di. San non. San jijman.",
    whatsOnHeart: "Kisa ou gen nan kè ou kounye a...",
    releaseItBtn: "Lage li ✦", youAreHeard: "Yo tande ou. ✦",
    spreadLightTitle: "Gaye Limyè.",
    spreadLightMsg: "Pure Rêve te bati pou tout moun ki pote yon bagay lou. Si sanktiyè sa a te ede ou — pase li. Jan limyè vrèman vwayaje.",
    sharePureReve: "✦ Pataje Pure Rêve", orShareLink: "Oswa pataje lyen an dirèkteman",
    lumiereTitle: "Lumyè", lumiereSub: "Gid sanktiyè ou",
    shareHeart: "Pataje sa ki nan kè ou...", newConversation: "Kòmanse yon nouvo konvèsasyon",
    wordTitle: "Pawòl la", todaysVerse: "Vèsè jodi a",
    next: "Swivan →", skipTour: "Pase vwayaj", enterSanctuaryFinal: "Antre nan Sanktiyè ✦",
  },
};


// eslint-disable-next-line no-unused-vars
const useLang = () => {
  const lang = localStorage.getItem('pr_lang') || 'en';
  return TRANSLATIONS[lang] || TRANSLATIONS.en;
};

const OnboardingSlides = ({ onComplete, appLang }) => {
  const [slide, setSlide] = useState(0);

  const slides = [
    {
      icon: "✦",
      label: "Welcome",
      title: "Your sanctuary awaits.",
      sub: "Pure Rêve is a digital space built for your peace, your strength, and your rest. No judgment. No performance. Just you and a space that holds you.",
    },
    {
      icon: "◎",
      label: "How are you arriving?",
      title: "The Mood Check-In.",
      sub: "Every time you open the app, you are asked how you are arriving. Your answer guides you to the right part of the sanctuary — whether you need to release, reflect, or simply rest.",
    },
    {
      icon: "✦",
      label: "Daily",
      title: "The Weight Check.",
      sub: "Each morning the sanctuary asks: what are you carrying today that isn’t yours? Slide from light to heavy. The app meets you where you are with a breathing exercise, a candle, or a scripture.",
    },
    {
      icon: "✦",
      label: "Reframe · Stillness · Word",
      title: "Your three anchors.",
      sub: "The Reframe Journal transforms your struggle into strength with AI guidance. The Stillness timer gives you two minutes of release. The Daily Word delivers a scripture chosen just for today.",
    },
    {
      icon: "🌙",
      label: "Every evening",
      title: "The Digital Sunset.",
      sub: "A three-step evening ritual: release what you don’t need to carry into sleep, nourish yourself, and receive tonight’s scripture. It closes with one instruction — rest well.",
    },
    {
      icon: "✦",
      label: "For the hard moments",
      title: "Grief Mode · The Unsent Letter.",
      sub: "Grief Mode holds space without trying to fix you. The Unsent Letter lets you write to someone you can’t talk to — then burn it. Nothing saved. Nothing sent. Just release.",
    },
    {
      icon: "🌙",
      label: "When you’re awake at 3am",
      title: "The 3am Wall.",
      sub: "The sanctuary stays open at night. Between 11pm and 4am, Pure Rêve finds you first — with breathing and presence, for the moments when sleep won’t come.",
    },
    {
      icon: "✦",
      label: "For two people",
      title: "Sanctuary for Two.",
      sub: "Share a 6-digit code with someone you trust. Breathe together in real time. Exchange what you’re carrying. Witness each other in silence. No chat. No history. Just presence.",
    },
    {
      icon: "✦",
      label: "Your Kintsugi Vessel",
      title: "Your struggles become gold.",
      sub: "In Japanese art, broken pottery is repaired with gold — because the break is where the beauty lives. Every journal entry cracks your vessel. Every night of stillness gilds it.",
    },
    {
      icon: "✦",
      label: "Lumière",
      title: "Your sanctuary guide.",
      sub: "Lumière is a gentle AI companion. Share what is on your heart — she will respond with warmth and wisdom. She is not a therapist. She is a presence.",
    },
    {
      icon: "✦",
      label: "You are ready.",
      title: "The sanctuary is yours.",
      sub: "Everything here was built for the version of you that is carrying something heavy. You don’t have to be okay today. The sanctuary does not close.",
      final: true,
    },
  ];

  const current = slides[slide];

  return (
    <div style={{ position: "fixed", inset: 0, background: "radial-gradient(ellipse at center, #0D3B5E 0%, #071E30 70%, #050F1A 100%)", zIndex: 1000, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "48px 32px" }}>
      <div style={{ width: "100%", maxWidth: 380 }}>
        <div style={{ display: "flex", justifyContent: "center", gap: 6, marginBottom: 40 }}>
          {slides.map((_, i) => (
            <div key={i} style={{ width: i === slide ? 20 : 6, height: 6, borderRadius: 3, background: i === slide ? "#B8A48C" : "#3D3228", transition: "all 0.3s ease" }} />
          ))}
        </div>
        <div style={{ textAlign: "center", marginBottom: 20 }}>
          <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 48, color: "#B8A48C" }}>{current.icon}</span>
        </div>
        <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.22em", textTransform: "uppercase", color: "#7A6A58", textAlign: "center", margin: "0 0 12px" }}>{current.label}</p>
        <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 32, fontStyle: "italic", color: "#FAF7F2", textAlign: "center", lineHeight: 1.3, margin: "0 0 20px" }}>{current.title}</p>
        {current.final ? (
          <button onClick={onComplete} style={{ width: "100%", background: "#B8A48C", color: "#0D3B5E", border: "none", borderRadius: 2, padding: "16px", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.18em", textTransform: "uppercase", cursor: "pointer" }}>
            Enter the Sanctuary ✦
          </button>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <button onClick={() => setSlide(slide + 1)} style={{ width: "100%", background: "#B8A48C", color: "#0D3B5E", border: "none", borderRadius: 2, padding: "15px", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.16em", textTransform: "uppercase", cursor: "pointer" }}>
              Next →
            </button>
            {slide < slides.length - 1 && <button onClick={onComplete} style={{ width: "100%", background: "none", border: "none", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.12em", textTransform: "uppercase", color: "#3D3228", cursor: "pointer", padding: "8px" }}>Skip tour</button>}
          </div>
        )}
      </div>
    </div>
  );
};

const NightPrompt = ({ onEnter, onDismiss }) => {
// eslint-disable-next-line no-unused-vars
  const hour = new Date().getHours();
  const timeStr = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(6,4,8,0.96)", zIndex: 700, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "40px 28px" }}>
      <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: "#4A3F35", letterSpacing: "0.2em", marginBottom: 32 }}>{timeStr}</p>
      <img src="/pure-reve-icon-light.svg" style={{ width: 52, height: 52, display: "block", margin: "0 auto 28px", opacity: 0.6 }} alt="Pure Reve" />
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 28, fontStyle: "italic", color: "#C4B5A0", textAlign: "center", lineHeight: 1.6, marginBottom: 12 }}>
        It's late.
      </p>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 28, color: "#C4B5A0", textAlign: "center", lineHeight: 1.6, marginBottom: 40 }}>
        We're here.
      </p>
      <button onClick={onEnter}
        style={{ width: "100%", maxWidth: 300, background: "none", border: "1px solid #3A3028", borderRadius: 2, padding: "16px", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.16em", color: "#C4B5A0", cursor: "pointer", marginBottom: 16 }}>
        Open the 3am Wall
      </button>
      <button onClick={onDismiss}
        style={{ background: "none", border: "none", fontFamily: "'Jost', sans-serif", fontSize: 12, color: "#4A3F35", letterSpacing: "0.12em", cursor: "pointer", padding: "12px" }}>
        I'm okay, take me to my sanctuary
      </button>
    </div>
  );
};


const DisclaimerScreen = ({ onAccept }) => {
  const CrisisBar = () => (
    <div style={{ background: "#3D3228", borderRadius: 2, padding: "14px 16px", marginBottom: 10, borderLeft: "3px solid #8B6914" }}>
      <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: "#FAF7F2", fontWeight: 300, lineHeight: 1.9, margin: 0 }}>
        📞 <strong>Call or text 988</strong> — Suicide & Crisis Lifeline (US)<br/>
        📞 <strong>Call 911</strong> — Emergency services<br/>
        📞 <strong>Go to your nearest emergency room</strong>
      </p>
    </div>
  );

  const Section = ({ title, children }) => (
    <div style={{ background: T.sand, borderRadius: 2, padding: "18px", marginBottom: 14, border: "1px solid " + T.sandMid }}>
      <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: "#8B6914", letterSpacing: "0.14em", marginBottom: 10, fontWeight: 600 }}>{title}</p>
      {children}
    </div>
  );

  const Body = ({ text }) => (
    <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: T.inkMid, fontWeight: 300, lineHeight: 1.9, margin: 0 }}>{text}</p>
  );

  return (
    <div style={{ position: "fixed", inset: 0, background: T.ivory, zIndex: 800, overflowY: "auto", WebkitOverflowScrolling: "touch" }}>
      <div style={{ padding: "48px 24px 40px", maxWidth: 430, margin: "0 auto" }}>
        
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <img src="/pure-reve-icon-light.svg" style={{ width: 48, height: 48, display: "block", margin: "0 auto 12px", opacity: 0.7 }} alt="Pure Reve" />
          <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: "#6B5D52", letterSpacing: "0.2em", marginBottom: 8 }}>PURE RÊVE LLC</p>
          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontStyle: "italic", color: "#5F5242", lineHeight: 1.5 }}>
            Before you enter the sanctuary,<br/>please read carefully.
          </p>
        </div>

        <Section title="🚨 EMERGENCY & CRISIS NOTICE">
          <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: "#5F5242", fontWeight: 300, lineHeight: 1.9, marginBottom: 10 }}>
            Pure Rêve is a wellness app. It is <strong>NOT</strong> a crisis service, emergency service, or medical provider.
          </p>
          <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, color: "#5F5242", fontWeight: 300, lineHeight: 1.9, marginBottom: 10 }}>
            If you are experiencing a mental health emergency, having thoughts of suicide or self-harm, or are in danger:
          </p>
          <CrisisBar />
          <Body text="Pure Rêve does not provide therapy, medical advice, diagnosis, treatment, or emergency services of any kind." />
        </Section>

        <Section title="NOT A MEDICAL OR THERAPEUTIC SERVICE">
          <Body text="Pure Rêve is a general wellness and self-care tool for educational purposes only. Nothing in this app constitutes medical advice, mental health treatment, or a clinical provider-patient relationship. Always consult a qualified healthcare professional for medical or mental health concerns." />
        </Section>

        <Section title="ADVISOR SPOTLIGHT DISCLAIMER">
          <Body text="Content in the Advisor Spotlight is provided by licensed professionals for general wellness education only. This content does not establish a clinical provider-patient relationship and is not a substitute for professional mental health care. Viewing this content does not create any therapeutic or medical relationship with the advisor." />
        </Section>

        <Section title="INTERNATIONAL USERS">
          <Body text="Pure Rêve is operated and controlled in the United States of America under the laws of the State of Florida. If you access this app from outside the United States, you do so at your own risk and are solely responsible for compliance with all applicable local laws and regulations in your jurisdiction." />
        </Section>

        <Section title="AGE REQUIREMENT">
          <Body text="Pure Rêve is intended for users 18 years of age and older. By continuing, you confirm that you are at least 18 years old." />
        </Section>

        <div style={{ marginTop: 8, paddingTop: 20, borderTop: "1px solid #1C1610" }}>
          <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: "#6B5D52", textAlign: "center", lineHeight: 1.9, marginBottom: 16 }}>
            By tapping below, you confirm you have read and agree to these terms, our Privacy Policy and Terms of Service.
          </p>
          <button onClick={() => { localStorage.setItem('pr_disclaimer', '1'); onAccept(); }}
            style={{ width: "100%", background: T.ink, color: T.ivory, border: "1px solid #8B6914", borderRadius: 2, padding: "16px", fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.14em", cursor: "pointer", marginBottom: 12 }}>
            I have read and understand — Enter the Sanctuary
          </button>
          <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, color: "#4A3F35", textAlign: "center", letterSpacing: "0.1em" }}>
            Pure Rêve LLC · Orlando, Florida · purereve.app
          </p>
        </div>
      </div>
    </div>
  );
};
export default function App() {
  const [screen, setScreen] = useState("home");
  const [showMood, setShowMood] = useState(true);
  const [user, setUser] = useState(null);
  const [showResetPassword, setShowResetPassword] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const hash = new URLSearchParams(window.location.hash.replace('#', ''));
    return params.get('reset') === 'true' || hash.get('type') === 'recovery';
  });
  const [newPassword, setNewPassword] = useState("");



  const [betaAccess, setBetaAccess] = useState(true);
  // font scale handled via CSS
  // Font scale applied via CSS directly
  const [disclaimerAccepted, setDisclaimerAccepted] = useState(!!localStorage.getItem('pr_disclaimer'));
  const [show3amPrompt, setShow3amPrompt] = useState(() => {
    const hour = new Date().getHours();
    const isNight = hour >= 23 || hour < 4;
    const lastShown = localStorage.getItem('pr_3am_shown');
    const today = new Date().toDateString();
    return isNight && lastShown !== today;
  });
  const [appLang, setAppLang] = useState(localStorage.getItem('pr_lang') || 'en');
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    const font = localStorage.getItem('pr_font') || 'md';
    document.documentElement.style.setProperty('--pr-fs', font === 'sm' ? '0.85' : font === 'lg' ? '1.18' : '1');
    const root = document.getElementById('root'); if(root) root.style.zoom = font === 'sm' ? '0.88' : font === 'lg' ? '1.12' : '1';
  }, []);
  useEffect(() => {
    const font = localStorage.getItem('pr_font') || 'md';
    document.documentElement.style.setProperty('--pr-fs', font === 'sm' ? '0.85' : font === 'lg' ? '1.18' : '1');
  }, []);

  useEffect(() => {
    const font = localStorage.getItem('pr_font') || 'md';
    document.body.classList.remove('font-sm','font-md','font-lg');
    document.body.classList.add('font-' + font);
    document.documentElement.style.setProperty('--pr-font-scale', font === 'sm' ? '0.88' : font === 'lg' ? '1.14' : '1');
  }, []);
  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      const u = session?.user ?? null;
      if (u) {
        supabase.from('profiles').select('subscribed').eq('email', u.email).single().then(({ data }) => {
          u.subscribed = data?.subscribed ?? false;
          setUser({...u});
        });
      } else {
        setUser(null);
      }
      setAuthLoading(false);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange(async (authEvent, session) => {
      if (authEvent === "PASSWORD_RECOVERY") { setShowResetPassword(true); return; }
      setUser(session?.user ?? null);
      if (authEvent === 'SIGNED_IN' && !localStorage.getItem('pr_onboarded')) { setShowOnboarding(true); localStorage.setItem('pr_onboarded', '1'); }
    });
    return () => subscription.unsubscribe();
  }, []);

  const handleMoodSelect = (dest) => {
    setShowMood(false);
    setScreen(dest);
  };
  const handleMoodSkip = () => {
    setShowMood(false);
  };
  const screens = {
    lumiere: LumiereScreen,
    detente: DetenteScreen,
        settings: (props) => <SettingsScreen {...props} setAppLang={setAppLang} />,
    wall3am: Wall3am,
    letter: UnsentLetter,
    grief: GriefMode,
    sanctuary2: SanctuaryTwo,
    privacy: PrivacyScreen,
    terms: TermsScreen, home: HomeScreen, scripture: ScriptureScreen, journal: JournalScreen, ritual: RitualScreen, library: LibraryScreen, shop: ShopScreen, community: CommunityScreen };
  const Screen = screens[screen] || HomeScreen;
  const screenProps = { setScreen, user, appLang };
  if (!betaAccess) return <BetaGate onAccess={() => setBetaAccess(true)} key={appLang} />;
  if (user && !user.subscribed && !showResetPassword) return <StripePaywall user={user} onSignIn={async () => { await supabase.auth.signOut(); setScreen("login"); }} />;
  if (showOnboarding) return <OnboardingSlides onComplete={() => setShowOnboarding(false)} appLang={appLang} />;
  if (!disclaimerAccepted) return <DisclaimerScreen onAccept={() => setDisclaimerAccepted(true)} />;
  if (show3amPrompt) return <NightPrompt 
    onEnter={() => { 
      localStorage.setItem('pr_3am_shown', new Date().toDateString()); 
      setShow3amPrompt(false); 
      setScreen('wall3am');
    }} 
    onDismiss={() => { 
      localStorage.setItem('pr_3am_shown', new Date().toDateString()); 
      setShow3amPrompt(false); 
    }} 
  />;
  if (showResetPassword) {
    return (
      <div style={{ minHeight: "100vh", background: "#0A3A5C", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Jost', sans-serif" }}>
        <div style={{ background: "#F8F6F1", borderRadius: 4, padding: "44px 32px", width: 340, textAlign: "center", boxShadow: "0 20px 60px rgba(0,0,0,0.25)" }}>
          <p style={{ color: "#B8965A", fontSize: 11, letterSpacing: "0.3em", marginBottom: 14 }}>PURE RÊVE<sup style={{ fontSize: "0.55em", letterSpacing: 0, marginLeft: 2, verticalAlign: "super" }}>™</sup></p>
          <h2 style={{ color: "#3B2E22", fontFamily: "'Cormorant Garamond', serif", fontStyle: "italic", fontWeight: 400, fontSize: 30, lineHeight: 1.3, marginBottom: 28 }}>Set your new password.</h2>
          <input type="password" placeholder="New password" value={newPassword} onChange={e => setNewPassword(e.target.value)} style={{ width: "100%", padding: "16px", borderRadius: 2, border: "1px solid #D9CFC0", background: "#EDE5DA", color: "#3B2E22", fontFamily: "'Jost', sans-serif", fontSize: 14, boxSizing: "border-box", marginBottom: 16, outline: "none" }} />
          <button onClick={async () => {
            if (!newPassword || newPassword.length < 6) { alert("Password must be at least 6 characters."); return; }
            const { error } = await supabase.auth.updateUser({ password: newPassword });
            if (error) { alert(error.message); }
            else { await supabase.auth.signOut(); setShowResetPassword(false); window.history.replaceState({}, '', '/'); }
          }} style={{ width: "100%", padding: "16px", background: "#1A1511", color: "#F8F6F1", border: "none", borderRadius: 2, fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.25em", cursor: "pointer" }}>UPDATE PASSWORD</button>
          <button onClick={async () => { await supabase.auth.signOut(); setShowResetPassword(false); window.history.replaceState({}, '', '/'); }} style={{ marginTop: 16, background: "none", border: "none", color: "#8A7B6A", fontFamily: "'Jost', sans-serif", fontSize: 12, cursor: "pointer", textDecoration: "underline" }}>Cancel</button>
        </div>
      </div>
    );
  }
  if (authLoading) return (
    <div style={{ maxWidth: 430, margin: "0 auto", minHeight: "100vh", background: T.ivory, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <FontLoader />
      <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 44, color: "#B8A48C" }}>✦</span>
    </div>
  );
  if (!user) return (
    <div style={{ maxWidth: 430, margin: "0 auto", minHeight: "100vh", background: T.ivory }}>
      <FontLoader />
      <AuthScreen onAuth={setUser} />
    </div>
  );

  window.__prSetScreen = (s) => setScreen(s);
  return (
    <div key={appLang} style={{ maxWidth: 430, margin: "0 auto", minHeight: "100vh", background: T.ivory, position: "relative", boxShadow: "0 0 60px rgba(0,0,0,0.08)", fontFamily: "'Jost', sans-serif" }}>
      <FontLoader />
      {showMood && <MoodCheckIn onSelect={handleMoodSelect} onSkip={handleMoodSkip} />}
      <Screen {...screenProps} />
      <Nav screen={screen} setScreen={setScreen} />
      <div style={{ position: "fixed", top: 12, right: 16, zIndex: 50 }}>
        <button onClick={() => supabase.auth.signOut()} style={{ background: "none", border: "none", fontFamily: "Jost,sans-serif", fontSize: 13, letterSpacing: "0.14em", textTransform: "uppercase", color: "#A89880", cursor: "pointer", padding: "8px" }}>{TRANSLATIONS.en.signOutBtn}</button>
      </div>
    </div>
  );
}const DumpHistory = ({ user }) => {
  const [open, setOpen] = useState(false);
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    if (!user || !open) return;
    supabase.from('dump_history').select('*').eq('user_id', user.id).order('created_at', { ascending: false }).limit(90)
      .then(({ data }) => { if (data) setEntries(data); });
  }, [user, open]);

  if (!user) return null;

  return (
    <div style={{ marginTop: 20 }}>
      <button onClick={() => setOpen(!open)}
        style={{ background: "none", border: "none", fontFamily: "'Jost', sans-serif", fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", color: T.inkGhost, cursor: "pointer", padding: "8px 0", display: "flex", alignItems: "center", gap: 8 }}>
        <span>{open ? "−" : "+"}</span>
        <span>What I have overcome</span>
      </button>
      {open && entries.length === 0 && (
        <Serif size={13} italic color={T.inkGhost} style={{ display: "block", marginTop: 8 }}>Nothing saved yet. Use Release & Remember during your Digital Sunset.</Serif>
      )}
      {open && entries.length > 0 && (
        <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 8 }}>
          {entries.map((e, i) => (
            <div key={i} style={{ background: T.sand, borderRadius: 2, padding: "14px 18px", borderLeft: "2px solid " + T.sandDark }}>
              <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: "0.12em", textTransform: "uppercase", color: T.inkGhost, margin: "0 0 6px" }}>{e.date_str}</p>
              <Serif size={14} italic color={T.inkMid} style={{ display: "block", lineHeight: 1.65 }}>"{e.text}"</Serif>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
      
